/*!
 * 
 *
 * 	This file is auto generated by webpack.
 * 	Do not edit this file directly.
 *
 *
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 5160:
/***/ (function() {

window.globals = {
  manaScrollToElement: function manaScrollToElement(element, topPosition) {
    if ($(element).length > 0) {
      jQuery('html, body').animate({
        scrollTop: $(element).offset().top - topPosition
      }, 500);
      return false;
    }
  }
};

/***/ }),

/***/ 4020:
/***/ (function() {

window.sga = window.sga || {};
window.sga.manaSetCookie = function (name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};
window.sga.manaGetCookie = function (name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};
window.sga.manaEraseCookie = function (name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

/***/ }),

/***/ 7996:
/***/ (function() {

window.mana = window.mana || {};
window.mana.initTiles = function () {
  document.querySelectorAll(".tile-wrapper").forEach(function (wrapper) {
    var dark = wrapper.classList.contains("dark");
    var button = document.createElement("button");
    button.classList.add("tile-button");
    wrapper.appendChild(button);
    var panel = wrapper.querySelector(".tile-panel");
    var content = wrapper.querySelector(".tile-content");
    var closeButton = document.createElement("button");
    closeButton.classList.add("tile-close-button");
    panel.appendChild(closeButton);
    var scrim = document.createElement("div");
    scrim.classList.add("tile-scrim");
    content.appendChild(scrim);
    var closeIcon = document.createElement("div");
    closeIcon.classList.add("tile-close-icon");
    content.appendChild(closeIcon);
    var closeIconSvg = "<svg\n                            width=\"100%\"\n                            fill=\"currentColor\"\n                            className={className}\n                            height=\"100%\"\n                            viewBox=\"0 0 180 180\"\n                            version=\"1.1\"\n                            xmlns=\"http://www.w3.org/2000/svg\"\n                        >\n                            <g transform=\"matrix(1,0,0,1,-208.062,-198.999)\">\n                                <g transform=\"matrix(0.627015,0,0,0.627015,192.279,219.808)\">\n                                    <path d=\"M168.609,253.688C188.203,253.688 206.648,249.938 223.945,242.438C241.242,234.938 256.5,224.578 269.719,211.359C282.938,198.141 293.297,182.883 300.797,165.586C308.297,148.289 312.047,129.844 312.047,110.25C312.047,90.656 308.297,72.211 300.797,54.914C293.297,37.617 282.938,22.359 269.719,9.141C256.5,-4.078 241.219,-14.438 223.875,-21.938C206.531,-29.438 188.063,-33.188 168.469,-33.188C148.875,-33.188 130.43,-29.438 113.133,-21.938C95.836,-14.438 80.602,-4.078 67.43,9.141C54.258,22.359 43.922,37.617 36.422,54.914C28.922,72.211 25.172,90.656 25.172,110.25C25.172,129.844 28.922,148.289 36.422,165.586C43.922,182.883 54.281,198.141 67.5,211.359C80.719,224.578 95.977,234.938 113.273,242.438C130.57,249.938 149.016,253.688 168.609,253.688ZM100.828,110.391C100.828,106.734 102,103.758 104.344,101.461C106.688,99.164 109.688,98.016 113.344,98.016L156.375,98.016L156.375,54.984C156.375,51.328 157.477,48.328 159.68,45.984C161.883,43.641 164.766,42.469 168.328,42.469C171.984,42.469 174.961,43.641 177.258,45.984C179.555,48.328 180.703,51.328 180.703,54.984L180.703,98.016L223.875,98.016C227.438,98.016 230.391,99.164 232.734,101.461C235.078,103.758 236.25,106.734 236.25,110.391C236.25,113.953 235.078,116.836 232.734,119.039C230.391,121.242 227.438,122.344 223.875,122.344L180.703,122.344L180.703,165.516C180.703,169.172 179.555,172.148 177.258,174.445C174.961,176.742 171.984,177.891 168.328,177.891C164.766,177.891 161.883,176.719 159.68,174.375C157.477,172.031 156.375,169.078 156.375,165.516L156.375,122.344L113.344,122.344C109.688,122.344 106.688,121.242 104.344,119.039C102,116.836 100.828,113.953 100.828,110.391Z\" />\n                                </g>\n                            </g>\n                        </svg>";
    closeIcon.innerHTML = closeIconSvg;
    if (!(panel && content)) {
      throw new Error("Cannot query button,closeButton,panel or content element");
    }
    button.addEventListener("click", function (event) {
      event.preventDefault();
      document.querySelectorAll(".panel-show").forEach(function (el) {
        el.classList.remove("panel-show");
      });
      wrapper.classList.add("panel-show");
    });
    closeButton.addEventListener("click", function (event) {
      wrapper.classList.remove("panel-show");
    });
  });
};

/***/ }),

/***/ 5132:
/***/ (function() {

document.addEventListener('DOMContentLoaded', function () {
  var element = document.querySelector('.payment-methods');
  if (!element) return;
  var hmac = element.dataset.hmac;
  var timestamp = element.dataset.timestamp;
  var shop = element.dataset.shop;
  var customerEmail = element.dataset.customerEmail;
  var cardNumberEl = element.querySelector('.card-number');
  var cardExpirationEl = element.querySelector('.card-expiration');
  var cardProviderEl = element.querySelector('.card-provider');
  var queryParams = {
    customerEmail: encodeURIComponent(customerEmail),
    shop: shop,
    hmac: hmac,
    timestamp: timestamp
  };
  var baseUrl = 'https://us-central1-mana-backend-7041e.cloudfunctions.net/app';
  var endpoint = '/customerPaymentMethodList';
  var fullUrl = baseUrl + endpoint + '?' + new URLSearchParams(queryParams).toString();
  fetch(fullUrl).then(function (response) {
    return response.text();
  }).then(function (text) {
    return JSON.parse(text);
  }).then(function (data) {
    var cardData = data.data[0];
    if (cardData) {
      element.classList.remove('hidden', 'hidden-label');
      cardNumberEl.textContent = '•••• •••• •••• ' + cardData.lastDigits;
      cardExpirationEl.textContent = "".concat(cardData.cardExpirationMonth, "/").concat(cardData.cardExpirationYear);
      cardProviderEl.textContent = cardData.cardBrand;
    }
  }).catch(function (error) {
    return console.error('Error:', error);
  });
});

/***/ }),

/***/ 2012:
/***/ (function() {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
window.sga = window.sga || {};
var productPurchase = function () {
  function productPurchase() {
    var _this = this;
    _classCallCheck(this, productPurchase);
    this.quantitySelector = '.manaBuySection input[name="purchase_quantity"]';
    this.colorVariantSelector = '[data-variants] input[data-color-selector]';
    this.sizeVariantSelector = '[data-variants] input[data-size-selector]';
    this.colorSelector = '[data-color-option]';
    this.buySectionSelector = '.product-buy-section';
    this.purchaseTypeSelector = 'input[name="purchase_type"]';
    this.sellingPlansSelector = '.manaCartBody select[name="selling_plan"]';
    this.oneTimeSelector = '.manaCartBody select[name="onetime_package"]';
    this.manaBuySectionSelector = '.manaBuySection';
    this.manaStickySelector = '.manaTopSticky, .manaMobileSticky';
    this.manaStickyButtonSelector = '.manaTopSticky button.order, .manaMobileSticky button.order';
    this.manaPurchaseTypeButtonSelector = '.manaPurchaseTypeButton';
    this.optionInfoSelector = '.selected .option__info';
    this.optionNameSelector = '.selected .option__name, .bottom__informations .portions';
    this.optionShippingSelector = '.selected .option__freeShippingLabel';
    this.everySelector = '.bottom__informations .mainPrice .every';
    this.comparePriceSelector = '.bottom__informations .comparePrice';
    this.purchaseButtonSelector = '.add-purchase-button, [data-addProductToCart]';
    this.crosselProductActiveClass = 'productRecommendedKit__body--active';
    this.crosselProductActiveSelector = '.' + this.crosselProductActiveClass;
    this.crosselProductResumeSelector = '[data-crossells-resume]';
    this.oneTimeQuantitySelector = '.manaCartBody select[name="purchase_quantity"]';
    this.manaAddToOrderButtonSelector = '.manaAddToOrderButton';
    this.manaAddToOrderButtonActiveClass = 'manaAddToOrderButton--active';
    this.recommendedProductSelector = '[data-product-recommended-kit]';
    this.crossellProductSelector = '[data-product-crossell]';
    this.crossellProductVariantsSelector = '.productRecommendedKit__variants';
    this.crossellProductImageSelector = '.productRecommendedKit__body__image';
    this.flavorSelector = '[data-option-selector="flavor"]';
    this.quantityButtonSelector = '[data-quantity-select]';
    this.flavorQtySelector = '[data-flavor-quantity-selector]';
    this.servingsLabelSelector = '[data-buy-section-selector="servings"]';
    this.selectedServingsSelector = '.productOption--servings.productOption--selected';
    this.priceSelector = '[data-buy-section-selector="price"], .bottom__informations .mainPrice .price';
    this.unavailableMessageSelector = '.productOption__unavailable-message';
    this.subscriptionOnlyLabelSelector = '.subscription-only-label';
    this.onetimeOnlyLabelSelector = '.onetime-only-label';
    this.totalQuantity = 0;
    this.totalPrice = 0;
    this.isNewBuySection = window.sga.newBuySection;
    this.init();
    if (this.isNewBuySection === 'true') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          _this.initQtyInputs();
          _this.setPrices();
          _this.setDiscounts();
          _this.validateSubscriptionOnPageLoad();
        });
      } else {
        this.initQtyInputs();
        this.setPrices();
        this.setDiscounts();
        this.validateSubscriptionOnPageLoad();
      }
    }
  }
  _createClass(productPurchase, [{
    key: "getSelectedVariant",
    value: function getSelectedVariant(event) {
      event.target.checked = false;
      if (!event.target.checked) {
        event.target.checked = true;
      }
    }
  }, {
    key: "changeColor",
    value: function changeColor(event) {
      var colorSelector = event.target.closest('.color-selector');
      var selectedParent = colorSelector.closest('[data-product-variant-selector]');
      var jsonData = JSON.parse(selectedParent.querySelector('[data-product-json]').textContent);
      var colorOptions = colorSelector.querySelectorAll('input[type="radio"]');
      colorOptions.forEach(function (option) {
        option.classList.remove('is-selected');
      });
      if (!event.target.classList.contains('is-selected')) {
        event.target.classList.add('is-selected');
      }
      var selectedVariant = jsonData.variants.find(function (variant) {
        return variant.option1 === event.target.value;
      });
      selectedParent.querySelectorAll('.variant-price').forEach(function (price) {
        price.classList.add('hidden');
        var variantId = parseInt(price.getAttribute('data-variant-id'));
        if (variantId === selectedVariant.id) {
          price.classList.remove('hidden');
        }
      });
      selectedParent.querySelectorAll('.variant-image').forEach(function (image) {
        image.classList.add('hidden');
        var variantId = parseInt(image.getAttribute('data-variant-id'));
        if (variantId === selectedVariant.id) {
          image.classList.remove('hidden');
        }
      });
    }
  }, {
    key: "quickAddToCart",
    value: function () {
      var _quickAddToCart = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(event) {
        var variantId, selectedItem, selectedParent, jsonData, colorSelector, selectedColor, selectedVariant, _selectedVariant, item, items;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              selectedItem = event.target;
              selectedParent = selectedItem.closest('[data-product-variant-selector]');
              jsonData = JSON.parse(selectedParent.querySelector('[data-product-json]').textContent);
              colorSelector = selectedParent.querySelector('.color-selector');
              if (selectedItem.hasAttribute('data-one-time')) {
                if (colorSelector) {
                  selectedColor = colorSelector.querySelector('.is-selected');
                  selectedVariant = jsonData.variants.find(function (variant) {
                    return variant.option1 === selectedColor.value;
                  });
                  variantId = selectedVariant.id;
                } else {
                  variantId = selectedItem.getAttribute('data-variant');
                }
              } else {
                _selectedVariant = jsonData.variants.find(function (variant) {
                  if (colorSelector) {
                    var _selectedColor = colorSelector.querySelector('.is-selected');
                    return variant.option1 === _selectedColor.value && variant.option2 === selectedItem.value;
                  } else {
                    return variant.option1 === selectedItem.value;
                  }
                });
                variantId = _selectedVariant.id;
              }
              item = {
                id: variantId,
                quantity: 1
              };
              items = [];
              items.push(item);
              _context.next = 10;
              return window.shopifyFrontendHelper.addToCart(items);
            case 10:
              window.cartDrawerElement.toggleCart();
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function quickAddToCart(_x) {
        return _quickAddToCart.apply(this, arguments);
      }
      return quickAddToCart;
    }()
  }, {
    key: "getAvailableServingSizes",
    value: function getAvailableServingSizes() {
      var servingSizesFromJSON = this.getServingSizesFromProductJSON();
      if (servingSizesFromJSON.length > 0) {
        return servingSizesFromJSON;
      }
      var servingsElements = document.querySelectorAll('.productOption--servings');
      var servingSizes = Array.from(servingsElements).map(function (element) {
        return element.dataset.servings;
      }).filter(function (servings) {
        return servings && !isNaN(parseInt(servings));
      }).sort(function (a, b) {
        return parseInt(a) - parseInt(b);
      });
      return _toConsumableArray(new Set(servingSizes));
    }
  }, {
    key: "getServingSizesFromProductJSON",
    value: function getServingSizesFromProductJSON() {
      try {
        var productJsonElement = document.querySelector('#ProductJson');
        if (!productJsonElement) {
          console.warn('ProductJson element not found');
          return [];
        }
        var productJson = JSON.parse(productJsonElement.textContent);
        if (!productJson.products || !Array.isArray(productJson.products)) {
          console.warn('No products array found in ProductJson');
          return [];
        }
        var servingSizes = productJson.products.map(function (product) {
          return product.servings;
        }).filter(function (servings) {
          return servings && !isNaN(parseInt(servings));
        }).sort(function (a, b) {
          return parseInt(a) - parseInt(b);
        });
        return _toConsumableArray(new Set(servingSizes));
      } catch (error) {
        console.error('Error parsing ProductJson for serving sizes:', error);
        return [];
      }
    }
  }, {
    key: "getDefaultServingSize",
    value: function getDefaultServingSize() {
      var selectedServingsElement = document.querySelector(this.selectedServingsSelector);
      if (selectedServingsElement !== null && selectedServingsElement !== void 0 && selectedServingsElement.dataset.servings) {
        return selectedServingsElement.dataset.servings;
      }
      return this.getSmallestServingSize();
    }
  }, {
    key: "hasMultipleServingSizes",
    value: function hasMultipleServingSizes() {
      return this.getAvailableServingSizes().length > 1;
    }
  }, {
    key: "getServingSizeConfig",
    value: function getServingSizeConfig() {
      var availableSizes = this.getAvailableServingSizes();
      var defaultSize = this.getDefaultServingSize();
      return {
        availableSizes: availableSizes,
        defaultSize: defaultSize,
        hasMultipleSizes: availableSizes.length > 1,
        shouldShowSelector: availableSizes.length > 1
      };
    }
  }, {
    key: "getSmallestServingSize",
    value: function getSmallestServingSize() {
      var servingSizes = this.getAvailableServingSizes();
      return servingSizes.length > 0 ? servingSizes[0] : null;
    }
  }, {
    key: "getLargestServingSize",
    value: function getLargestServingSize() {
      var servingSizes = this.getAvailableServingSizes();
      return servingSizes.length > 0 ? servingSizes[servingSizes.length - 1] : null;
    }
  }, {
    key: "isValidServingSize",
    value: function isValidServingSize(servingSize) {
      return this.getAvailableServingSizes().includes(servingSize);
    }
  }, {
    key: "_setSizeSelectorPercentageOff",
    value: function _setSizeSelectorPercentageOff() {
      var smallestServing = this.getSmallestServingSize();
      var largestServing = this.getLargestServingSize();
      if (!smallestServing || !largestServing || smallestServing === largestServing) {
        return 0;
      }
      var formattedPricesSmall = this.getFormattedLowestPrice(smallestServing, true, 'subscription', true);
      var formattedPricesLarge = this.getFormattedLowestPrice(largestServing, true, 'subscription', true);
      if (!formattedPricesSmall || !formattedPricesLarge) {
        return 0;
      }
      var subscriptionPricePerServingSmall = formattedPricesSmall.subscriptionPricePerServing / 100;
      var subscriptionPricePerServingLarge = formattedPricesLarge.subscriptionPricePerServing / 100;
      var absolutePriceDifference = Math.abs(subscriptionPricePerServingLarge - subscriptionPricePerServingSmall);
      var averagePrice = (subscriptionPricePerServingLarge + subscriptionPricePerServingSmall) / 2;
      var discountRate = averagePrice > 0 ? Math.round(absolutePriceDifference / averagePrice * 100) : 0;
      return discountRate;
    }
  }, {
    key: "setDiscounts",
    value: function setDiscounts() {
      if (this.isNewBuySection !== 'true') return;
      var largeSizePercentageOffEl = document.querySelector('[data-buy-section-selector="servings-discount"]');
      if (largeSizePercentageOffEl) {
        var discountRate = this._setSizeSelectorPercentageOff();
        discountRate > 0 ? largeSizePercentageOffEl.textContent = discountRate : largeSizePercentageOffEl.closest('.sub-discount').classList.add('hidden');
      }
      var subscriptionWidgetPercentageOffEl = document.querySelector('[data-buy-section-selector="subscription-discount"]');
      if (subscriptionWidgetPercentageOffEl) {
        var _discountRate = document.querySelector(this.manaPurchaseTypeButtonSelector + '[data-type="subscription"]').dataset.discount;
        subscriptionWidgetPercentageOffEl.textContent = _discountRate;
      }
    }
  }, {
    key: "validateSubscriptionOnPageLoad",
    value: function validateSubscriptionOnPageLoad() {
      if (this.isNewBuySection !== 'true') return;
      try {
        var productJsonElement = document.querySelector('#ProductJson');
        if (!productJsonElement) return;
        var productJson = JSON.parse(productJsonElement.textContent);
        if (!productJson.products || !Array.isArray(productJson.products)) return;
        var allProductsAreOnetimeOnly = productJson.products.every(function (product) {
          return product.tags && Array.isArray(product.tags) && product.tags.includes('onetime');
        });
        var subscriptionPurchaseSelector = document.querySelector('.manaCartBody[data-type="subscription"]');
        if (allProductsAreOnetimeOnly) {
          this._toggleSubscriptionPurchase(subscriptionPurchaseSelector, false);
        } else {
          this._toggleSubscriptionPurchase(subscriptionPurchaseSelector, true);
        }
      } catch (error) {
        console.error('Error validating subscription on page load:', error);
      }
    }
  }, {
    key: "setPrices",
    value: function setPrices() {
      var _this2 = this;
      if (this.isNewBuySection !== 'true') return;
      var targetServings = this.getDefaultServingSize();
      if (!targetServings) {
        console.warn('❌ No serving sizes available for price calculation');
        return;
      }
      var subscriptionFormattedPrices = this.getFormattedLowestPrice(targetServings, true, 'subscription');
      var onetimeFormattedPrices = this.getFormattedLowestPrice(targetServings, true, 'onetime');
      var formattedPrices = subscriptionFormattedPrices || onetimeFormattedPrices;
      if (!formattedPrices) {
        console.warn("\u274C Could not get formatted prices for serving size: ".concat(targetServings));
        return;
      }
      var availableServingSizes = this.getAvailableServingSizes();
      var priceElements = document.querySelectorAll(this.priceSelector);
      var subscriptionPricesCache = {};
      var onetimePricesCache = {};
      availableServingSizes.forEach(function (servingSize) {
        var subscriptionPriceData = _this2.getFormattedLowestPrice(servingSize, true, 'subscription', true);
        if (subscriptionPriceData) {
          subscriptionPricesCache[servingSize] = subscriptionPriceData;
        }
        var onetimePriceData = _this2.getFormattedLowestPrice(servingSize, true, 'onetime');
        if (onetimePriceData) {
          onetimePricesCache[servingSize] = onetimePriceData;
        }
      });
      if (priceElements.length === 0) {
        console.warn('❌ No price elements found to update');
        return;
      }
      priceElements.forEach(function (priceElement, index) {
        var _subscriptionPricesCa, _subscriptionPricesCa2;
        var manaCartBody = priceElement.closest('.manaCartBody');
        var perPortionOption = priceElement.closest('.price-per-portion');
        var servingsOption = priceElement.closest('.productOption--servings');
        var caseMatched = false;
        var newPrice = null;
        switch (true) {
          case (manaCartBody === null || manaCartBody === void 0 ? void 0 : manaCartBody.dataset.type) === 'subscription':
            caseMatched = true;
            if (priceElement.hasAttribute('data-compare-price')) {
              newPrice = subscriptionFormattedPrices === null || subscriptionFormattedPrices === void 0 ? void 0 : subscriptionFormattedPrices.originalPriceFormatted;
              if (newPrice) priceElement.textContent = newPrice;
            } else {
              newPrice = subscriptionFormattedPrices === null || subscriptionFormattedPrices === void 0 ? void 0 : subscriptionFormattedPrices.subscriptionPriceFormatted;
              if (newPrice) {
                var finalPrice = subscriptionFormattedPrices !== null && subscriptionFormattedPrices !== void 0 && subscriptionFormattedPrices.priceVaries ? "".concat(theme.strings.from, " ").concat(newPrice) : newPrice;
                priceElement.textContent = finalPrice;
              }
            }
            break;
          case (manaCartBody === null || manaCartBody === void 0 ? void 0 : manaCartBody.dataset.type) === 'onetime':
            caseMatched = true;
            if (priceElement.hasAttribute('data-compare-price') && (onetimeFormattedPrices === null || onetimeFormattedPrices === void 0 ? void 0 : onetimeFormattedPrices.comparePriceFormatted) !== null) {
              newPrice = onetimeFormattedPrices.comparePriceFormatted;
              if (newPrice) priceElement.textContent = newPrice;
            } else {
              newPrice = onetimeFormattedPrices === null || onetimeFormattedPrices === void 0 ? void 0 : onetimeFormattedPrices.originalPriceFormatted;
              if (newPrice) {
                var _finalPrice = onetimeFormattedPrices !== null && onetimeFormattedPrices !== void 0 && onetimeFormattedPrices.priceVaries ? "".concat(theme.strings.from, " ").concat(newPrice) : newPrice;
                priceElement.textContent = _finalPrice;
              }
            }
            break;
          case priceElement.hasAttribute('data-per-portion'):
            caseMatched = true;
            var perPortionServings = perPortionOption.closest('.productOption--servings').dataset.servings;
            if ((_subscriptionPricesCa = subscriptionPricesCache[perPortionServings]) !== null && _subscriptionPricesCa !== void 0 && _subscriptionPricesCa.subscriptionPricePerServingFormatted) {
              newPrice = subscriptionPricesCache[perPortionServings].subscriptionPricePerServingFormatted;
              priceElement.textContent = newPrice;
            } else {
              console.log('   ❌ No cached subscription price for per-portion servings:', perPortionServings);
            }
            break;
          case priceElement.hasAttribute('data-total-price'):
            caseMatched = true;
            var optionServings = servingsOption.dataset.servings;
            if ((_subscriptionPricesCa2 = subscriptionPricesCache[optionServings]) !== null && _subscriptionPricesCa2 !== void 0 && _subscriptionPricesCa2.subscriptionPriceFormatted) {
              newPrice = subscriptionPricesCache[optionServings].subscriptionPriceFormatted;
              priceElement.textContent = newPrice;
            } else {
              console.log('   ❌ No cached subscription price for option servings:', optionServings);
              console.log('   📊 Available subscription cache keys:', Object.keys(subscriptionPricesCache));
            }
            break;
        }
        if (!caseMatched) {
          console.log('   ⚠️ No case matched for this price element');
        }
      });
    }
  }, {
    key: "_toggleSubscriptionPurchase",
    value: function _toggleSubscriptionPurchase(subscriptionPurchaseSelector, isEnabled) {
      if (!subscriptionPurchaseSelector) return;
      var inputElement = subscriptionPurchaseSelector.querySelector('input[name="purchase_type"]');
      var labelElement = subscriptionPurchaseSelector.querySelector('.manaPurchaseTypeButton');
      if (isEnabled) {
        subscriptionPurchaseSelector.classList.remove('disabled');
        if (labelElement) labelElement.classList.remove('disabled');
        if (inputElement) {
          inputElement.removeAttribute('disabled');
          inputElement.disabled = false;
        }
      } else {
        subscriptionPurchaseSelector.classList.add('disabled');
        if (labelElement) labelElement.classList.add('disabled');
        if (inputElement) {
          inputElement.setAttribute('disabled', 'disabled');
          inputElement.disabled = true;
        }
      }
    }
  }, {
    key: "updatePricesOnQuantityChange",
    value: function updatePricesOnQuantityChange(event) {
      try {
        var changedFlavorSelector = event.target;
        var productJsonElement = document.querySelector('#ProductJson');
        var selectedServingsOption = document.querySelector(this.selectedServingsSelector);
        var selectedServings = selectedServingsOption ? selectedServingsOption.dataset.servings : this.getDefaultServingSize();
        var productJson = JSON.parse(productJsonElement.textContent);
        var subscriptionPurchaseSelector = document.querySelector('.manaCartBody[data-type="subscription"]');
        var onetimePurchaseSelector = document.querySelector('.manaCartBody[data-type="onetime"]');
        if (!selectedServings) {
          console.warn('No serving size available for price calculation');
          this.setPrices();
          return;
        }
        var allActiveFlavorSelectors = document.querySelectorAll(this.flavorQtySelector + '.--active ' + this.flavorSelector);
        if (allActiveFlavorSelectors.length === 0) {
          this.validateSubscriptionOnPageLoad();
          this.setPrices();
          return;
        }
        this._validateChangedFlavorSubscription(changedFlavorSelector, productJson, selectedServings, subscriptionPurchaseSelector, allActiveFlavorSelectors);
        var totals = this._calculateTotalPrices(allActiveFlavorSelectors, productJson, selectedServings, subscriptionPurchaseSelector);
        this._updatePriceDisplay(onetimePurchaseSelector, subscriptionPurchaseSelector, totals);
      } catch (error) {
        console.error('Error updating prices on quantity change:', error);
      }
    }
  }, {
    key: "_validateChangedFlavorSubscription",
    value: function _validateChangedFlavorSubscription(changedFlavorSelector, productJson, selectedServings, subscriptionPurchaseSelector, allActiveFlavorSelectors) {
      if (!subscriptionPurchaseSelector) return;
      var sellingPlanOption = subscriptionPurchaseSelector.querySelector('option:checked');
      if (!sellingPlanOption) return;
      var sellingPlanId = parseInt(sellingPlanOption.value);
      var hasAnyFlavorWithoutSubscription = false;
      var hasAnyOnetimeOnlyProduct = false;
      allActiveFlavorSelectors.forEach(function (flavorSelector) {
        var qtyOfFlavor = parseInt(flavorSelector.value) || 0;
        if (qtyOfFlavor === 0) return;
        var matchingProduct = productJson.products.find(function (product) {
          return product.servings === selectedServings && product.flavor === flavorSelector.dataset.flavor;
        });
        if (!matchingProduct) return;
        if (matchingProduct.tags && Array.isArray(matchingProduct.tags)) {
          if (matchingProduct.tags.includes('onetime')) {
            hasAnyOnetimeOnlyProduct = true;
          }
        }
        var matchingProductVariant = matchingProduct.variants[0];
        if (!matchingProductVariant) return;
        var variantHasSubscription = matchingProductVariant.selling_plan_allocations && matchingProductVariant.selling_plan_allocations.find(function (allocation) {
          return allocation.selling_plan_id === sellingPlanId;
        });
        if (!variantHasSubscription) {
          hasAnyFlavorWithoutSubscription = true;
        }
      });
      if (hasAnyOnetimeOnlyProduct || hasAnyFlavorWithoutSubscription) {
        this._toggleSubscriptionPurchase(subscriptionPurchaseSelector, false);
      } else {
        this._toggleSubscriptionPurchase(subscriptionPurchaseSelector, true);
      }
    }
  }, {
    key: "_calculateTotalPrices",
    value: function _calculateTotalPrices(flavorSelectors, productJson, selectedServings, subscriptionPurchaseSelector) {
      var totalOriginalPrice = 0;
      var totalSubscriptionPrice = 0;
      var totalComparePrice = 0;
      var sellingPlanId = parseInt(subscriptionPurchaseSelector.querySelector('option:checked').value);
      flavorSelectors.forEach(function (flavorSelector) {
        var qtyOfFlavor = parseInt(flavorSelector.value) || 0;
        var matchingProduct = productJson.products.find(function (product) {
          return product.servings === selectedServings && product.flavor === flavorSelector.dataset.flavor;
        });
        if (!matchingProduct) return;
        var matchingProductVariant = matchingProduct.variants[0];
        var originalPrice = matchingProductVariant.price;
        var comparePrice = matchingProductVariant.compare_at_price || null;
        var variantHasSubscription = matchingProductVariant.selling_plan_allocations.find(function (allocation) {
          return allocation.selling_plan_id === sellingPlanId;
        });
        var subscriptionPriceTotal = variantHasSubscription ? variantHasSubscription.price * qtyOfFlavor : 0;
        var oneTimePriceTotal = originalPrice * qtyOfFlavor;
        var comparePriceTotal = comparePrice ? comparePrice * qtyOfFlavor : 0;
        if (flavorSelector.dataset.progressionRuleDiscount && qtyOfFlavor >= 2) {
          var discountedValue = parseInt(flavorSelector.dataset.progressionRuleDiscount) || 0;
          if (discountedValue > 0) {
            var discountAmount = discountedValue * (qtyOfFlavor - 1);
            oneTimePriceTotal -= discountAmount;
            comparePriceTotal -= discountAmount;
          }
        }
        totalOriginalPrice += oneTimePriceTotal;
        totalSubscriptionPrice += subscriptionPriceTotal;
        totalComparePrice += comparePriceTotal;
      });
      return {
        totalOriginalPrice: totalOriginalPrice,
        totalSubscriptionPrice: totalSubscriptionPrice,
        totalComparePrice: totalComparePrice
      };
    }
  }, {
    key: "_updatePriceDisplay",
    value: function _updatePriceDisplay(onetimePurchaseSelector, subscriptionPurchaseSelector, totals) {
      var _this3 = this;
      var totalOriginalPrice = totals.totalOriginalPrice,
        totalSubscriptionPrice = totals.totalSubscriptionPrice,
        totalComparePrice = totals.totalComparePrice;
      var moneyFormat = theme.strings.moneyFormat || '{{ amount }}';
      onetimePurchaseSelector.querySelectorAll(this.priceSelector).forEach(function (priceElement) {
        if (priceElement.hasAttribute('data-compare-price')) {
          priceElement.classList.remove('hidden');
          if (totalComparePrice > totalOriginalPrice) {
            priceElement.textContent = moneyFormat.includes('amount_with_space_separator') ? _this3._formatMoneyFallback(totalComparePrice, moneyFormat) : Shopify.formatMoney(totalComparePrice, moneyFormat);
          } else {
            priceElement.classList.add('hidden');
          }
        } else {
          priceElement.textContent = moneyFormat.includes('amount_with_space_separator') ? _this3._formatMoneyFallback(totalOriginalPrice, moneyFormat) : Shopify.formatMoney(totalOriginalPrice, moneyFormat);
        }
      });
      subscriptionPurchaseSelector.querySelectorAll(this.priceSelector).forEach(function (priceElement) {
        if (priceElement.hasAttribute('data-compare-price')) {
          priceElement.textContent = moneyFormat.includes('amount_with_space_separator') ? _this3._formatMoneyFallback(totalOriginalPrice, moneyFormat) : Shopify.formatMoney(totalOriginalPrice, moneyFormat);
        } else {
          priceElement.textContent = moneyFormat.includes('amount_with_space_separator') ? _this3._formatMoneyFallback(totalSubscriptionPrice, moneyFormat) : Shopify.formatMoney(totalSubscriptionPrice, moneyFormat);
        }
      });
    }
  }, {
    key: "getLowestVariantPrice",
    value: function getLowestVariantPrice(servings) {
      var purchaseType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var processAllVariants = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      try {
        if (!purchaseType) {
          var activePurchaseButton = document.querySelector(this.manaPurchaseTypeButtonSelector + '[data-active]');
          purchaseType = (activePurchaseButton === null || activePurchaseButton === void 0 ? void 0 : activePurchaseButton.dataset.type) || 'onetime';
        }
        var productJsonElement = document.querySelector('#ProductJson');
        if (!productJsonElement) {
          console.error('ProductJson element not found');
          return null;
        }
        var productJson = JSON.parse(productJsonElement.innerHTML);
        var matchingProducts = productJson.products.filter(function (product) {
          return product.servings === servings;
        });
        if (!matchingProducts || matchingProducts.length === 0) {
          console.warn("No products found with servings: ".concat(servings));
          return null;
        }
        if (purchaseType === 'subscription') {
          return this._findLowestSubscriptionPrice(matchingProducts, processAllVariants);
        } else {
          return this._findLowestOnetimePrice(matchingProducts);
        }
      } catch (error) {
        console.error('Error parsing product JSON or finding lowest price:', error);
        return null;
      }
    }
  }, {
    key: "_findLowestSubscriptionPrice",
    value: function _findLowestSubscriptionPrice(matchingProducts) {
      var _selectedVariant2;
      var processAllVariants = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var subscriptionPurchaseSelector = document.querySelector('.manaCartBody[data-type="subscription"]');
      if (!subscriptionPurchaseSelector) {
        console.warn('No subscription purchase selector found');
        return null;
      }
      var selectedOption = subscriptionPurchaseSelector.querySelector('option:checked');
      if (!selectedOption) {
        console.warn('No subscription selling plan selected');
        return null;
      }
      var targetSellingPlanId = parseInt(selectedOption.value);
      var lowestSubscriptionPrice = Infinity;
      var productWithLowestSubscription = null;
      var selectedVariant = null;
      var uniquePrices = new Set();
      matchingProducts.forEach(function (product) {
        product.variants.forEach(function (variant) {
          if (!variant.selling_plan_allocations || !Array.isArray(variant.selling_plan_allocations)) {
            return;
          }
          var subscriptionAllocation = variant.selling_plan_allocations.find(function (allocation) {
            return allocation.selling_plan_id === targetSellingPlanId;
          });
          if (!processAllVariants) {
            if (!subscriptionAllocation) {
              return;
            }
            if (!subscriptionAllocation.price_adjustments || !Array.isArray(subscriptionAllocation.price_adjustments)) {
              return;
            }
          }
          if (subscriptionAllocation) {
            subscriptionAllocation.price_adjustments.forEach(function (adjustment) {
              if (adjustment.price) {
                uniquePrices.add(adjustment.price);
                if (adjustment.price < lowestSubscriptionPrice) {
                  lowestSubscriptionPrice = adjustment.price;
                  productWithLowestSubscription = product;
                  selectedVariant = variant;
                }
              }
            });
          } else if (processAllVariants) {
            if (variant.price) {
              var sellingPlanAllocations = variant.selling_plan_allocations || [];
              var lowestAdjustmentPrice = variant.price;
              sellingPlanAllocations.forEach(function (allocation) {
                var priceAdjustments = allocation.price_adjustments || [];
                priceAdjustments.forEach(function (adjustment) {
                  if (adjustment.price < lowestAdjustmentPrice) {
                    lowestAdjustmentPrice = adjustment.price;
                  }
                });
              });
              if (lowestAdjustmentPrice < lowestSubscriptionPrice) {
                uniquePrices.add(lowestAdjustmentPrice);
                lowestSubscriptionPrice = lowestAdjustmentPrice;
                productWithLowestSubscription = product;
                selectedVariant = variant;
              }
            }
          }
        });
      });
      var priceVaries = uniquePrices.size > 1;
      if (lowestSubscriptionPrice === Infinity) {
        var _matchingProducts$, _fallbackVariant$sell;
        console.warn("No subscription prices found for selling plan ID: ".concat(targetSellingPlanId));
        var fallbackVariant = ((_matchingProducts$ = matchingProducts[0]) === null || _matchingProducts$ === void 0 ? void 0 : _matchingProducts$.variants[0]) || null;
        return {
          originalPrice: (fallbackVariant === null || fallbackVariant === void 0 ? void 0 : fallbackVariant.price) || null,
          subscriptionPrice: (fallbackVariant === null || fallbackVariant === void 0 || (_fallbackVariant$sell = fallbackVariant.selling_plan_allocations[0]) === null || _fallbackVariant$sell === void 0 ? void 0 : _fallbackVariant$sell.price) || null,
          product: matchingProducts[0] || null,
          variant: fallbackVariant,
          matchingProductsCount: matchingProducts.length,
          priceVaries: false
        };
      }
      return {
        originalPrice: ((_selectedVariant2 = selectedVariant) === null || _selectedVariant2 === void 0 ? void 0 : _selectedVariant2.price) || null,
        subscriptionPrice: lowestSubscriptionPrice,
        product: productWithLowestSubscription,
        variant: selectedVariant,
        matchingProductsCount: matchingProducts.length,
        priceVaries: priceVaries
      };
    }
  }, {
    key: "_findLowestOnetimePrice",
    value: function _findLowestOnetimePrice(matchingProducts) {
      var lowestOriginalPrice = Infinity;
      var productWithLowestOriginal = null;
      var selectedVariant = null;
      var uniquePrices = new Set();
      matchingProducts.forEach(function (product) {
        product.variants.forEach(function (variant) {
          var originalPrice = variant.price;
          if (originalPrice) {
            uniquePrices.add(originalPrice);
            if (originalPrice < lowestOriginalPrice) {
              lowestOriginalPrice = originalPrice;
              productWithLowestOriginal = product;
              selectedVariant = variant;
            }
          }
        });
      });
      if (lowestOriginalPrice === Infinity) {
        console.warn('No original prices found for these products');
        return null;
      }
      var priceVaries = uniquePrices.size > 1;
      return {
        originalPrice: lowestOriginalPrice,
        subscriptionPrice: null,
        product: productWithLowestOriginal,
        variant: selectedVariant,
        matchingProductsCount: matchingProducts.length,
        priceVaries: priceVaries
      };
    }
  }, {
    key: "getFormattedLowestPrice",
    value: function getFormattedLowestPrice(servings) {
      var _priceData$variant,
        _this4 = this;
      var formatMoney = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var purchaseType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var processAllVariants = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var priceData = this.getLowestVariantPrice(servings, purchaseType, processAllVariants);
      if (!priceData) {
        return null;
      }
      var result = {
        servings: servings,
        flavor: priceData.product.flavor,
        originalPrice: priceData.originalPrice,
        originalPricePerServing: priceData.originalPrice ? priceData.originalPrice / servings : null,
        subscriptionPrice: priceData.subscriptionPrice,
        subscriptionPricePerServing: priceData.subscriptionPrice ? priceData.subscriptionPrice / servings : null,
        savings: null,
        comparePrice: ((_priceData$variant = priceData.variant) === null || _priceData$variant === void 0 ? void 0 : _priceData$variant.compare_at_price) || null,
        priceVaries: priceData.priceVaries || false
      };
      if (priceData.originalPrice && priceData.subscriptionPrice) {
        result.savings = priceData.originalPrice - priceData.subscriptionPrice;
      }
      if (formatMoney) {
        var _theme;
        var moneyFormat = '${{amount}}';
        if ((_theme = theme) !== null && _theme !== void 0 && (_theme = _theme.strings) !== null && _theme !== void 0 && _theme.moneyFormat) {
          moneyFormat = theme.strings.moneyFormat;
        } else if (typeof Shopify !== 'undefined' && Shopify.money_format) {
          moneyFormat = Shopify.money_format;
        } else if (window.shop && window.shop.money_format) {
          moneyFormat = window.shop.money_format;
        }
        var formatPrice = function formatPrice(price) {
          if (moneyFormat.includes('amount_with_space_separator')) {
            return _this4._formatMoneyFallback(price, moneyFormat);
          }
          if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            return Shopify.formatMoney(price, moneyFormat);
          }
          if (typeof window.themeCurrency !== 'undefined' && window.themeCurrency.formatMoney) {
            return window.themeCurrency.formatMoney(price, moneyFormat);
          }
          return _this4._formatMoneyFallback(price, moneyFormat);
        };
        if (result.originalPrice) {
          result.originalPriceFormatted = formatPrice(result.originalPrice);
          result.originalPricePerServingFormatted = formatPrice(result.originalPrice / servings);
        }
        if (result.subscriptionPrice) {
          result.subscriptionPriceFormatted = formatPrice(result.subscriptionPrice);
          result.subscriptionPricePerServingFormatted = formatPrice(result.subscriptionPrice / servings);
        }
        if (result.savings) {
          result.savingsFormatted = formatPrice(result.savings);
        }
        if (result.comparePrice) {
          result.comparePriceFormatted = formatPrice(result.comparePrice);
        }
      }
      return result;
    }
  }, {
    key: "updateServingsLabels",
    value: function updateServingsLabels() {
      var _this5 = this;
      var servingsLabels = document.querySelectorAll(this.servingsLabelSelector);
      servingsLabels.forEach(function (label) {
        var initialServings = parseInt(label.dataset.servings) || 1;
        if (_this5.totalQuantity > 0) {
          label.textContent = initialServings * _this5.totalQuantity;
        } else {
          label.textContent = initialServings;
        }
      });
    }
  }, {
    key: "onQuantityChange",
    value: function onQuantityChange(event) {
      if (event.detail.buttonType === 'plus') {
        this.totalQuantity++;
      } else if (event.detail.buttonType === 'minus') {
        this.totalQuantity--;
      }
      var quantityInput = event.target.closest(this.flavorQtySelector);
      if (event.target.value >= 1 && !quantityInput.classList.contains('--active')) {
        quantityInput.classList.add('--active');
      } else if (event.target.value < 1 && quantityInput.classList.contains('--active')) {
        quantityInput.classList.remove('--active');
      }
      this.updateServingsLabels();
      this.toggleAtcBtnState();
      this.changeProductSticky();
      this.updatePricesOnQuantityChange(event);
    }
  }, {
    key: "toggleAtcBtnState",
    value: function toggleAtcBtnState() {
      var _this6 = this;
      var atcBtns = document.querySelectorAll(this.purchaseButtonSelector);
      atcBtns.forEach(function (atcBtn) {
        if (_this6.totalQuantity > 0) {
          atcBtn.removeAttribute('data-disabled');
          atcBtn.closest(_this6.manaBuySectionSelector + '[data-type="subscription"]') ? atcBtn.textContent = theme.strings.subscribe : atcBtn.textContent = theme.strings.addToCart;
        } else {
          atcBtn.setAttribute('data-disabled', 'true');
          atcBtn.textContent = theme.strings.selectProducts;
        }
      });
    }
  }, {
    key: "resetTotalQuantity",
    value: function resetTotalQuantity() {
      this.totalQuantity = 0;
      this.toggleAtcBtnState();
      this.updateServingsLabels();
    }
  }, {
    key: "resetFlavorSelectors",
    value: function resetFlavorSelectors() {
      var _this7 = this;
      var flavorSelectors = document.querySelectorAll(this.flavorQtySelector + '.--active');
      flavorSelectors.forEach(function (selector) {
        selector.classList.remove('--active');
        selector.querySelector(_this7.flavorSelector).value = 0;
      });
    }
  }, {
    key: "addToCart",
    value: function () {
      var _addToCart = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2(event) {
        var button, buySection, items, productAddedEvent;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              button = event.target;
              if (!button.hasAttribute('data-disabled')) {
                _context2.next = 4;
                break;
              }
              window.globals.manaScrollToElement(this.buySectionSelector, 250);
              return _context2.abrupt("return");
            case 4:
              button.classList.add('data-processing');
              buySection = button.closest(this.buySectionSelector);
              _context2.prev = 6;
              if (!(this.isNewBuySection === 'true')) {
                _context2.next = 13;
                break;
              }
              _context2.next = 10;
              return this._getNewBuySectionItems(buySection);
            case 10:
              _context2.t0 = _context2.sent;
              _context2.next = 16;
              break;
            case 13:
              _context2.next = 15;
              return this._getLegacyCartItems(button, buySection);
            case 15:
              _context2.t0 = _context2.sent;
            case 16:
              items = _context2.t0;
              if (!(items.length === 0)) {
                _context2.next = 20;
                break;
              }
              console.warn('No valid items to add to cart');
              return _context2.abrupt("return");
            case 20:
              _context2.next = 22;
              return window.shopifyFrontendHelper.addToCart(items);
            case 22:
              if (this.isNewBuySection === 'true') {
                this.resetFlavorSelectors();
              }
              productAddedEvent = new Event('product:added');
              document.dispatchEvent(productAddedEvent);
              this._handlePostCartActions(button);
              _context2.next = 31;
              break;
            case 28:
              _context2.prev = 28;
              _context2.t1 = _context2["catch"](6);
              console.error('Error adding to cart:', _context2.t1);
            case 31:
              _context2.prev = 31;
              button.classList.remove('data-processing');
              return _context2.finish(31);
            case 34:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[6, 28, 31, 34]]);
      }));
      function addToCart(_x2) {
        return _addToCart.apply(this, arguments);
      }
      return addToCart;
    }()
  }, {
    key: "_getNewBuySectionItems",
    value: function () {
      var _getNewBuySectionItems2 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3(buySection) {
        var _buySection$querySele,
          _this8 = this;
        var items, productJson, selectedServingSize, flavorSelectors;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              items = [];
              productJson = JSON.parse(buySection.querySelector('#ProductJson').innerHTML);
              selectedServingSize = ((_buySection$querySele = buySection.querySelector('.productOption--servings.productOption--selected')) === null || _buySection$querySele === void 0 ? void 0 : _buySection$querySele.dataset.servings) || this.getDefaultServingSize();
              if (selectedServingSize) {
                _context3.next = 6;
                break;
              }
              console.warn('No serving size available for cart items');
              return _context3.abrupt("return", items);
            case 6:
              flavorSelectors = buySection.querySelectorAll(this.flavorQtySelector + '.--active' + ' ' + this.flavorSelector);
              flavorSelectors.forEach(function (flavorSelector) {
                var qty = parseInt(flavorSelector.value);
                var flavorName = flavorSelector.dataset.flavor;
                var selectedProduct = productJson.products.find(function (product) {
                  return product.flavor === flavorName && product.servings === selectedServingSize;
                });
                if (selectedProduct && selectedProduct.variants && selectedProduct.variants.length > 0 && qty > 0) {
                  var selectedVariant = selectedProduct.variants[0];
                  var item = _this8._createCartItem(selectedVariant.id, qty, buySection);
                  items.push(item);
                } else {
                  console.warn('Could not find product or variant for flavor:', flavorName, 'servings:', selectedServingSize);
                }
              });
              this._addCrosellItems(buySection, items, 1);
              return _context3.abrupt("return", items);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _getNewBuySectionItems(_x3) {
        return _getNewBuySectionItems2.apply(this, arguments);
      }
      return _getNewBuySectionItems;
    }()
  }, {
    key: "_getLegacyCartItems",
    value: function () {
      var _getLegacyCartItems2 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee4(button, buySection) {
        var items, variantId, quantity, sellingPlan, item, quantityFromButton;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              items = [];
              variantId = this._determineVariantId(button);
              if (variantId) {
                _context4.next = 5;
                break;
              }
              console.log("Variant is missing.");
              return _context4.abrupt("return", items);
            case 5:
              quantity = 1;
              if (buySection) {
                quantity = this._getQuantityFromBuySection(buySection);
              }
              sellingPlan = this._getSellingPlanFromButton(button, variantId);
              item = this._createCartItem(variantId, quantity, buySection, sellingPlan);
              quantityFromButton = button.getAttribute('data-quantity');
              if (quantityFromButton) {
                item.quantity = quantityFromButton;
              }
              items.push(item);
              if (buySection) {
                this._addCrosellItems(buySection, items, quantity);
              }
              return _context4.abrupt("return", items);
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function _getLegacyCartItems(_x4, _x5) {
        return _getLegacyCartItems2.apply(this, arguments);
      }
      return _getLegacyCartItems;
    }()
  }, {
    key: "_createCartItem",
    value: function _createCartItem(variantId, quantity, buySection) {
      var sellingPlan = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var item = {
        id: variantId,
        quantity: quantity,
        properties: {}
      };
      var purchase = 'onetime';
      if (buySection) {
        var purchaseElement = buySection.querySelector(this.purchaseTypeSelector + ':checked');
        if (purchaseElement) {
          purchase = purchaseElement.value;
        }
        if (purchase === 'subscription' && !sellingPlan) {
          sellingPlan = buySection.querySelector(this.sellingPlansSelector).value;
        }
      }
      if (sellingPlan) {
        item["selling_plan"] = sellingPlan;
        item["properties"]["_subscription"] = true;
      }
      if (manaProductsProperties[variantId] !== undefined) {
        if (!sellingPlan) {
          if (manaProductsProperties[variantId].discount) {
            item["properties"]["_discount_per_one"] = manaProductsProperties[variantId].discount;
            item["properties"]["_hmac"] = manaProductsProperties[variantId].hmac;
            item["properties"]["_timestamp"] = manaProductsProperties[variantId].timestamp;
          }
          item["properties"]["_subscription"] = false;
        }
      }
      return item;
    }
  }, {
    key: "_determineVariantId",
    value: function _determineVariantId(button) {
      var variantId = button.getAttribute('data-variant');
      if (!variantId) {
        var _button$closest;
        variantId = (_button$closest = button.closest('button')) === null || _button$closest === void 0 ? void 0 : _button$closest.getAttribute('data-variant');
      }
      var colorVariant = document.querySelector(this.colorVariantSelector + ':checked');
      var sizeVariant = document.querySelector(this.sizeVariantSelector + ':checked');
      if (colorVariant || sizeVariant) {
        var productData = JSON.parse(document.querySelector('#ProductJson').innerHTML);
        productData.variants.forEach(function (variant) {
          if (colorVariant && sizeVariant) {
            if (variant.option1 === colorVariant.value && variant.option2 === sizeVariant.value) {
              variantId = variant.id;
            }
          } else if (colorVariant) {
            if (variant.option1 === colorVariant.value) {
              variantId = variant.id;
            }
          } else if (sizeVariant) {
            if (variant.option1 === sizeVariant.value) {
              variantId = variant.id;
            }
          }
        });
      }
      return variantId;
    }
  }, {
    key: "_getQuantityFromBuySection",
    value: function _getQuantityFromBuySection(buySection) {
      var purchaseElement = buySection.querySelector(this.purchaseTypeSelector + ':checked');
      var purchase = (purchaseElement === null || purchaseElement === void 0 ? void 0 : purchaseElement.value) || 'onetime';
      if (purchase === 'onetime') {
        if (buySection.querySelector(this.oneTimeSelector)) {
          return buySection.querySelector(this.oneTimeSelector).value;
        } else if (buySection.querySelector(this.oneTimeQuantitySelector)) {
          return buySection.querySelector(this.oneTimeQuantitySelector).value;
        } else if (document.querySelector(this.quantitySelector)) {
          return document.querySelector(this.quantitySelector).value;
        }
      }
      return 1;
    }
  }, {
    key: "_getSellingPlanFromButton",
    value: function _getSellingPlanFromButton(button, variantId) {
      var sellingPlanAttr = button.getAttribute('data-sellingPlan');
      if (sellingPlanAttr !== null) {
        if (sellingPlanAttr === 'true') {
          if (manaProductsProperties[variantId] !== undefined && manaProductsProperties[variantId].sellingPlans.length) {
            return manaProductsProperties[variantId].sellingPlans[0];
          }
        } else {
          return sellingPlanAttr;
        }
      }
      return null;
    }
  }, {
    key: "_addCrosellItems",
    value: function _addCrosellItems(buySection, items, quantity) {
      buySection.querySelectorAll(this.crosselProductActiveSelector).forEach(function (crossell) {
        var crosselId = crossell.getAttribute('data-variant-id');
        var item = {
          id: crosselId,
          quantity: quantity
        };
        items.push(item);
      });
    }
  }, {
    key: "_handlePostCartActions",
    value: function _handlePostCartActions(button) {
      var thankYouText = button.getAttribute('data-thankYouText');
      if (thankYouText) {
        button.textContent = thankYouText;
      }
      if (!button.getAttribute('data-dontOpenCart')) {
        window.cartDrawerElement.toggleCart();
      }
      var finishFunction = button.getAttribute('data-callFinishFunction');
      if (finishFunction && typeof window[finishFunction] === 'function') {
        window[finishFunction]();
      }
      if (this.isNewBuySection === 'true') {
        var subscriptionPurchaseSelector = document.querySelector('.manaCartBody[data-type="subscription"]');
        this.resetTotalQuantity();
        this.setPrices();
        this.setDiscounts();
        this._toggleSubscriptionPurchase(subscriptionPurchaseSelector, true);
      }
    }
  }, {
    key: "crossellsProductsResume",
    value: function crossellsProductsResume() {
      var products = document.querySelectorAll(this.crosselProductActiveSelector);
      var resumes = document.querySelectorAll(this.crosselProductResumeSelector);
      var quantity = 1;
      var buySection = document.querySelector(this.buySectionSelector);
      if (buySection) {
        var purchaseElement = buySection.querySelector(this.purchaseTypeSelector + ':checked');
        if (purchaseElement) {
          purchase = purchaseElement.value;
        }
        if (purchase === 'onetime') {
          if (buySection.querySelector(this.oneTimeSelector)) {
            quantity = buySection.querySelector(this.oneTimeSelector).value;
          } else if (buySection.querySelector(this.oneTimeQuantitySelector)) {
            quantity = buySection.querySelector(this.oneTimeQuantitySelector).value;
          }
        }
      }
      var html = '';
      if (products.length) {
        var _iterator = _createForOfIteratorHelper(products),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            product = _step.value;
            var name = product.getAttribute('data-name');
            if (quantity > 1) {
              name = quantity + '× ' + name;
            }
            var price = product.getAttribute('data-price');
            html += "<div class=\"crossel-row\">\n                                        <div class=\"name\">+ ".concat(name, "</div>\n                                        <div class=\"price\">").concat(price, "</div>\n                                    </div>");
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      var _iterator2 = _createForOfIteratorHelper(resumes),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var resume = _step2.value;
          resume.innerHTML = html;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "changeActivePurchase",
    value: function changeActivePurchase() {
      var _this9 = this;
      var purchase = document.querySelector(this.purchaseTypeSelector + ':checked').value;
      document.querySelectorAll(this.manaBuySectionSelector).forEach(function (section) {
        var active = null;
        if (section.getAttribute('data-type') === purchase) {
          active = true;
        }
        section.setAttribute('data-active', active);
        if (!active) {
          section.removeAttribute('data-active');
        }
      });
      document.querySelectorAll(this.manaPurchaseTypeButtonSelector).forEach(function (button) {
        var active = null;
        if (button.getAttribute('data-type') === purchase) {
          active = true;
        }
        button.setAttribute('data-active', active);
        if (!active) {
          button.removeAttribute('data-active');
        }
      });
      document.querySelectorAll(this.flavorSelector).forEach(function (flavor) {
        var flavorPrices = flavor.closest('.productOption--flavor').querySelectorAll('[data-flavor-price]');
        flavorPrices.forEach(function (price) {
          price.getAttribute('data-buy-section-selector') !== "".concat(purchase, "-price") ? price.classList.add('display-none') : price.classList.remove('display-none');
        });
        _this9._updateFlavorAvailability(flavor, purchase);
      });
      this.changeProductSticky();
    }
  }, {
    key: "changeActiveOnetimePurchase",
    value: function changeActiveOnetimePurchase() {
      var purchase = document.querySelector(this.purchaseTypeSelector + ':checked').value;
      var selectElement = document.querySelector(this.oneTimeSelector);
      var variant = selectElement.options[selectElement.selectedIndex];
      var price = variant.getAttribute('data-price');
      var sale = variant.getAttribute('data-sale');
      var portions = variant.getAttribute('data-portions') + '<span class="sale">' + sale + '</span>';
      var pricePerPortion = variant.getAttribute('data-price-per-portion');
      var comparePrice = variant.getAttribute('data-compare-price');
      var shipping = variant.getAttribute('data-shipping');
      var manaBuySection = this.manaBuySectionSelector + '[data-type="' + purchase + '"]';
      document.querySelector(manaBuySection).querySelector(this.optionNameSelector).innerHTML = portions;
      document.querySelector(manaBuySection).querySelector(this.priceSelector).innerHTML = price;
      document.querySelector(manaBuySection).querySelector(this.comparePriceSelector).innerHTML = comparePrice;
      document.querySelector(manaBuySection).querySelector('[data-transport] span').innerHTML = shipping;
      document.querySelector(manaBuySection).querySelector('[data-pricePerPortion]').innerHTML = pricePerPortion;
      this.changeProductSticky();
    }
  }, {
    key: "changeActiveSubscriptionPurchase",
    value: function changeActiveSubscriptionPurchase(event) {
      var purchase = document.querySelector(this.purchaseTypeSelector + ':checked').value;
      var manaBuySection = document.querySelector("".concat(this.manaBuySectionSelector, "[data-type=\"").concat(purchase, "\"]"));
      var selectElement = document.querySelector(this.sellingPlansSelector);
      if (this.isNewBuySection !== 'true') {
        var variant = selectElement.options[selectElement.selectedIndex];
        var price = variant.getAttribute('data-price');
        var frequency = variant.getAttribute('data-frequency');
        var pricePerPortion = variant.getAttribute('data-price-per-portion');
        manaBuySection.querySelector(this.optionNameSelector).innerHTML = frequency;
        manaBuySection.querySelector(this.priceSelector).innerHTML = price;
        manaBuySection.querySelector(this.everySelector).innerHTML = frequency;
        manaBuySection.querySelector('[data-pricePerPortion]').innerHTML = pricePerPortion;
      } else {
        selectElement.closest('.select-container').querySelector(this.optionNameSelector).innerHTML = selectElement.selectedOptions[0].innerHTML;
        this.updatePricesOnQuantityChange(event);
      }
      this.changeProductSticky();
    }
  }, {
    key: "_updateFlavorAvailability",
    value: function _updateFlavorAvailability(flavor, purchase) {
      var flavorSelectorElement = flavor.closest('.productOption--flavor');
      var qtySelector = flavorSelectorElement.querySelector(this.flavorQtySelector);
      var unavailableMessage = flavorSelectorElement.querySelector(this.unavailableMessageSelector);
      var isOnetimeOnly = flavorSelectorElement.getAttribute('data-onetime-only') === 'true';
      var isSubscriptionOnly = flavorSelectorElement.getAttribute('data-subscription-only') === 'true';
      var isInStock = flavorSelectorElement.getAttribute('data-in-stock') === 'true';
      this._resetFlavorState(flavorSelectorElement, qtySelector, unavailableMessage);
      if (purchase === 'subscription' && isOnetimeOnly && isInStock) {
        this._hideFlavorForPurchaseType(flavorSelectorElement, qtySelector, unavailableMessage, 'show-onetime-only');
      } else if (purchase === 'onetime' && isSubscriptionOnly && isInStock) {
        this._hideFlavorForPurchaseType(flavorSelectorElement, qtySelector, unavailableMessage, 'show-subscription-only');
      }
    }
  }, {
    key: "_resetFlavorState",
    value: function _resetFlavorState(flavorSelectorElement, qtySelector, unavailableMessage) {
      flavorSelectorElement.classList.remove('productOption--unavailable');
      qtySelector.classList.remove('display-none');
      unavailableMessage.classList.remove('show-onetime-only', 'show-subscription-only');
      unavailableMessage.classList.add('display-none');
    }
  }, {
    key: "_hideFlavorForPurchaseType",
    value: function _hideFlavorForPurchaseType(flavorSelectorElement, qtySelector, unavailableMessage, messageClass) {
      flavorSelectorElement.classList.add('productOption--unavailable');
      qtySelector.classList.add('display-none');
      unavailableMessage.classList.remove('display-none');
      unavailableMessage.classList.add(messageClass);
    }
  }, {
    key: "crossellProduct",
    value: function crossellProduct() {
      var self = this;
      var variantLinks = document.querySelectorAll(self.crossellProductVariantsSelector + ' a[data-image]');
      variantLinks.forEach(function (link) {
        var imageUrl = link.getAttribute('data-image');
        var img = new Image();
        img.src = imageUrl;
      });
      document.querySelectorAll(self.crossellProductSelector).forEach(function (element) {
        if (!element.hasAttribute('data-event-listener-set')) {
          element.addEventListener('click', function () {
            var target = event.target;
            var isVariant = target.matches(self.crossellProductVariantsSelector) || target.closest(self.crossellProductVariantsSelector);
            if (isVariant) {
              return;
            }
            var body = this;
            if (!body.classList.contains(self.crosselProductActiveClass)) {
              body.classList.add(self.crosselProductActiveClass);
              if (body.querySelector(self.crossellProductVariantsSelector) && !body.querySelector(self.crossellProductVariantsSelector + ' .selected')) {
                var variantId = body.getAttribute('data-variant-id');
                body.querySelector(self.crossellProductVariantsSelector + ' a[data-variant-id="' + variantId + '"]').classList.add('selected');
              }
            } else {
              body.classList.remove(self.crosselProductActiveClass);
              body.querySelectorAll('.selected').forEach(function (selected) {
                selected.classList.remove('selected');
              });
            }
            self.crossellsProductsResume();
            return false;
          });
          element.setAttribute('data-event-listener-set', 'true');
        }
      });
      document.querySelectorAll(self.crossellProductVariantsSelector + ' a').forEach(function (element) {
        if (!element.hasAttribute('data-event-listener-set')) {
          element.addEventListener('click', function (event) {
            event.preventDefault();
            var button = this;
            var body = button.closest(self.crossellProductSelector);
            if (!button.classList.contains('selected')) {
              var variantId = button.getAttribute('data-variant-id');
              var name = button.getAttribute('data-name');
              var price = button.getAttribute('data-price');
              var img = button.querySelector('.img').getAttribute('data-image');
              body.classList.add(self.crosselProductActiveClass);
              body.setAttribute('data-variant-id', variantId);
              body.setAttribute('data-name', name);
              body.setAttribute('data-price', price);
              body.querySelectorAll(self.crossellProductVariantsSelector + ' .selected').forEach(function (selected) {
                selected.classList.remove('selected');
              });
              body.querySelector('.price').innerHTML = button.getAttribute('data-price');
              body.querySelector(self.crossellProductImageSelector + ' img').setAttribute('src', img);
              button.classList.add('selected');
            } else {
              button.classList.remove('selected');
              body.classList.remove(self.crosselProductActiveClass);
            }
            self.crossellsProductsResume();
            return false;
          });
          element.setAttribute('data-event-listener-set', 'true');
        }
      });
    }
  }, {
    key: "recommendedProduct",
    value: function recommendedProduct() {
      var self = this;
      var manaAddToOrderButtons = document.querySelectorAll(self.manaAddToOrderButtonSelector);
      document.querySelectorAll(self.recommendedProductSelector).forEach(function (element) {
        if (!element.hasAttribute('data-event-listener-set')) {
          element.addEventListener('click', function () {
            var isActive = false;
            if (!this.classList.contains(self.crosselProductActiveClass)) {
              isActive = true;
              this.classList.add(self.crosselProductActiveClass);
            } else {
              this.classList.remove(self.crosselProductActiveClass);
            }
            manaAddToOrderButtons.forEach(function (button) {
              var text = button.getAttribute('data-before');
              if (isActive) {
                text = button.getAttribute('data-after');
                button.classList.add(self.manaAddToOrderButtonActiveClass);
              } else {
                button.classList.remove(self.manaAddToOrderButtonActiveClass);
              }
              button.textContent = text;
            });
            self.crossellsProductsResume();
            return false;
          });
          element.setAttribute('data-event-listener-set', 'true');
        }
      });
    }
  }, {
    key: "changeProductSticky",
    value: function () {
      var _changeProductSticky = _asyncToGenerator(_regeneratorRuntime().mark(function _callee5() {
        var buySection, buySectionParent, stickies, price, portions, typeText, type, comparePrice, selectedItems, totalPrice, totalComparePrice, _document$querySelect, selectedServings, servingToUse, prices, formattedSubscriptionPrice, formattedOriginalPrice, productJson, moneyFormat, selectedInput, _iterator4, _step4, sticky, button, buttonText;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              buySection = document.querySelector(this.manaBuySectionSelector + '[data-active]');
              buySectionParent = buySection === null || buySection === void 0 ? void 0 : buySection.closest(this.buySectionSelector);
              stickies = document.querySelectorAll(this.manaStickySelector);
              if (!(buySection && stickies.length)) {
                _context5.next = 26;
                break;
              }
              price = 0;
              portions = '';
              typeText = '';
              type = '';
              comparePrice = 0;
              if (!(this.isNewBuySection === 'true')) {
                _context5.next = 18;
                break;
              }
              _context5.next = 12;
              return this._getNewBuySectionItems(buySectionParent);
            case 12:
              selectedItems = _context5.sent;
              totalPrice = 0;
              totalComparePrice = 0;
              if (!selectedItems || selectedItems.length === 0) {
                selectedServings = (_document$querySelect = document.querySelector('.productOption--servings.productOption--selected')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.dataset.servings;
                servingToUse = selectedServings || this.getSmallestServingSize();
                if (servingToUse) {
                  prices = this.getFormattedLowestPrice(servingToUse, true);
                  if (prices) {
                    formattedSubscriptionPrice = prices.priceVaries ? theme.strings.from + ' ' + prices.subscriptionPriceFormatted : prices.subscriptionPriceFormatted;
                    formattedOriginalPrice = prices.priceVaries ? theme.strings.from + ' ' + prices.originalPriceFormatted : prices.originalPriceFormatted;
                    price = prices.subscriptionPriceFormatted ? formattedSubscriptionPrice : formattedOriginalPrice;
                    comparePrice = prices.comparePriceFormatted;
                  }
                }
              } else {
                productJson = JSON.parse(buySectionParent.querySelector('#ProductJson').innerHTML);
                selectedItems.forEach(function (item) {
                  var variant = null;
                  var _iterator3 = _createForOfIteratorHelper(productJson.products),
                    _step3;
                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      var _product = _step3.value;
                      variant = _product.variants.find(function (v) {
                        return v.id == item.id;
                      });
                      if (variant) break;
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                  if (!variant) return;
                  var price = variant.price;
                  var compare = variant.compare_at_price || variant.price;
                  if (item.selling_plan && Array.isArray(variant.selling_plan_allocations)) {
                    var allocation = variant.selling_plan_allocations.find(function (alloc) {
                      return alloc.selling_plan_id == item.selling_plan;
                    });
                    if (allocation) {
                      price = allocation.price;
                      compare = allocation.compare_at_price || allocation.price;
                    }
                  }
                  totalPrice += price * item.quantity;
                  totalComparePrice += compare * item.quantity;
                });
                moneyFormat = theme.strings.moneyFormat || '{{ amount }}';
                price = moneyFormat.includes('amount_with_space_separator') ? this._formatMoneyFallback(totalPrice, moneyFormat) : Shopify.formatMoney(totalPrice, moneyFormat);
                comparePrice = moneyFormat.includes('amount_with_space_separator') ? this._formatMoneyFallback(totalComparePrice, moneyFormat) : Shopify.formatMoney(totalComparePrice, moneyFormat);
              }
              _context5.next = 24;
              break;
            case 18:
              selectedInput = buySection.querySelector('[data-add-to-cart-selector]:checked');
              price = selectedInput === null || selectedInput === void 0 ? void 0 : selectedInput.getAttribute('data-price');
              portions = selectedInput === null || selectedInput === void 0 ? void 0 : selectedInput.getAttribute('data-portions-only');
              typeText = selectedInput === null || selectedInput === void 0 ? void 0 : selectedInput.getAttribute('data-label');
              type = buySection === null || buySection === void 0 ? void 0 : buySection.getAttribute('data-type');
              comparePrice = (selectedInput === null || selectedInput === void 0 ? void 0 : selectedInput.getAttribute('data-compare-price')) || 0;
            case 24:
              _iterator4 = _createForOfIteratorHelper(stickies);
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  sticky = _step4.value;
                  if (sticky.querySelector('.portions')) {
                    sticky.querySelector('.portions').textContent = portions;
                  }
                  if (sticky.querySelector('.type')) {
                    sticky.querySelector('.type').textContent = typeText;
                  }
                  if (sticky.querySelector('.price')) {
                    sticky.querySelector('.price').textContent = price;
                  }
                  if (sticky.querySelector('.comparePrice')) {
                    sticky.querySelector('.comparePrice').textContent = comparePrice;
                  }
                  button = sticky.querySelector('button.order');
                  if (button) {
                    buttonText = button.getAttribute('data-' + type);
                    button.textContent = buttonText;
                  } else {
                    console.warn("Warning! sticky button not found!!");
                  }
                  sticky.classList.add('init');
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            case 26:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function changeProductSticky() {
        return _changeProductSticky.apply(this, arguments);
      }
      return changeProductSticky;
    }()
  }, {
    key: "manaBottomStickyReveal",
    value: function manaBottomStickyReveal() {
      var stickyElement = document.querySelector('.manaMobileSticky');
      var buttonElements = document.querySelectorAll('.manaCartBody .add-purchase-button');
      if (!stickyElement || !buttonElements.length) return;
      var visibleButton = Array.from(buttonElements).find(function (button) {
        return button.offsetParent !== null;
      });
      if (!visibleButton) {
        stickyElement.classList.add('--active');
        return;
      }
      var buttonRect = visibleButton.getBoundingClientRect();
      if (buttonRect.top > window.innerHeight || buttonRect.bottom < 0) {
        stickyElement.classList.add('--active');
      } else {
        stickyElement.classList.remove('--active');
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this10 = this;
      var self = this;
      document.querySelectorAll(self.purchaseTypeSelector).forEach(function (element) {
        if (element.hasAttribute('data-purchase-type-listener-attached')) return;
        element.addEventListener('change', self.changeActivePurchase.bind(_this10));
        element.setAttribute('data-purchase-type-listener-attached', 'true');
      });
      document.querySelectorAll(self.sellingPlansSelector).forEach(function (element) {
        if (element.hasAttribute('data-selling-plans-listener-attached')) return;
        element.addEventListener('change', function (event) {
          return self.changeActiveSubscriptionPurchase(event);
        });
        element.setAttribute('data-selling-plans-listener-attached', 'true');
      });
      document.querySelectorAll(self.oneTimeSelector).forEach(function (element) {
        if (element.hasAttribute('data-onetime-listener-attached')) return;
        element.addEventListener('change', self.changeActiveOnetimePurchase.bind(_this10));
        element.setAttribute('data-onetime-listener-attached', 'true');
      });
      document.querySelectorAll(self.purchaseButtonSelector).forEach(function (element) {
        if (element.hasAttribute('data-purchase-button-listener-attached')) return;
        element.addEventListener('click', function (event) {
          self.addToCart(event);
        });
        element.setAttribute('data-purchase-button-listener-attached', 'true');
      });
      document.querySelectorAll(self.manaStickyButtonSelector).forEach(function (element) {
        if (!element.hasAttribute('data-event-listener-set')) {
          element.addEventListener('click', function () {
            var button = document.querySelector(self.manaBuySectionSelector + '[data-active] ' + self.purchaseButtonSelector);
            if (button) {
              button.click();
            }
          });
          element.setAttribute('data-event-listener-set', 'true');
        }
      });
      document.querySelectorAll('[data-quick-add]').forEach(function (element) {
        if (element.hasAttribute('data-quick-add-listener-attached')) return;
        element.addEventListener('click', self.quickAddToCart.bind(_this10));
        element.setAttribute('data-quick-add-listener-attached', 'true');
      });
      document.querySelectorAll(self.colorSelector).forEach(function (element) {
        if (element.hasAttribute('data-color-selector-listener-attached')) return;
        element.addEventListener('click', self.changeColor.bind(_this10));
        element.setAttribute('data-color-selector-listener-attached', 'true');
      });
      document.querySelectorAll(this.colorVariantSelector).forEach(function (element) {
        if (element.hasAttribute('data-color-variant-listener-attached')) return;
        element.addEventListener('click', _this10.getSelectedVariant.bind(_this10));
        element.setAttribute('data-color-variant-listener-attached', 'true');
      });
      document.querySelectorAll(this.sizeVariantSelector).forEach(function (element) {
        if (element.hasAttribute('data-size-variant-listener-attached')) return;
        element.addEventListener('click', _this10.getSelectedVariant.bind(_this10));
        element.setAttribute('data-size-variant-listener-attached', 'true');
      });
      window.addEventListener('colorChange', function (event) {
        _this10.changeColor(event.detail.selectedVariant);
      });
      self.recommendedProduct();
      self.crossellProduct();
      self.changeProductSticky();
      self.manaBottomStickyReveal();
      window.addEventListener('scroll', self.manaBottomStickyReveal);
    }
  }, {
    key: "initQtyInputs",
    value: function initQtyInputs() {
      if (this.isNewBuySection !== 'true') return;
      this.attachQtyInputListeners();
    }
  }, {
    key: "attachQtyInputListeners",
    value: function attachQtyInputListeners() {
      var _this11 = this;
      document.querySelectorAll(this.quantityButtonSelector).forEach(function (button) {
        if (button.hasAttribute('data-qty-listener-attached')) {
          return;
        }
        var quantityInput = button.closest('.productOption__quantity-selector').querySelector(_this11.flavorSelector);
        var clickHandler = function clickHandler(event) {
          if (event.target.dataset.quantityButton === 'plus') {
            quantityInput.value = parseInt(quantityInput.value) + 1;
            quantityInput.dispatchEvent(new CustomEvent('input', {
              bubbles: true,
              detail: {
                value: quantityInput.value,
                buttonType: event.target.dataset.quantityButton
              }
            }));
          }
          if (event.target.dataset.quantityButton === 'minus') {
            quantityInput.value = parseInt(quantityInput.value) - 1;
            quantityInput.dispatchEvent(new CustomEvent('input', {
              bubbles: true,
              detail: {
                value: quantityInput.value,
                buttonType: event.target.dataset.quantityButton
              }
            }));
          }
        };
        button.addEventListener('click', clickHandler);
        button.setAttribute('data-qty-listener-attached', 'true');
      });
      document.querySelectorAll(this.flavorSelector).forEach(function (element) {
        if (element.hasAttribute('data-input-listener-attached')) {
          return;
        }
        element.addEventListener('input', _this11.onQuantityChange.bind(_this11));
        element.setAttribute('data-input-listener-attached', 'true');
      });
    }
  }, {
    key: "reinitQtyInputs",
    value: function reinitQtyInputs() {
      document.querySelectorAll('[data-qty-listener-attached]').forEach(function (button) {
        button.removeAttribute('data-qty-listener-attached');
      });
      document.querySelectorAll('[data-input-listener-attached]').forEach(function (input) {
        input.removeAttribute('data-input-listener-attached');
      });
      this.attachQtyInputListeners();
    }
  }, {
    key: "reinitPurchaseListeners",
    value: function reinitPurchaseListeners() {
      var _this12 = this;
      var self = this;
      document.querySelectorAll('[data-purchase-type-listener-attached]').forEach(function (el) {
        el.removeAttribute('data-purchase-type-listener-attached');
      });
      document.querySelectorAll('[data-selling-plans-listener-attached]').forEach(function (el) {
        el.removeAttribute('data-selling-plans-listener-attached');
      });
      document.querySelectorAll('[data-onetime-listener-attached]').forEach(function (el) {
        el.removeAttribute('data-onetime-listener-attached');
      });
      document.querySelectorAll('[data-purchase-button-listener-attached]').forEach(function (el) {
        el.removeAttribute('data-purchase-button-listener-attached');
      });
      document.querySelectorAll(self.purchaseTypeSelector).forEach(function (element) {
        if (element.hasAttribute('data-purchase-type-listener-attached')) return;
        element.addEventListener('change', self.changeActivePurchase.bind(_this12));
        element.setAttribute('data-purchase-type-listener-attached', 'true');
      });
      document.querySelectorAll(self.sellingPlansSelector).forEach(function (element) {
        if (element.hasAttribute('data-selling-plans-listener-attached')) return;
        element.addEventListener('change', function (event) {
          return self.changeActiveSubscriptionPurchase(event);
        });
        element.setAttribute('data-selling-plans-listener-attached', 'true');
      });
      document.querySelectorAll(self.oneTimeSelector).forEach(function (element) {
        if (element.hasAttribute('data-onetime-listener-attached')) return;
        element.addEventListener('change', self.changeActiveOnetimePurchase.bind(_this12));
        element.setAttribute('data-onetime-listener-attached', 'true');
      });
      document.querySelectorAll(self.purchaseButtonSelector).forEach(function (element) {
        if (element.hasAttribute('data-purchase-button-listener-attached')) return;
        element.addEventListener('click', function (event) {
          self.addToCart(event);
        });
        element.setAttribute('data-purchase-button-listener-attached', 'true');
      });
      self.recommendedProduct();
      self.crossellProduct();
      self.changeProductSticky();
    }
  }, {
    key: "_formatMoneyFallback",
    value: function _formatMoneyFallback(price, format) {
      format = format || '${{amount}}';
      if (typeof price === 'string') {
        price = price.replace('.', '');
      }
      var formatMatch = /\{\{\s*(\w+)\s*\}\}/.exec(format);
      if (!formatMatch) {
        var priceValue = (price / 100).toFixed(2);
        var currencyMatch = format.match(/[^\d\s,.{{}}]+/);
        var currency = currencyMatch ? currencyMatch[0] : '$';
        var currencyIndex = format.indexOf(currency);
        var amountIndex = format.indexOf('{{');
        if (currencyIndex < amountIndex || amountIndex === -1) {
          return currency + priceValue;
        } else {
          return priceValue + currency;
        }
      }
      var formatCurrency = function formatCurrency(amount, decimals, thousandsSep, decimalSep) {
        thousandsSep = thousandsSep || ',';
        decimalSep = decimalSep || '.';
        if (isNaN(amount) || amount === null) return '0';
        var formattedAmount = (amount / 100).toFixed(decimals);
        var parts = formattedAmount.split('.');
        parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousandsSep);
        return parts[1] ? parts[0] + decimalSep + parts[1] : parts[0];
      };
      var formattedAmount;
      switch (formatMatch[1]) {
        case 'amount':
          formattedAmount = formatCurrency(price, 2);
          break;
        case 'amount_no_decimals':
          formattedAmount = formatCurrency(price, 0);
          break;
        case 'amount_with_comma_separator':
          formattedAmount = formatCurrency(price, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          formattedAmount = formatCurrency(price, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          formattedAmount = formatCurrency(price, 2, ' ');
          break;
        case 'amount_no_decimals_with_space_separator':
          formattedAmount = formatCurrency(price, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          formattedAmount = formatCurrency(price, 2, "'");
          break;
        default:
          formattedAmount = formatCurrency(price, 2);
      }
      return format.replace(formatMatch[0], formattedAmount);
    }
  }]);
  return productPurchase;
}();
window.purchaseProduct = new productPurchase();
document.addEventListener('DOMContentLoaded', function () {
  window.purchaseProduct.init();
});
document.addEventListener("turbo:load", function () {
  window.purchaseProduct.init();
});
document.addEventListener("productSelectionChanged", function () {
  if (window.sga.newBuySection === 'true') {
    window.purchaseProduct.reinitQtyInputs();
    window.purchaseProduct.resetTotalQuantity();
    window.purchaseProduct.setPrices();
    window.purchaseProduct.setDiscounts();
  }
});

/***/ }),

/***/ 7496:
/***/ (function() {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
window.restoreCustomerCart = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(currentCart) {
    var savedCart, items, _iterator, _step, _loop;
    return _regeneratorRuntime().wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!localStorage.customerLoggedIn) {
            _context2.next = 3;
            break;
          }
          window.saveCustomerCart(currentCart);
          return _context2.abrupt("return");
        case 3:
          if (localStorage[window.customerEmailLocalStorageName]) {
            _context2.next = 6;
            break;
          }
          localStorage.customerLoggedIn = true;
          return _context2.abrupt("return");
        case 6:
          savedCart = JSON.parse(localStorage[window.customerEmailLocalStorageName]);
          items = [];
          _iterator = _createForOfIteratorHelper(savedCart);
          _context2.prev = 9;
          _loop = _regeneratorRuntime().mark(function _loop() {
            var cartItem, matchingItem, item;
            return _regeneratorRuntime().wrap(function _loop$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  cartItem = _step.value;
                  matchingItem = currentCart.find(function (currentItem) {
                    var _currentItem$selling_, _cartItem$selling_pla;
                    return (currentItem === null || currentItem === void 0 || (_currentItem$selling_ = currentItem.selling_plan_allocation) === null || _currentItem$selling_ === void 0 || (_currentItem$selling_ = _currentItem$selling_.selling_plan) === null || _currentItem$selling_ === void 0 ? void 0 : _currentItem$selling_.id) === (cartItem === null || cartItem === void 0 || (_cartItem$selling_pla = cartItem.selling_plan_allocation) === null || _cartItem$selling_pla === void 0 || (_cartItem$selling_pla = _cartItem$selling_pla.selling_plan) === null || _cartItem$selling_pla === void 0 ? void 0 : _cartItem$selling_pla.id) && currentItem.variant_id === cartItem.variant_id && JSON.stringify(currentItem.properties) === JSON.stringify(cartItem.properties);
                  });
                  item = {
                    id: cartItem.variant_id,
                    properties: cartItem.properties,
                    quantity: cartItem.quantity
                  };
                  if (cartItem.selling_plan_allocation) {
                    item.selling_plan = cartItem.selling_plan_allocation.selling_plan.id;
                  }
                  if (!matchingItem) {
                    _context.next = 8;
                    break;
                  }
                  if (!(matchingItem.quantity >= cartItem.quantity)) {
                    _context.next = 7;
                    break;
                  }
                  return _context.abrupt("return", 1);
                case 7:
                  item.quantity = item.quantity - matchingItem.quantity;
                case 8:
                  items.push(item);
                case 9:
                case "end":
                  return _context.stop();
              }
            }, _loop);
          });
          _iterator.s();
        case 12:
          if ((_step = _iterator.n()).done) {
            _context2.next = 18;
            break;
          }
          return _context2.delegateYield(_loop(), "t0", 14);
        case 14:
          if (!_context2.t0) {
            _context2.next = 16;
            break;
          }
          return _context2.abrupt("continue", 16);
        case 16:
          _context2.next = 12;
          break;
        case 18:
          _context2.next = 23;
          break;
        case 20:
          _context2.prev = 20;
          _context2.t1 = _context2["catch"](9);
          _iterator.e(_context2.t1);
        case 23:
          _context2.prev = 23;
          _iterator.f();
          return _context2.finish(23);
        case 26:
          if (items.length) {
            _context2.next = 28;
            break;
          }
          return _context2.abrupt("return");
        case 28:
          _context2.next = 30;
          return window.shopifyFrontendHelper.addToCart(items);
        case 30:
          window.cartDrawerElement.toggleCart();
          localStorage.customerLoggedIn = true;
        case 32:
        case "end":
          return _context2.stop();
      }
    }, _callee, null, [[9, 20, 23, 26]]);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();
window.saveCustomerCart = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
  var currentCart,
    response,
    cart,
    _args3 = arguments;
  return _regeneratorRuntime().wrap(function _callee2$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        currentCart = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : null;
        if (window.customerEmailLocalStorageName) {
          _context3.next = 3;
          break;
        }
        return _context3.abrupt("return");
      case 3:
        _context3.prev = 3;
        if (currentCart) {
          _context3.next = 12;
          break;
        }
        _context3.next = 7;
        return fetch('/cart.json');
      case 7:
        response = _context3.sent;
        _context3.next = 10;
        return response.json();
      case 10:
        cart = _context3.sent;
        currentCart = cart.items;
      case 12:
        if (localStorage.customerLoggedIn) {
          localStorage[window.customerEmailLocalStorageName] = JSON.stringify(currentCart);
        }
        _context3.next = 18;
        break;
      case 15:
        _context3.prev = 15;
        _context3.t0 = _context3["catch"](3);
        console.log(_context3.t0);
      case 18:
      case "end":
        return _context3.stop();
    }
  }, _callee2, null, [[3, 15]]);
}));

/***/ }),

/***/ 9116:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
class ShopifyFrontendHelper {
    constructor() {
        this.routes = '/';
        if (window.hasOwnProperty('Shopify')) {
            this.routes = window.Shopify.routes.root;
        }
    }
    fetchConfig(type = 'json') {
        return {
            method: 'POST',
            headers: { 'Content-Type': `application/${type}`, 'Accept': `application/${type}` }
        };
    }
    /* Will add items array to cart */
    async addToCart(items) {
        const body = JSON.stringify({ items: items });
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/add.js', Object.assign(Object.assign({}, config), { body }))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /* Will add variant of product to cart */
    async addVariantToCart(variantId, quantity, sellingPlan = null) {
        const items = [
            {
                id: variantId,
                quantity: quantity
            }
        ];
        if (sellingPlan) {
            items[0]["selling_plan"] = sellingPlan;
        }
        const body = JSON.stringify({ items: items });
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/add.js', Object.assign(Object.assign({}, config), { body }))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /* Will remove variant from cart */
    async removeFromCart(variantId) {
        let updates = {};
        updates[variantId] = 0;
        const body = JSON.stringify({ updates: updates });
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/update.js', Object.assign(Object.assign({}, config), { body }))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /* Will change quantity of variant in cart */
    async updateQuantityInCart(variantId, quantity, itemKey = null, updateSellingPlan = false, sellingPlan = null) {
        const updateBody = {
            id: itemKey ? itemKey : variantId,
            quantity: quantity,
        };
        if (updateSellingPlan) {
            updateBody["selling_plan"] = sellingPlan;
        }
        const body = JSON.stringify(updateBody);
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/change.js', Object.assign(Object.assign({}, config), { body }))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /* Will change quantity of variant in cart */
    async updateCartItem(updatedItem) {
        const body = JSON.stringify(updatedItem);
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/change.js', Object.assign(Object.assign({}, config), { body }))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /*
    Search function
    Type: product, page, article, collection
    Unavailable products:
        show: Show unavailable products.
        hide: Hide unavailable products.
        last: Show unavailable products below other matching results.
    Fields: author, body, product_type, tag, title, variants.barcode, variants.sku, variants.title, vendor
    More about parameters: https://shopify.dev/api/ajax/reference/predictive-search
    */
    async search(query, type = 'product', limit = 10, unavailable_products = 'last', fields = 'title,product_type,variants.title,vendor') {
        const url = this.routes
            + 'search/suggest.json?q='
            + query
            + '&resources[type]=' + type
            + '&resources[limit]=' + limit
            + '&resources[options][unavailable_products]=' + unavailable_products
            + '&resources[options][fields]=' + fields;
        return await fetch(url)
            .then((response) => response.json())
            .then((suggestions) => {
            return suggestions.resources.results;
        })
            .catch((e) => {
            return e;
        });
    }
    /* Will clear cart items */
    async clearCartItems() {
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/clear.js', Object.assign({}, config))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /* Will clear cart items with attributes and properties */
    async clearCartFully() {
        /* First clear attributes and note in cart */
        await fetch('/cart.js').then(result => result.json()).then(async (cart) => {
            for (const attr in cart.attributes) {
                cart.attributes[attr] = null;
            }
            cart.note = '';
            const body = JSON.stringify(cart);
            const config = this.fetchConfig();
            await fetch(this.routes + 'cart/update.js', Object.assign(Object.assign({}, config), { body }))
                .then((response) => { return response.json(); })
                .then((state) => { return state; })
                .catch((e) => {
                return e;
            });
        });
        /* Clear cart  items */
        return await this.clearCartItems();
    }
    /* Will log in customer. Recaptcha has to be disabled. If redirectUrl is empty we don't redirect after login */
    async customerLogin(email, password, redirectUrl = '/account/') {
        let formData = new FormData();
        formData.append('customer[email]', email);
        formData.append('customer[password]', password);
        formData.append('form_type', 'customer_login');
        formData.append('utf8', '✓');
        return await fetch("/account/login", {
            method: "POST",
            mode: "no-cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "form-data"
            },
            body: formData
        })
            .then((response) => { return response.text(); })
            .then((html) => {
            if (!html.includes('/account/logout')) {
                return 'Wrong email or password';
            }
            else {
                if (redirectUrl != '') {
                    location.href = redirectUrl;
                }
                return 'Logged In';
            }
        })
            .catch((e) => {
            return e;
        });
    }
    /* Will log out customer */
    async customerLogout(redirectUrl = '/') {
        return await fetch(this.routes + 'account/logout')
            .then((response) => { })
            .then((state) => {
            if (redirectUrl != '') {
                location.href = redirectUrl;
            }
            return 'Logged Out';
        })
            .catch((e) => {
            return e;
        });
        ;
    }
}
exports.c = ShopifyFrontendHelper;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";

;// CONCATENATED MODULE: ./node_modules/@hotwired/turbo/dist/turbo.es2017-esm.js
/*
Turbo 7.3.0
Copyright © 2023 37signals LLC
 */
(function () {
    if (window.Reflect === undefined ||
        window.customElements === undefined ||
        window.customElements.polyfillWrapFlushCallback) {
        return;
    }
    const BuiltInHTMLElement = HTMLElement;
    const wrapperForTheName = {
        HTMLElement: function HTMLElement() {
            return Reflect.construct(BuiltInHTMLElement, [], this.constructor);
        },
    };
    window.HTMLElement = wrapperForTheName["HTMLElement"];
    HTMLElement.prototype = BuiltInHTMLElement.prototype;
    HTMLElement.prototype.constructor = HTMLElement;
    Object.setPrototypeOf(HTMLElement, BuiltInHTMLElement);
})();

/**
 * The MIT License (MIT)
 * 
 * Copyright (c) 2019 Javan Makhmali
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

(function(prototype) {
  if (typeof prototype.requestSubmit == "function") return

  prototype.requestSubmit = function(submitter) {
    if (submitter) {
      validateSubmitter(submitter, this);
      submitter.click();
    } else {
      submitter = document.createElement("input");
      submitter.type = "submit";
      submitter.hidden = true;
      this.appendChild(submitter);
      submitter.click();
      this.removeChild(submitter);
    }
  };

  function validateSubmitter(submitter, form) {
    submitter instanceof HTMLElement || raise(TypeError, "parameter 1 is not of type 'HTMLElement'");
    submitter.type == "submit" || raise(TypeError, "The specified element is not a submit button");
    submitter.form == form || raise(DOMException, "The specified element is not owned by this form element", "NotFoundError");
  }

  function raise(errorConstructor, message, name) {
    throw new errorConstructor("Failed to execute 'requestSubmit' on 'HTMLFormElement': " + message + ".", name)
  }
})(HTMLFormElement.prototype);

const submittersByForm = new WeakMap();
function findSubmitterFromClickTarget(target) {
    const element = target instanceof Element ? target : target instanceof Node ? target.parentElement : null;
    const candidate = element ? element.closest("input, button") : null;
    return (candidate === null || candidate === void 0 ? void 0 : candidate.type) == "submit" ? candidate : null;
}
function clickCaptured(event) {
    const submitter = findSubmitterFromClickTarget(event.target);
    if (submitter && submitter.form) {
        submittersByForm.set(submitter.form, submitter);
    }
}
(function () {
    if ("submitter" in Event.prototype)
        return;
    let prototype = window.Event.prototype;
    if ("SubmitEvent" in window && /Apple Computer/.test(navigator.vendor)) {
        prototype = window.SubmitEvent.prototype;
    }
    else if ("SubmitEvent" in window) {
        return;
    }
    addEventListener("click", clickCaptured, true);
    Object.defineProperty(prototype, "submitter", {
        get() {
            if (this.type == "submit" && this.target instanceof HTMLFormElement) {
                return submittersByForm.get(this.target);
            }
        },
    });
})();

var FrameLoadingStyle;
(function (FrameLoadingStyle) {
    FrameLoadingStyle["eager"] = "eager";
    FrameLoadingStyle["lazy"] = "lazy";
})(FrameLoadingStyle || (FrameLoadingStyle = {}));
class FrameElement extends HTMLElement {
    static get observedAttributes() {
        return ["disabled", "complete", "loading", "src"];
    }
    constructor() {
        super();
        this.loaded = Promise.resolve();
        this.delegate = new FrameElement.delegateConstructor(this);
    }
    connectedCallback() {
        this.delegate.connect();
    }
    disconnectedCallback() {
        this.delegate.disconnect();
    }
    reload() {
        return this.delegate.sourceURLReloaded();
    }
    attributeChangedCallback(name) {
        if (name == "loading") {
            this.delegate.loadingStyleChanged();
        }
        else if (name == "complete") {
            this.delegate.completeChanged();
        }
        else if (name == "src") {
            this.delegate.sourceURLChanged();
        }
        else {
            this.delegate.disabledChanged();
        }
    }
    get src() {
        return this.getAttribute("src");
    }
    set src(value) {
        if (value) {
            this.setAttribute("src", value);
        }
        else {
            this.removeAttribute("src");
        }
    }
    get loading() {
        return frameLoadingStyleFromString(this.getAttribute("loading") || "");
    }
    set loading(value) {
        if (value) {
            this.setAttribute("loading", value);
        }
        else {
            this.removeAttribute("loading");
        }
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(value) {
        if (value) {
            this.setAttribute("disabled", "");
        }
        else {
            this.removeAttribute("disabled");
        }
    }
    get autoscroll() {
        return this.hasAttribute("autoscroll");
    }
    set autoscroll(value) {
        if (value) {
            this.setAttribute("autoscroll", "");
        }
        else {
            this.removeAttribute("autoscroll");
        }
    }
    get complete() {
        return !this.delegate.isLoading;
    }
    get isActive() {
        return this.ownerDocument === document && !this.isPreview;
    }
    get isPreview() {
        var _a, _b;
        return (_b = (_a = this.ownerDocument) === null || _a === void 0 ? void 0 : _a.documentElement) === null || _b === void 0 ? void 0 : _b.hasAttribute("data-turbo-preview");
    }
}
function frameLoadingStyleFromString(style) {
    switch (style.toLowerCase()) {
        case "lazy":
            return FrameLoadingStyle.lazy;
        default:
            return FrameLoadingStyle.eager;
    }
}

function expandURL(locatable) {
    return new URL(locatable.toString(), document.baseURI);
}
function getAnchor(url) {
    let anchorMatch;
    if (url.hash) {
        return url.hash.slice(1);
    }
    else if ((anchorMatch = url.href.match(/#(.*)$/))) {
        return anchorMatch[1];
    }
}
function getAction(form, submitter) {
    const action = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formaction")) || form.getAttribute("action") || form.action;
    return expandURL(action);
}
function getExtension(url) {
    return (getLastPathComponent(url).match(/\.[^.]*$/) || [])[0] || "";
}
function isHTML(url) {
    return !!getExtension(url).match(/^(?:|\.(?:htm|html|xhtml|php))$/);
}
function isPrefixedBy(baseURL, url) {
    const prefix = getPrefix(url);
    return baseURL.href === expandURL(prefix).href || baseURL.href.startsWith(prefix);
}
function locationIsVisitable(location, rootLocation) {
    return isPrefixedBy(location, rootLocation) && isHTML(location);
}
function getRequestURL(url) {
    const anchor = getAnchor(url);
    return anchor != null ? url.href.slice(0, -(anchor.length + 1)) : url.href;
}
function toCacheKey(url) {
    return getRequestURL(url);
}
function urlsAreEqual(left, right) {
    return expandURL(left).href == expandURL(right).href;
}
function getPathComponents(url) {
    return url.pathname.split("/").slice(1);
}
function getLastPathComponent(url) {
    return getPathComponents(url).slice(-1)[0];
}
function getPrefix(url) {
    return addTrailingSlash(url.origin + url.pathname);
}
function addTrailingSlash(value) {
    return value.endsWith("/") ? value : value + "/";
}

class FetchResponse {
    constructor(response) {
        this.response = response;
    }
    get succeeded() {
        return this.response.ok;
    }
    get failed() {
        return !this.succeeded;
    }
    get clientError() {
        return this.statusCode >= 400 && this.statusCode <= 499;
    }
    get serverError() {
        return this.statusCode >= 500 && this.statusCode <= 599;
    }
    get redirected() {
        return this.response.redirected;
    }
    get location() {
        return expandURL(this.response.url);
    }
    get isHTML() {
        return this.contentType && this.contentType.match(/^(?:text\/([^\s;,]+\b)?html|application\/xhtml\+xml)\b/);
    }
    get statusCode() {
        return this.response.status;
    }
    get contentType() {
        return this.header("Content-Type");
    }
    get responseText() {
        return this.response.clone().text();
    }
    get responseHTML() {
        if (this.isHTML) {
            return this.response.clone().text();
        }
        else {
            return Promise.resolve(undefined);
        }
    }
    header(name) {
        return this.response.headers.get(name);
    }
}

function activateScriptElement(element) {
    if (element.getAttribute("data-turbo-eval") == "false") {
        return element;
    }
    else {
        const createdScriptElement = document.createElement("script");
        const cspNonce = getMetaContent("csp-nonce");
        if (cspNonce) {
            createdScriptElement.nonce = cspNonce;
        }
        createdScriptElement.textContent = element.textContent;
        createdScriptElement.async = false;
        copyElementAttributes(createdScriptElement, element);
        return createdScriptElement;
    }
}
function copyElementAttributes(destinationElement, sourceElement) {
    for (const { name, value } of sourceElement.attributes) {
        destinationElement.setAttribute(name, value);
    }
}
function createDocumentFragment(html) {
    const template = document.createElement("template");
    template.innerHTML = html;
    return template.content;
}
function dispatch(eventName, { target, cancelable, detail } = {}) {
    const event = new CustomEvent(eventName, {
        cancelable,
        bubbles: true,
        composed: true,
        detail,
    });
    if (target && target.isConnected) {
        target.dispatchEvent(event);
    }
    else {
        document.documentElement.dispatchEvent(event);
    }
    return event;
}
function nextAnimationFrame() {
    return new Promise((resolve) => requestAnimationFrame(() => resolve()));
}
function nextEventLoopTick() {
    return new Promise((resolve) => setTimeout(() => resolve(), 0));
}
function nextMicrotask() {
    return Promise.resolve();
}
function parseHTMLDocument(html = "") {
    return new DOMParser().parseFromString(html, "text/html");
}
function unindent(strings, ...values) {
    const lines = interpolate(strings, values).replace(/^\n/, "").split("\n");
    const match = lines[0].match(/^\s+/);
    const indent = match ? match[0].length : 0;
    return lines.map((line) => line.slice(indent)).join("\n");
}
function interpolate(strings, values) {
    return strings.reduce((result, string, i) => {
        const value = values[i] == undefined ? "" : values[i];
        return result + string + value;
    }, "");
}
function uuid() {
    return Array.from({ length: 36 })
        .map((_, i) => {
        if (i == 8 || i == 13 || i == 18 || i == 23) {
            return "-";
        }
        else if (i == 14) {
            return "4";
        }
        else if (i == 19) {
            return (Math.floor(Math.random() * 4) + 8).toString(16);
        }
        else {
            return Math.floor(Math.random() * 15).toString(16);
        }
    })
        .join("");
}
function getAttribute(attributeName, ...elements) {
    for (const value of elements.map((element) => element === null || element === void 0 ? void 0 : element.getAttribute(attributeName))) {
        if (typeof value == "string")
            return value;
    }
    return null;
}
function hasAttribute(attributeName, ...elements) {
    return elements.some((element) => element && element.hasAttribute(attributeName));
}
function markAsBusy(...elements) {
    for (const element of elements) {
        if (element.localName == "turbo-frame") {
            element.setAttribute("busy", "");
        }
        element.setAttribute("aria-busy", "true");
    }
}
function clearBusyState(...elements) {
    for (const element of elements) {
        if (element.localName == "turbo-frame") {
            element.removeAttribute("busy");
        }
        element.removeAttribute("aria-busy");
    }
}
function waitForLoad(element, timeoutInMilliseconds = 2000) {
    return new Promise((resolve) => {
        const onComplete = () => {
            element.removeEventListener("error", onComplete);
            element.removeEventListener("load", onComplete);
            resolve();
        };
        element.addEventListener("load", onComplete, { once: true });
        element.addEventListener("error", onComplete, { once: true });
        setTimeout(resolve, timeoutInMilliseconds);
    });
}
function getHistoryMethodForAction(action) {
    switch (action) {
        case "replace":
            return history.replaceState;
        case "advance":
        case "restore":
            return history.pushState;
    }
}
function isAction(action) {
    return action == "advance" || action == "replace" || action == "restore";
}
function getVisitAction(...elements) {
    const action = getAttribute("data-turbo-action", ...elements);
    return isAction(action) ? action : null;
}
function getMetaElement(name) {
    return document.querySelector(`meta[name="${name}"]`);
}
function getMetaContent(name) {
    const element = getMetaElement(name);
    return element && element.content;
}
function setMetaContent(name, content) {
    let element = getMetaElement(name);
    if (!element) {
        element = document.createElement("meta");
        element.setAttribute("name", name);
        document.head.appendChild(element);
    }
    element.setAttribute("content", content);
    return element;
}
function findClosestRecursively(element, selector) {
    var _a;
    if (element instanceof Element) {
        return (element.closest(selector) ||
            findClosestRecursively(element.assignedSlot || ((_a = element.getRootNode()) === null || _a === void 0 ? void 0 : _a.host), selector));
    }
}

var FetchMethod;
(function (FetchMethod) {
    FetchMethod[FetchMethod["get"] = 0] = "get";
    FetchMethod[FetchMethod["post"] = 1] = "post";
    FetchMethod[FetchMethod["put"] = 2] = "put";
    FetchMethod[FetchMethod["patch"] = 3] = "patch";
    FetchMethod[FetchMethod["delete"] = 4] = "delete";
})(FetchMethod || (FetchMethod = {}));
function fetchMethodFromString(method) {
    switch (method.toLowerCase()) {
        case "get":
            return FetchMethod.get;
        case "post":
            return FetchMethod.post;
        case "put":
            return FetchMethod.put;
        case "patch":
            return FetchMethod.patch;
        case "delete":
            return FetchMethod.delete;
    }
}
class FetchRequest {
    constructor(delegate, method, location, body = new URLSearchParams(), target = null) {
        this.abortController = new AbortController();
        this.resolveRequestPromise = (_value) => { };
        this.delegate = delegate;
        this.method = method;
        this.headers = this.defaultHeaders;
        this.body = body;
        this.url = location;
        this.target = target;
    }
    get location() {
        return this.url;
    }
    get params() {
        return this.url.searchParams;
    }
    get entries() {
        return this.body ? Array.from(this.body.entries()) : [];
    }
    cancel() {
        this.abortController.abort();
    }
    async perform() {
        const { fetchOptions } = this;
        this.delegate.prepareRequest(this);
        await this.allowRequestToBeIntercepted(fetchOptions);
        try {
            this.delegate.requestStarted(this);
            const response = await fetch(this.url.href, fetchOptions);
            return await this.receive(response);
        }
        catch (error) {
            if (error.name !== "AbortError") {
                if (this.willDelegateErrorHandling(error)) {
                    this.delegate.requestErrored(this, error);
                }
                throw error;
            }
        }
        finally {
            this.delegate.requestFinished(this);
        }
    }
    async receive(response) {
        const fetchResponse = new FetchResponse(response);
        const event = dispatch("turbo:before-fetch-response", {
            cancelable: true,
            detail: { fetchResponse },
            target: this.target,
        });
        if (event.defaultPrevented) {
            this.delegate.requestPreventedHandlingResponse(this, fetchResponse);
        }
        else if (fetchResponse.succeeded) {
            this.delegate.requestSucceededWithResponse(this, fetchResponse);
        }
        else {
            this.delegate.requestFailedWithResponse(this, fetchResponse);
        }
        return fetchResponse;
    }
    get fetchOptions() {
        var _a;
        return {
            method: FetchMethod[this.method].toUpperCase(),
            credentials: "same-origin",
            headers: this.headers,
            redirect: "follow",
            body: this.isSafe ? null : this.body,
            signal: this.abortSignal,
            referrer: (_a = this.delegate.referrer) === null || _a === void 0 ? void 0 : _a.href,
        };
    }
    get defaultHeaders() {
        return {
            Accept: "text/html, application/xhtml+xml",
        };
    }
    get isSafe() {
        return this.method === FetchMethod.get;
    }
    get abortSignal() {
        return this.abortController.signal;
    }
    acceptResponseType(mimeType) {
        this.headers["Accept"] = [mimeType, this.headers["Accept"]].join(", ");
    }
    async allowRequestToBeIntercepted(fetchOptions) {
        const requestInterception = new Promise((resolve) => (this.resolveRequestPromise = resolve));
        const event = dispatch("turbo:before-fetch-request", {
            cancelable: true,
            detail: {
                fetchOptions,
                url: this.url,
                resume: this.resolveRequestPromise,
            },
            target: this.target,
        });
        if (event.defaultPrevented)
            await requestInterception;
    }
    willDelegateErrorHandling(error) {
        const event = dispatch("turbo:fetch-request-error", {
            target: this.target,
            cancelable: true,
            detail: { request: this, error: error },
        });
        return !event.defaultPrevented;
    }
}

class AppearanceObserver {
    constructor(delegate, element) {
        this.started = false;
        this.intersect = (entries) => {
            const lastEntry = entries.slice(-1)[0];
            if (lastEntry === null || lastEntry === void 0 ? void 0 : lastEntry.isIntersecting) {
                this.delegate.elementAppearedInViewport(this.element);
            }
        };
        this.delegate = delegate;
        this.element = element;
        this.intersectionObserver = new IntersectionObserver(this.intersect);
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.intersectionObserver.observe(this.element);
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.intersectionObserver.unobserve(this.element);
        }
    }
}

class StreamMessage {
    static wrap(message) {
        if (typeof message == "string") {
            return new this(createDocumentFragment(message));
        }
        else {
            return message;
        }
    }
    constructor(fragment) {
        this.fragment = importStreamElements(fragment);
    }
}
StreamMessage.contentType = "text/vnd.turbo-stream.html";
function importStreamElements(fragment) {
    for (const element of fragment.querySelectorAll("turbo-stream")) {
        const streamElement = document.importNode(element, true);
        for (const inertScriptElement of streamElement.templateElement.content.querySelectorAll("script")) {
            inertScriptElement.replaceWith(activateScriptElement(inertScriptElement));
        }
        element.replaceWith(streamElement);
    }
    return fragment;
}

var FormSubmissionState;
(function (FormSubmissionState) {
    FormSubmissionState[FormSubmissionState["initialized"] = 0] = "initialized";
    FormSubmissionState[FormSubmissionState["requesting"] = 1] = "requesting";
    FormSubmissionState[FormSubmissionState["waiting"] = 2] = "waiting";
    FormSubmissionState[FormSubmissionState["receiving"] = 3] = "receiving";
    FormSubmissionState[FormSubmissionState["stopping"] = 4] = "stopping";
    FormSubmissionState[FormSubmissionState["stopped"] = 5] = "stopped";
})(FormSubmissionState || (FormSubmissionState = {}));
var FormEnctype;
(function (FormEnctype) {
    FormEnctype["urlEncoded"] = "application/x-www-form-urlencoded";
    FormEnctype["multipart"] = "multipart/form-data";
    FormEnctype["plain"] = "text/plain";
})(FormEnctype || (FormEnctype = {}));
function formEnctypeFromString(encoding) {
    switch (encoding.toLowerCase()) {
        case FormEnctype.multipart:
            return FormEnctype.multipart;
        case FormEnctype.plain:
            return FormEnctype.plain;
        default:
            return FormEnctype.urlEncoded;
    }
}
class FormSubmission {
    static confirmMethod(message, _element, _submitter) {
        return Promise.resolve(confirm(message));
    }
    constructor(delegate, formElement, submitter, mustRedirect = false) {
        this.state = FormSubmissionState.initialized;
        this.delegate = delegate;
        this.formElement = formElement;
        this.submitter = submitter;
        this.formData = buildFormData(formElement, submitter);
        this.location = expandURL(this.action);
        if (this.method == FetchMethod.get) {
            mergeFormDataEntries(this.location, [...this.body.entries()]);
        }
        this.fetchRequest = new FetchRequest(this, this.method, this.location, this.body, this.formElement);
        this.mustRedirect = mustRedirect;
    }
    get method() {
        var _a;
        const method = ((_a = this.submitter) === null || _a === void 0 ? void 0 : _a.getAttribute("formmethod")) || this.formElement.getAttribute("method") || "";
        return fetchMethodFromString(method.toLowerCase()) || FetchMethod.get;
    }
    get action() {
        var _a;
        const formElementAction = typeof this.formElement.action === "string" ? this.formElement.action : null;
        if ((_a = this.submitter) === null || _a === void 0 ? void 0 : _a.hasAttribute("formaction")) {
            return this.submitter.getAttribute("formaction") || "";
        }
        else {
            return this.formElement.getAttribute("action") || formElementAction || "";
        }
    }
    get body() {
        if (this.enctype == FormEnctype.urlEncoded || this.method == FetchMethod.get) {
            return new URLSearchParams(this.stringFormData);
        }
        else {
            return this.formData;
        }
    }
    get enctype() {
        var _a;
        return formEnctypeFromString(((_a = this.submitter) === null || _a === void 0 ? void 0 : _a.getAttribute("formenctype")) || this.formElement.enctype);
    }
    get isSafe() {
        return this.fetchRequest.isSafe;
    }
    get stringFormData() {
        return [...this.formData].reduce((entries, [name, value]) => {
            return entries.concat(typeof value == "string" ? [[name, value]] : []);
        }, []);
    }
    async start() {
        const { initialized, requesting } = FormSubmissionState;
        const confirmationMessage = getAttribute("data-turbo-confirm", this.submitter, this.formElement);
        if (typeof confirmationMessage === "string") {
            const answer = await FormSubmission.confirmMethod(confirmationMessage, this.formElement, this.submitter);
            if (!answer) {
                return;
            }
        }
        if (this.state == initialized) {
            this.state = requesting;
            return this.fetchRequest.perform();
        }
    }
    stop() {
        const { stopping, stopped } = FormSubmissionState;
        if (this.state != stopping && this.state != stopped) {
            this.state = stopping;
            this.fetchRequest.cancel();
            return true;
        }
    }
    prepareRequest(request) {
        if (!request.isSafe) {
            const token = getCookieValue(getMetaContent("csrf-param")) || getMetaContent("csrf-token");
            if (token) {
                request.headers["X-CSRF-Token"] = token;
            }
        }
        if (this.requestAcceptsTurboStreamResponse(request)) {
            request.acceptResponseType(StreamMessage.contentType);
        }
    }
    requestStarted(_request) {
        var _a;
        this.state = FormSubmissionState.waiting;
        (_a = this.submitter) === null || _a === void 0 ? void 0 : _a.setAttribute("disabled", "");
        this.setSubmitsWith();
        dispatch("turbo:submit-start", {
            target: this.formElement,
            detail: { formSubmission: this },
        });
        this.delegate.formSubmissionStarted(this);
    }
    requestPreventedHandlingResponse(request, response) {
        this.result = { success: response.succeeded, fetchResponse: response };
    }
    requestSucceededWithResponse(request, response) {
        if (response.clientError || response.serverError) {
            this.delegate.formSubmissionFailedWithResponse(this, response);
        }
        else if (this.requestMustRedirect(request) && responseSucceededWithoutRedirect(response)) {
            const error = new Error("Form responses must redirect to another location");
            this.delegate.formSubmissionErrored(this, error);
        }
        else {
            this.state = FormSubmissionState.receiving;
            this.result = { success: true, fetchResponse: response };
            this.delegate.formSubmissionSucceededWithResponse(this, response);
        }
    }
    requestFailedWithResponse(request, response) {
        this.result = { success: false, fetchResponse: response };
        this.delegate.formSubmissionFailedWithResponse(this, response);
    }
    requestErrored(request, error) {
        this.result = { success: false, error };
        this.delegate.formSubmissionErrored(this, error);
    }
    requestFinished(_request) {
        var _a;
        this.state = FormSubmissionState.stopped;
        (_a = this.submitter) === null || _a === void 0 ? void 0 : _a.removeAttribute("disabled");
        this.resetSubmitterText();
        dispatch("turbo:submit-end", {
            target: this.formElement,
            detail: Object.assign({ formSubmission: this }, this.result),
        });
        this.delegate.formSubmissionFinished(this);
    }
    setSubmitsWith() {
        if (!this.submitter || !this.submitsWith)
            return;
        if (this.submitter.matches("button")) {
            this.originalSubmitText = this.submitter.innerHTML;
            this.submitter.innerHTML = this.submitsWith;
        }
        else if (this.submitter.matches("input")) {
            const input = this.submitter;
            this.originalSubmitText = input.value;
            input.value = this.submitsWith;
        }
    }
    resetSubmitterText() {
        if (!this.submitter || !this.originalSubmitText)
            return;
        if (this.submitter.matches("button")) {
            this.submitter.innerHTML = this.originalSubmitText;
        }
        else if (this.submitter.matches("input")) {
            const input = this.submitter;
            input.value = this.originalSubmitText;
        }
    }
    requestMustRedirect(request) {
        return !request.isSafe && this.mustRedirect;
    }
    requestAcceptsTurboStreamResponse(request) {
        return !request.isSafe || hasAttribute("data-turbo-stream", this.submitter, this.formElement);
    }
    get submitsWith() {
        var _a;
        return (_a = this.submitter) === null || _a === void 0 ? void 0 : _a.getAttribute("data-turbo-submits-with");
    }
}
function buildFormData(formElement, submitter) {
    const formData = new FormData(formElement);
    const name = submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("name");
    const value = submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("value");
    if (name) {
        formData.append(name, value || "");
    }
    return formData;
}
function getCookieValue(cookieName) {
    if (cookieName != null) {
        const cookies = document.cookie ? document.cookie.split("; ") : [];
        const cookie = cookies.find((cookie) => cookie.startsWith(cookieName));
        if (cookie) {
            const value = cookie.split("=").slice(1).join("=");
            return value ? decodeURIComponent(value) : undefined;
        }
    }
}
function responseSucceededWithoutRedirect(response) {
    return response.statusCode == 200 && !response.redirected;
}
function mergeFormDataEntries(url, entries) {
    const searchParams = new URLSearchParams();
    for (const [name, value] of entries) {
        if (value instanceof File)
            continue;
        searchParams.append(name, value);
    }
    url.search = searchParams.toString();
    return url;
}

class Snapshot {
    constructor(element) {
        this.element = element;
    }
    get activeElement() {
        return this.element.ownerDocument.activeElement;
    }
    get children() {
        return [...this.element.children];
    }
    hasAnchor(anchor) {
        return this.getElementForAnchor(anchor) != null;
    }
    getElementForAnchor(anchor) {
        return anchor ? this.element.querySelector(`[id='${anchor}'], a[name='${anchor}']`) : null;
    }
    get isConnected() {
        return this.element.isConnected;
    }
    get firstAutofocusableElement() {
        const inertDisabledOrHidden = "[inert], :disabled, [hidden], details:not([open]), dialog:not([open])";
        for (const element of this.element.querySelectorAll("[autofocus]")) {
            if (element.closest(inertDisabledOrHidden) == null)
                return element;
            else
                continue;
        }
        return null;
    }
    get permanentElements() {
        return queryPermanentElementsAll(this.element);
    }
    getPermanentElementById(id) {
        return getPermanentElementById(this.element, id);
    }
    getPermanentElementMapForSnapshot(snapshot) {
        const permanentElementMap = {};
        for (const currentPermanentElement of this.permanentElements) {
            const { id } = currentPermanentElement;
            const newPermanentElement = snapshot.getPermanentElementById(id);
            if (newPermanentElement) {
                permanentElementMap[id] = [currentPermanentElement, newPermanentElement];
            }
        }
        return permanentElementMap;
    }
}
function getPermanentElementById(node, id) {
    return node.querySelector(`#${id}[data-turbo-permanent]`);
}
function queryPermanentElementsAll(node) {
    return node.querySelectorAll("[id][data-turbo-permanent]");
}

class FormSubmitObserver {
    constructor(delegate, eventTarget) {
        this.started = false;
        this.submitCaptured = () => {
            this.eventTarget.removeEventListener("submit", this.submitBubbled, false);
            this.eventTarget.addEventListener("submit", this.submitBubbled, false);
        };
        this.submitBubbled = ((event) => {
            if (!event.defaultPrevented) {
                const form = event.target instanceof HTMLFormElement ? event.target : undefined;
                const submitter = event.submitter || undefined;
                if (form &&
                    submissionDoesNotDismissDialog(form, submitter) &&
                    submissionDoesNotTargetIFrame(form, submitter) &&
                    this.delegate.willSubmitForm(form, submitter)) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    this.delegate.formSubmitted(form, submitter);
                }
            }
        });
        this.delegate = delegate;
        this.eventTarget = eventTarget;
    }
    start() {
        if (!this.started) {
            this.eventTarget.addEventListener("submit", this.submitCaptured, true);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.eventTarget.removeEventListener("submit", this.submitCaptured, true);
            this.started = false;
        }
    }
}
function submissionDoesNotDismissDialog(form, submitter) {
    const method = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formmethod")) || form.getAttribute("method");
    return method != "dialog";
}
function submissionDoesNotTargetIFrame(form, submitter) {
    if ((submitter === null || submitter === void 0 ? void 0 : submitter.hasAttribute("formtarget")) || form.hasAttribute("target")) {
        const target = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formtarget")) || form.target;
        for (const element of document.getElementsByName(target)) {
            if (element instanceof HTMLIFrameElement)
                return false;
        }
        return true;
    }
    else {
        return true;
    }
}

class View {
    constructor(delegate, element) {
        this.resolveRenderPromise = (_value) => { };
        this.resolveInterceptionPromise = (_value) => { };
        this.delegate = delegate;
        this.element = element;
    }
    scrollToAnchor(anchor) {
        const element = this.snapshot.getElementForAnchor(anchor);
        if (element) {
            this.scrollToElement(element);
            this.focusElement(element);
        }
        else {
            this.scrollToPosition({ x: 0, y: 0 });
        }
    }
    scrollToAnchorFromLocation(location) {
        this.scrollToAnchor(getAnchor(location));
    }
    scrollToElement(element) {
        element.scrollIntoView();
    }
    focusElement(element) {
        if (element instanceof HTMLElement) {
            if (element.hasAttribute("tabindex")) {
                element.focus();
            }
            else {
                element.setAttribute("tabindex", "-1");
                element.focus();
                element.removeAttribute("tabindex");
            }
        }
    }
    scrollToPosition({ x, y }) {
        this.scrollRoot.scrollTo(x, y);
    }
    scrollToTop() {
        this.scrollToPosition({ x: 0, y: 0 });
    }
    get scrollRoot() {
        return window;
    }
    async render(renderer) {
        const { isPreview, shouldRender, newSnapshot: snapshot } = renderer;
        if (shouldRender) {
            try {
                this.renderPromise = new Promise((resolve) => (this.resolveRenderPromise = resolve));
                this.renderer = renderer;
                await this.prepareToRenderSnapshot(renderer);
                const renderInterception = new Promise((resolve) => (this.resolveInterceptionPromise = resolve));
                const options = { resume: this.resolveInterceptionPromise, render: this.renderer.renderElement };
                const immediateRender = this.delegate.allowsImmediateRender(snapshot, options);
                if (!immediateRender)
                    await renderInterception;
                await this.renderSnapshot(renderer);
                this.delegate.viewRenderedSnapshot(snapshot, isPreview);
                this.delegate.preloadOnLoadLinksForView(this.element);
                this.finishRenderingSnapshot(renderer);
            }
            finally {
                delete this.renderer;
                this.resolveRenderPromise(undefined);
                delete this.renderPromise;
            }
        }
        else {
            this.invalidate(renderer.reloadReason);
        }
    }
    invalidate(reason) {
        this.delegate.viewInvalidated(reason);
    }
    async prepareToRenderSnapshot(renderer) {
        this.markAsPreview(renderer.isPreview);
        await renderer.prepareToRender();
    }
    markAsPreview(isPreview) {
        if (isPreview) {
            this.element.setAttribute("data-turbo-preview", "");
        }
        else {
            this.element.removeAttribute("data-turbo-preview");
        }
    }
    async renderSnapshot(renderer) {
        await renderer.render();
    }
    finishRenderingSnapshot(renderer) {
        renderer.finishRendering();
    }
}

class FrameView extends View {
    missing() {
        this.element.innerHTML = `<strong class="turbo-frame-error">Content missing</strong>`;
    }
    get snapshot() {
        return new Snapshot(this.element);
    }
}

class LinkInterceptor {
    constructor(delegate, element) {
        this.clickBubbled = (event) => {
            if (this.respondsToEventTarget(event.target)) {
                this.clickEvent = event;
            }
            else {
                delete this.clickEvent;
            }
        };
        this.linkClicked = ((event) => {
            if (this.clickEvent && this.respondsToEventTarget(event.target) && event.target instanceof Element) {
                if (this.delegate.shouldInterceptLinkClick(event.target, event.detail.url, event.detail.originalEvent)) {
                    this.clickEvent.preventDefault();
                    event.preventDefault();
                    this.delegate.linkClickIntercepted(event.target, event.detail.url, event.detail.originalEvent);
                }
            }
            delete this.clickEvent;
        });
        this.willVisit = ((_event) => {
            delete this.clickEvent;
        });
        this.delegate = delegate;
        this.element = element;
    }
    start() {
        this.element.addEventListener("click", this.clickBubbled);
        document.addEventListener("turbo:click", this.linkClicked);
        document.addEventListener("turbo:before-visit", this.willVisit);
    }
    stop() {
        this.element.removeEventListener("click", this.clickBubbled);
        document.removeEventListener("turbo:click", this.linkClicked);
        document.removeEventListener("turbo:before-visit", this.willVisit);
    }
    respondsToEventTarget(target) {
        const element = target instanceof Element ? target : target instanceof Node ? target.parentElement : null;
        return element && element.closest("turbo-frame, html") == this.element;
    }
}

class LinkClickObserver {
    constructor(delegate, eventTarget) {
        this.started = false;
        this.clickCaptured = () => {
            this.eventTarget.removeEventListener("click", this.clickBubbled, false);
            this.eventTarget.addEventListener("click", this.clickBubbled, false);
        };
        this.clickBubbled = (event) => {
            if (event instanceof MouseEvent && this.clickEventIsSignificant(event)) {
                const target = (event.composedPath && event.composedPath()[0]) || event.target;
                const link = this.findLinkFromClickTarget(target);
                if (link && doesNotTargetIFrame(link)) {
                    const location = this.getLocationForLink(link);
                    if (this.delegate.willFollowLinkToLocation(link, location, event)) {
                        event.preventDefault();
                        this.delegate.followedLinkToLocation(link, location);
                    }
                }
            }
        };
        this.delegate = delegate;
        this.eventTarget = eventTarget;
    }
    start() {
        if (!this.started) {
            this.eventTarget.addEventListener("click", this.clickCaptured, true);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.eventTarget.removeEventListener("click", this.clickCaptured, true);
            this.started = false;
        }
    }
    clickEventIsSignificant(event) {
        return !((event.target && event.target.isContentEditable) ||
            event.defaultPrevented ||
            event.which > 1 ||
            event.altKey ||
            event.ctrlKey ||
            event.metaKey ||
            event.shiftKey);
    }
    findLinkFromClickTarget(target) {
        return findClosestRecursively(target, "a[href]:not([target^=_]):not([download])");
    }
    getLocationForLink(link) {
        return expandURL(link.getAttribute("href") || "");
    }
}
function doesNotTargetIFrame(anchor) {
    if (anchor.hasAttribute("target")) {
        for (const element of document.getElementsByName(anchor.target)) {
            if (element instanceof HTMLIFrameElement)
                return false;
        }
        return true;
    }
    else {
        return true;
    }
}

class FormLinkClickObserver {
    constructor(delegate, element) {
        this.delegate = delegate;
        this.linkInterceptor = new LinkClickObserver(this, element);
    }
    start() {
        this.linkInterceptor.start();
    }
    stop() {
        this.linkInterceptor.stop();
    }
    willFollowLinkToLocation(link, location, originalEvent) {
        return (this.delegate.willSubmitFormLinkToLocation(link, location, originalEvent) &&
            link.hasAttribute("data-turbo-method"));
    }
    followedLinkToLocation(link, location) {
        const form = document.createElement("form");
        const type = "hidden";
        for (const [name, value] of location.searchParams) {
            form.append(Object.assign(document.createElement("input"), { type, name, value }));
        }
        const action = Object.assign(location, { search: "" });
        form.setAttribute("data-turbo", "true");
        form.setAttribute("action", action.href);
        form.setAttribute("hidden", "");
        const method = link.getAttribute("data-turbo-method");
        if (method)
            form.setAttribute("method", method);
        const turboFrame = link.getAttribute("data-turbo-frame");
        if (turboFrame)
            form.setAttribute("data-turbo-frame", turboFrame);
        const turboAction = getVisitAction(link);
        if (turboAction)
            form.setAttribute("data-turbo-action", turboAction);
        const turboConfirm = link.getAttribute("data-turbo-confirm");
        if (turboConfirm)
            form.setAttribute("data-turbo-confirm", turboConfirm);
        const turboStream = link.hasAttribute("data-turbo-stream");
        if (turboStream)
            form.setAttribute("data-turbo-stream", "");
        this.delegate.submittedFormLinkToLocation(link, location, form);
        document.body.appendChild(form);
        form.addEventListener("turbo:submit-end", () => form.remove(), { once: true });
        requestAnimationFrame(() => form.requestSubmit());
    }
}

class Bardo {
    static async preservingPermanentElements(delegate, permanentElementMap, callback) {
        const bardo = new this(delegate, permanentElementMap);
        bardo.enter();
        await callback();
        bardo.leave();
    }
    constructor(delegate, permanentElementMap) {
        this.delegate = delegate;
        this.permanentElementMap = permanentElementMap;
    }
    enter() {
        for (const id in this.permanentElementMap) {
            const [currentPermanentElement, newPermanentElement] = this.permanentElementMap[id];
            this.delegate.enteringBardo(currentPermanentElement, newPermanentElement);
            this.replaceNewPermanentElementWithPlaceholder(newPermanentElement);
        }
    }
    leave() {
        for (const id in this.permanentElementMap) {
            const [currentPermanentElement] = this.permanentElementMap[id];
            this.replaceCurrentPermanentElementWithClone(currentPermanentElement);
            this.replacePlaceholderWithPermanentElement(currentPermanentElement);
            this.delegate.leavingBardo(currentPermanentElement);
        }
    }
    replaceNewPermanentElementWithPlaceholder(permanentElement) {
        const placeholder = createPlaceholderForPermanentElement(permanentElement);
        permanentElement.replaceWith(placeholder);
    }
    replaceCurrentPermanentElementWithClone(permanentElement) {
        const clone = permanentElement.cloneNode(true);
        permanentElement.replaceWith(clone);
    }
    replacePlaceholderWithPermanentElement(permanentElement) {
        const placeholder = this.getPlaceholderById(permanentElement.id);
        placeholder === null || placeholder === void 0 ? void 0 : placeholder.replaceWith(permanentElement);
    }
    getPlaceholderById(id) {
        return this.placeholders.find((element) => element.content == id);
    }
    get placeholders() {
        return [...document.querySelectorAll("meta[name=turbo-permanent-placeholder][content]")];
    }
}
function createPlaceholderForPermanentElement(permanentElement) {
    const element = document.createElement("meta");
    element.setAttribute("name", "turbo-permanent-placeholder");
    element.setAttribute("content", permanentElement.id);
    return element;
}

class Renderer {
    constructor(currentSnapshot, newSnapshot, renderElement, isPreview, willRender = true) {
        this.activeElement = null;
        this.currentSnapshot = currentSnapshot;
        this.newSnapshot = newSnapshot;
        this.isPreview = isPreview;
        this.willRender = willRender;
        this.renderElement = renderElement;
        this.promise = new Promise((resolve, reject) => (this.resolvingFunctions = { resolve, reject }));
    }
    get shouldRender() {
        return true;
    }
    get reloadReason() {
        return;
    }
    prepareToRender() {
        return;
    }
    finishRendering() {
        if (this.resolvingFunctions) {
            this.resolvingFunctions.resolve();
            delete this.resolvingFunctions;
        }
    }
    async preservingPermanentElements(callback) {
        await Bardo.preservingPermanentElements(this, this.permanentElementMap, callback);
    }
    focusFirstAutofocusableElement() {
        const element = this.connectedSnapshot.firstAutofocusableElement;
        if (elementIsFocusable(element)) {
            element.focus();
        }
    }
    enteringBardo(currentPermanentElement) {
        if (this.activeElement)
            return;
        if (currentPermanentElement.contains(this.currentSnapshot.activeElement)) {
            this.activeElement = this.currentSnapshot.activeElement;
        }
    }
    leavingBardo(currentPermanentElement) {
        if (currentPermanentElement.contains(this.activeElement) && this.activeElement instanceof HTMLElement) {
            this.activeElement.focus();
            this.activeElement = null;
        }
    }
    get connectedSnapshot() {
        return this.newSnapshot.isConnected ? this.newSnapshot : this.currentSnapshot;
    }
    get currentElement() {
        return this.currentSnapshot.element;
    }
    get newElement() {
        return this.newSnapshot.element;
    }
    get permanentElementMap() {
        return this.currentSnapshot.getPermanentElementMapForSnapshot(this.newSnapshot);
    }
}
function elementIsFocusable(element) {
    return element && typeof element.focus == "function";
}

class FrameRenderer extends Renderer {
    static renderElement(currentElement, newElement) {
        var _a;
        const destinationRange = document.createRange();
        destinationRange.selectNodeContents(currentElement);
        destinationRange.deleteContents();
        const frameElement = newElement;
        const sourceRange = (_a = frameElement.ownerDocument) === null || _a === void 0 ? void 0 : _a.createRange();
        if (sourceRange) {
            sourceRange.selectNodeContents(frameElement);
            currentElement.appendChild(sourceRange.extractContents());
        }
    }
    constructor(delegate, currentSnapshot, newSnapshot, renderElement, isPreview, willRender = true) {
        super(currentSnapshot, newSnapshot, renderElement, isPreview, willRender);
        this.delegate = delegate;
    }
    get shouldRender() {
        return true;
    }
    async render() {
        await nextAnimationFrame();
        this.preservingPermanentElements(() => {
            this.loadFrameElement();
        });
        this.scrollFrameIntoView();
        await nextAnimationFrame();
        this.focusFirstAutofocusableElement();
        await nextAnimationFrame();
        this.activateScriptElements();
    }
    loadFrameElement() {
        this.delegate.willRenderFrame(this.currentElement, this.newElement);
        this.renderElement(this.currentElement, this.newElement);
    }
    scrollFrameIntoView() {
        if (this.currentElement.autoscroll || this.newElement.autoscroll) {
            const element = this.currentElement.firstElementChild;
            const block = readScrollLogicalPosition(this.currentElement.getAttribute("data-autoscroll-block"), "end");
            const behavior = readScrollBehavior(this.currentElement.getAttribute("data-autoscroll-behavior"), "auto");
            if (element) {
                element.scrollIntoView({ block, behavior });
                return true;
            }
        }
        return false;
    }
    activateScriptElements() {
        for (const inertScriptElement of this.newScriptElements) {
            const activatedScriptElement = activateScriptElement(inertScriptElement);
            inertScriptElement.replaceWith(activatedScriptElement);
        }
    }
    get newScriptElements() {
        return this.currentElement.querySelectorAll("script");
    }
}
function readScrollLogicalPosition(value, defaultValue) {
    if (value == "end" || value == "start" || value == "center" || value == "nearest") {
        return value;
    }
    else {
        return defaultValue;
    }
}
function readScrollBehavior(value, defaultValue) {
    if (value == "auto" || value == "smooth") {
        return value;
    }
    else {
        return defaultValue;
    }
}

class ProgressBar {
    static get defaultCSS() {
        return unindent `
      .turbo-progress-bar {
        position: fixed;
        display: block;
        top: 0;
        left: 0;
        height: 3px;
        background: #0076ff;
        z-index: 2147483647;
        transition:
          width ${ProgressBar.animationDuration}ms ease-out,
          opacity ${ProgressBar.animationDuration / 2}ms ${ProgressBar.animationDuration / 2}ms ease-in;
        transform: translate3d(0, 0, 0);
      }
    `;
    }
    constructor() {
        this.hiding = false;
        this.value = 0;
        this.visible = false;
        this.trickle = () => {
            this.setValue(this.value + Math.random() / 100);
        };
        this.stylesheetElement = this.createStylesheetElement();
        this.progressElement = this.createProgressElement();
        this.installStylesheetElement();
        this.setValue(0);
    }
    show() {
        if (!this.visible) {
            this.visible = true;
            this.installProgressElement();
            this.startTrickling();
        }
    }
    hide() {
        if (this.visible && !this.hiding) {
            this.hiding = true;
            this.fadeProgressElement(() => {
                this.uninstallProgressElement();
                this.stopTrickling();
                this.visible = false;
                this.hiding = false;
            });
        }
    }
    setValue(value) {
        this.value = value;
        this.refresh();
    }
    installStylesheetElement() {
        document.head.insertBefore(this.stylesheetElement, document.head.firstChild);
    }
    installProgressElement() {
        this.progressElement.style.width = "0";
        this.progressElement.style.opacity = "1";
        document.documentElement.insertBefore(this.progressElement, document.body);
        this.refresh();
    }
    fadeProgressElement(callback) {
        this.progressElement.style.opacity = "0";
        setTimeout(callback, ProgressBar.animationDuration * 1.5);
    }
    uninstallProgressElement() {
        if (this.progressElement.parentNode) {
            document.documentElement.removeChild(this.progressElement);
        }
    }
    startTrickling() {
        if (!this.trickleInterval) {
            this.trickleInterval = window.setInterval(this.trickle, ProgressBar.animationDuration);
        }
    }
    stopTrickling() {
        window.clearInterval(this.trickleInterval);
        delete this.trickleInterval;
    }
    refresh() {
        requestAnimationFrame(() => {
            this.progressElement.style.width = `${10 + this.value * 90}%`;
        });
    }
    createStylesheetElement() {
        const element = document.createElement("style");
        element.type = "text/css";
        element.textContent = ProgressBar.defaultCSS;
        if (this.cspNonce) {
            element.nonce = this.cspNonce;
        }
        return element;
    }
    createProgressElement() {
        const element = document.createElement("div");
        element.className = "turbo-progress-bar";
        return element;
    }
    get cspNonce() {
        return getMetaContent("csp-nonce");
    }
}
ProgressBar.animationDuration = 300;

class HeadSnapshot extends Snapshot {
    constructor() {
        super(...arguments);
        this.detailsByOuterHTML = this.children
            .filter((element) => !elementIsNoscript(element))
            .map((element) => elementWithoutNonce(element))
            .reduce((result, element) => {
            const { outerHTML } = element;
            const details = outerHTML in result
                ? result[outerHTML]
                : {
                    type: elementType(element),
                    tracked: elementIsTracked(element),
                    elements: [],
                };
            return Object.assign(Object.assign({}, result), { [outerHTML]: Object.assign(Object.assign({}, details), { elements: [...details.elements, element] }) });
        }, {});
    }
    get trackedElementSignature() {
        return Object.keys(this.detailsByOuterHTML)
            .filter((outerHTML) => this.detailsByOuterHTML[outerHTML].tracked)
            .join("");
    }
    getScriptElementsNotInSnapshot(snapshot) {
        return this.getElementsMatchingTypeNotInSnapshot("script", snapshot);
    }
    getStylesheetElementsNotInSnapshot(snapshot) {
        return this.getElementsMatchingTypeNotInSnapshot("stylesheet", snapshot);
    }
    getElementsMatchingTypeNotInSnapshot(matchedType, snapshot) {
        return Object.keys(this.detailsByOuterHTML)
            .filter((outerHTML) => !(outerHTML in snapshot.detailsByOuterHTML))
            .map((outerHTML) => this.detailsByOuterHTML[outerHTML])
            .filter(({ type }) => type == matchedType)
            .map(({ elements: [element] }) => element);
    }
    get provisionalElements() {
        return Object.keys(this.detailsByOuterHTML).reduce((result, outerHTML) => {
            const { type, tracked, elements } = this.detailsByOuterHTML[outerHTML];
            if (type == null && !tracked) {
                return [...result, ...elements];
            }
            else if (elements.length > 1) {
                return [...result, ...elements.slice(1)];
            }
            else {
                return result;
            }
        }, []);
    }
    getMetaValue(name) {
        const element = this.findMetaElementByName(name);
        return element ? element.getAttribute("content") : null;
    }
    findMetaElementByName(name) {
        return Object.keys(this.detailsByOuterHTML).reduce((result, outerHTML) => {
            const { elements: [element], } = this.detailsByOuterHTML[outerHTML];
            return elementIsMetaElementWithName(element, name) ? element : result;
        }, undefined);
    }
}
function elementType(element) {
    if (elementIsScript(element)) {
        return "script";
    }
    else if (elementIsStylesheet(element)) {
        return "stylesheet";
    }
}
function elementIsTracked(element) {
    return element.getAttribute("data-turbo-track") == "reload";
}
function elementIsScript(element) {
    const tagName = element.localName;
    return tagName == "script";
}
function elementIsNoscript(element) {
    const tagName = element.localName;
    return tagName == "noscript";
}
function elementIsStylesheet(element) {
    const tagName = element.localName;
    return tagName == "style" || (tagName == "link" && element.getAttribute("rel") == "stylesheet");
}
function elementIsMetaElementWithName(element, name) {
    const tagName = element.localName;
    return tagName == "meta" && element.getAttribute("name") == name;
}
function elementWithoutNonce(element) {
    if (element.hasAttribute("nonce")) {
        element.setAttribute("nonce", "");
    }
    return element;
}

class PageSnapshot extends Snapshot {
    static fromHTMLString(html = "") {
        return this.fromDocument(parseHTMLDocument(html));
    }
    static fromElement(element) {
        return this.fromDocument(element.ownerDocument);
    }
    static fromDocument({ head, body }) {
        return new this(body, new HeadSnapshot(head));
    }
    constructor(element, headSnapshot) {
        super(element);
        this.headSnapshot = headSnapshot;
    }
    clone() {
        const clonedElement = this.element.cloneNode(true);
        const selectElements = this.element.querySelectorAll("select");
        const clonedSelectElements = clonedElement.querySelectorAll("select");
        for (const [index, source] of selectElements.entries()) {
            const clone = clonedSelectElements[index];
            for (const option of clone.selectedOptions)
                option.selected = false;
            for (const option of source.selectedOptions)
                clone.options[option.index].selected = true;
        }
        for (const clonedPasswordInput of clonedElement.querySelectorAll('input[type="password"]')) {
            clonedPasswordInput.value = "";
        }
        return new PageSnapshot(clonedElement, this.headSnapshot);
    }
    get headElement() {
        return this.headSnapshot.element;
    }
    get rootLocation() {
        var _a;
        const root = (_a = this.getSetting("root")) !== null && _a !== void 0 ? _a : "/";
        return expandURL(root);
    }
    get cacheControlValue() {
        return this.getSetting("cache-control");
    }
    get isPreviewable() {
        return this.cacheControlValue != "no-preview";
    }
    get isCacheable() {
        return this.cacheControlValue != "no-cache";
    }
    get isVisitable() {
        return this.getSetting("visit-control") != "reload";
    }
    getSetting(name) {
        return this.headSnapshot.getMetaValue(`turbo-${name}`);
    }
}

var TimingMetric;
(function (TimingMetric) {
    TimingMetric["visitStart"] = "visitStart";
    TimingMetric["requestStart"] = "requestStart";
    TimingMetric["requestEnd"] = "requestEnd";
    TimingMetric["visitEnd"] = "visitEnd";
})(TimingMetric || (TimingMetric = {}));
var VisitState;
(function (VisitState) {
    VisitState["initialized"] = "initialized";
    VisitState["started"] = "started";
    VisitState["canceled"] = "canceled";
    VisitState["failed"] = "failed";
    VisitState["completed"] = "completed";
})(VisitState || (VisitState = {}));
const defaultOptions = {
    action: "advance",
    historyChanged: false,
    visitCachedSnapshot: () => { },
    willRender: true,
    updateHistory: true,
    shouldCacheSnapshot: true,
    acceptsStreamResponse: false,
};
var SystemStatusCode;
(function (SystemStatusCode) {
    SystemStatusCode[SystemStatusCode["networkFailure"] = 0] = "networkFailure";
    SystemStatusCode[SystemStatusCode["timeoutFailure"] = -1] = "timeoutFailure";
    SystemStatusCode[SystemStatusCode["contentTypeMismatch"] = -2] = "contentTypeMismatch";
})(SystemStatusCode || (SystemStatusCode = {}));
class Visit {
    constructor(delegate, location, restorationIdentifier, options = {}) {
        this.identifier = uuid();
        this.timingMetrics = {};
        this.followedRedirect = false;
        this.historyChanged = false;
        this.scrolled = false;
        this.shouldCacheSnapshot = true;
        this.acceptsStreamResponse = false;
        this.snapshotCached = false;
        this.state = VisitState.initialized;
        this.delegate = delegate;
        this.location = location;
        this.restorationIdentifier = restorationIdentifier || uuid();
        const { action, historyChanged, referrer, snapshot, snapshotHTML, response, visitCachedSnapshot, willRender, updateHistory, shouldCacheSnapshot, acceptsStreamResponse, } = Object.assign(Object.assign({}, defaultOptions), options);
        this.action = action;
        this.historyChanged = historyChanged;
        this.referrer = referrer;
        this.snapshot = snapshot;
        this.snapshotHTML = snapshotHTML;
        this.response = response;
        this.isSamePage = this.delegate.locationWithActionIsSamePage(this.location, this.action);
        this.visitCachedSnapshot = visitCachedSnapshot;
        this.willRender = willRender;
        this.updateHistory = updateHistory;
        this.scrolled = !willRender;
        this.shouldCacheSnapshot = shouldCacheSnapshot;
        this.acceptsStreamResponse = acceptsStreamResponse;
    }
    get adapter() {
        return this.delegate.adapter;
    }
    get view() {
        return this.delegate.view;
    }
    get history() {
        return this.delegate.history;
    }
    get restorationData() {
        return this.history.getRestorationDataForIdentifier(this.restorationIdentifier);
    }
    get silent() {
        return this.isSamePage;
    }
    start() {
        if (this.state == VisitState.initialized) {
            this.recordTimingMetric(TimingMetric.visitStart);
            this.state = VisitState.started;
            this.adapter.visitStarted(this);
            this.delegate.visitStarted(this);
        }
    }
    cancel() {
        if (this.state == VisitState.started) {
            if (this.request) {
                this.request.cancel();
            }
            this.cancelRender();
            this.state = VisitState.canceled;
        }
    }
    complete() {
        if (this.state == VisitState.started) {
            this.recordTimingMetric(TimingMetric.visitEnd);
            this.state = VisitState.completed;
            this.followRedirect();
            if (!this.followedRedirect) {
                this.adapter.visitCompleted(this);
                this.delegate.visitCompleted(this);
            }
        }
    }
    fail() {
        if (this.state == VisitState.started) {
            this.state = VisitState.failed;
            this.adapter.visitFailed(this);
        }
    }
    changeHistory() {
        var _a;
        if (!this.historyChanged && this.updateHistory) {
            const actionForHistory = this.location.href === ((_a = this.referrer) === null || _a === void 0 ? void 0 : _a.href) ? "replace" : this.action;
            const method = getHistoryMethodForAction(actionForHistory);
            this.history.update(method, this.location, this.restorationIdentifier);
            this.historyChanged = true;
        }
    }
    issueRequest() {
        if (this.hasPreloadedResponse()) {
            this.simulateRequest();
        }
        else if (this.shouldIssueRequest() && !this.request) {
            this.request = new FetchRequest(this, FetchMethod.get, this.location);
            this.request.perform();
        }
    }
    simulateRequest() {
        if (this.response) {
            this.startRequest();
            this.recordResponse();
            this.finishRequest();
        }
    }
    startRequest() {
        this.recordTimingMetric(TimingMetric.requestStart);
        this.adapter.visitRequestStarted(this);
    }
    recordResponse(response = this.response) {
        this.response = response;
        if (response) {
            const { statusCode } = response;
            if (isSuccessful(statusCode)) {
                this.adapter.visitRequestCompleted(this);
            }
            else {
                this.adapter.visitRequestFailedWithStatusCode(this, statusCode);
            }
        }
    }
    finishRequest() {
        this.recordTimingMetric(TimingMetric.requestEnd);
        this.adapter.visitRequestFinished(this);
    }
    loadResponse() {
        if (this.response) {
            const { statusCode, responseHTML } = this.response;
            this.render(async () => {
                if (this.shouldCacheSnapshot)
                    this.cacheSnapshot();
                if (this.view.renderPromise)
                    await this.view.renderPromise;
                if (isSuccessful(statusCode) && responseHTML != null) {
                    await this.view.renderPage(PageSnapshot.fromHTMLString(responseHTML), false, this.willRender, this);
                    this.performScroll();
                    this.adapter.visitRendered(this);
                    this.complete();
                }
                else {
                    await this.view.renderError(PageSnapshot.fromHTMLString(responseHTML), this);
                    this.adapter.visitRendered(this);
                    this.fail();
                }
            });
        }
    }
    getCachedSnapshot() {
        const snapshot = this.view.getCachedSnapshotForLocation(this.location) || this.getPreloadedSnapshot();
        if (snapshot && (!getAnchor(this.location) || snapshot.hasAnchor(getAnchor(this.location)))) {
            if (this.action == "restore" || snapshot.isPreviewable) {
                return snapshot;
            }
        }
    }
    getPreloadedSnapshot() {
        if (this.snapshotHTML) {
            return PageSnapshot.fromHTMLString(this.snapshotHTML);
        }
    }
    hasCachedSnapshot() {
        return this.getCachedSnapshot() != null;
    }
    loadCachedSnapshot() {
        const snapshot = this.getCachedSnapshot();
        if (snapshot) {
            const isPreview = this.shouldIssueRequest();
            this.render(async () => {
                this.cacheSnapshot();
                if (this.isSamePage) {
                    this.adapter.visitRendered(this);
                }
                else {
                    if (this.view.renderPromise)
                        await this.view.renderPromise;
                    await this.view.renderPage(snapshot, isPreview, this.willRender, this);
                    this.performScroll();
                    this.adapter.visitRendered(this);
                    if (!isPreview) {
                        this.complete();
                    }
                }
            });
        }
    }
    followRedirect() {
        var _a;
        if (this.redirectedToLocation && !this.followedRedirect && ((_a = this.response) === null || _a === void 0 ? void 0 : _a.redirected)) {
            this.adapter.visitProposedToLocation(this.redirectedToLocation, {
                action: "replace",
                response: this.response,
                shouldCacheSnapshot: false,
                willRender: false,
            });
            this.followedRedirect = true;
        }
    }
    goToSamePageAnchor() {
        if (this.isSamePage) {
            this.render(async () => {
                this.cacheSnapshot();
                this.performScroll();
                this.changeHistory();
                this.adapter.visitRendered(this);
            });
        }
    }
    prepareRequest(request) {
        if (this.acceptsStreamResponse) {
            request.acceptResponseType(StreamMessage.contentType);
        }
    }
    requestStarted() {
        this.startRequest();
    }
    requestPreventedHandlingResponse(_request, _response) { }
    async requestSucceededWithResponse(request, response) {
        const responseHTML = await response.responseHTML;
        const { redirected, statusCode } = response;
        if (responseHTML == undefined) {
            this.recordResponse({
                statusCode: SystemStatusCode.contentTypeMismatch,
                redirected,
            });
        }
        else {
            this.redirectedToLocation = response.redirected ? response.location : undefined;
            this.recordResponse({ statusCode: statusCode, responseHTML, redirected });
        }
    }
    async requestFailedWithResponse(request, response) {
        const responseHTML = await response.responseHTML;
        const { redirected, statusCode } = response;
        if (responseHTML == undefined) {
            this.recordResponse({
                statusCode: SystemStatusCode.contentTypeMismatch,
                redirected,
            });
        }
        else {
            this.recordResponse({ statusCode: statusCode, responseHTML, redirected });
        }
    }
    requestErrored(_request, _error) {
        this.recordResponse({
            statusCode: SystemStatusCode.networkFailure,
            redirected: false,
        });
    }
    requestFinished() {
        this.finishRequest();
    }
    performScroll() {
        if (!this.scrolled && !this.view.forceReloaded) {
            if (this.action == "restore") {
                this.scrollToRestoredPosition() || this.scrollToAnchor() || this.view.scrollToTop();
            }
            else {
                this.scrollToAnchor() || this.view.scrollToTop();
            }
            if (this.isSamePage) {
                this.delegate.visitScrolledToSamePageLocation(this.view.lastRenderedLocation, this.location);
            }
            this.scrolled = true;
        }
    }
    scrollToRestoredPosition() {
        const { scrollPosition } = this.restorationData;
        if (scrollPosition) {
            this.view.scrollToPosition(scrollPosition);
            return true;
        }
    }
    scrollToAnchor() {
        const anchor = getAnchor(this.location);
        if (anchor != null) {
            this.view.scrollToAnchor(anchor);
            return true;
        }
    }
    recordTimingMetric(metric) {
        this.timingMetrics[metric] = new Date().getTime();
    }
    getTimingMetrics() {
        return Object.assign({}, this.timingMetrics);
    }
    getHistoryMethodForAction(action) {
        switch (action) {
            case "replace":
                return history.replaceState;
            case "advance":
            case "restore":
                return history.pushState;
        }
    }
    hasPreloadedResponse() {
        return typeof this.response == "object";
    }
    shouldIssueRequest() {
        if (this.isSamePage) {
            return false;
        }
        else if (this.action == "restore") {
            return !this.hasCachedSnapshot();
        }
        else {
            return this.willRender;
        }
    }
    cacheSnapshot() {
        if (!this.snapshotCached) {
            this.view.cacheSnapshot(this.snapshot).then((snapshot) => snapshot && this.visitCachedSnapshot(snapshot));
            this.snapshotCached = true;
        }
    }
    async render(callback) {
        this.cancelRender();
        await new Promise((resolve) => {
            this.frame = requestAnimationFrame(() => resolve());
        });
        await callback();
        delete this.frame;
    }
    cancelRender() {
        if (this.frame) {
            cancelAnimationFrame(this.frame);
            delete this.frame;
        }
    }
}
function isSuccessful(statusCode) {
    return statusCode >= 200 && statusCode < 300;
}

class BrowserAdapter {
    constructor(session) {
        this.progressBar = new ProgressBar();
        this.showProgressBar = () => {
            this.progressBar.show();
        };
        this.session = session;
    }
    visitProposedToLocation(location, options) {
        this.navigator.startVisit(location, (options === null || options === void 0 ? void 0 : options.restorationIdentifier) || uuid(), options);
    }
    visitStarted(visit) {
        this.location = visit.location;
        visit.loadCachedSnapshot();
        visit.issueRequest();
        visit.goToSamePageAnchor();
    }
    visitRequestStarted(visit) {
        this.progressBar.setValue(0);
        if (visit.hasCachedSnapshot() || visit.action != "restore") {
            this.showVisitProgressBarAfterDelay();
        }
        else {
            this.showProgressBar();
        }
    }
    visitRequestCompleted(visit) {
        visit.loadResponse();
    }
    visitRequestFailedWithStatusCode(visit, statusCode) {
        switch (statusCode) {
            case SystemStatusCode.networkFailure:
            case SystemStatusCode.timeoutFailure:
            case SystemStatusCode.contentTypeMismatch:
                return this.reload({
                    reason: "request_failed",
                    context: {
                        statusCode,
                    },
                });
            default:
                return visit.loadResponse();
        }
    }
    visitRequestFinished(_visit) {
        this.progressBar.setValue(1);
        this.hideVisitProgressBar();
    }
    visitCompleted(_visit) { }
    pageInvalidated(reason) {
        this.reload(reason);
    }
    visitFailed(_visit) { }
    visitRendered(_visit) { }
    formSubmissionStarted(_formSubmission) {
        this.progressBar.setValue(0);
        this.showFormProgressBarAfterDelay();
    }
    formSubmissionFinished(_formSubmission) {
        this.progressBar.setValue(1);
        this.hideFormProgressBar();
    }
    showVisitProgressBarAfterDelay() {
        this.visitProgressBarTimeout = window.setTimeout(this.showProgressBar, this.session.progressBarDelay);
    }
    hideVisitProgressBar() {
        this.progressBar.hide();
        if (this.visitProgressBarTimeout != null) {
            window.clearTimeout(this.visitProgressBarTimeout);
            delete this.visitProgressBarTimeout;
        }
    }
    showFormProgressBarAfterDelay() {
        if (this.formProgressBarTimeout == null) {
            this.formProgressBarTimeout = window.setTimeout(this.showProgressBar, this.session.progressBarDelay);
        }
    }
    hideFormProgressBar() {
        this.progressBar.hide();
        if (this.formProgressBarTimeout != null) {
            window.clearTimeout(this.formProgressBarTimeout);
            delete this.formProgressBarTimeout;
        }
    }
    reload(reason) {
        var _a;
        dispatch("turbo:reload", { detail: reason });
        window.location.href = ((_a = this.location) === null || _a === void 0 ? void 0 : _a.toString()) || window.location.href;
    }
    get navigator() {
        return this.session.navigator;
    }
}

class CacheObserver {
    constructor() {
        this.selector = "[data-turbo-temporary]";
        this.deprecatedSelector = "[data-turbo-cache=false]";
        this.started = false;
        this.removeTemporaryElements = ((_event) => {
            for (const element of this.temporaryElements) {
                element.remove();
            }
        });
    }
    start() {
        if (!this.started) {
            this.started = true;
            addEventListener("turbo:before-cache", this.removeTemporaryElements, false);
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            removeEventListener("turbo:before-cache", this.removeTemporaryElements, false);
        }
    }
    get temporaryElements() {
        return [...document.querySelectorAll(this.selector), ...this.temporaryElementsWithDeprecation];
    }
    get temporaryElementsWithDeprecation() {
        const elements = document.querySelectorAll(this.deprecatedSelector);
        if (elements.length) {
            console.warn(`The ${this.deprecatedSelector} selector is deprecated and will be removed in a future version. Use ${this.selector} instead.`);
        }
        return [...elements];
    }
}

class FrameRedirector {
    constructor(session, element) {
        this.session = session;
        this.element = element;
        this.linkInterceptor = new LinkInterceptor(this, element);
        this.formSubmitObserver = new FormSubmitObserver(this, element);
    }
    start() {
        this.linkInterceptor.start();
        this.formSubmitObserver.start();
    }
    stop() {
        this.linkInterceptor.stop();
        this.formSubmitObserver.stop();
    }
    shouldInterceptLinkClick(element, _location, _event) {
        return this.shouldRedirect(element);
    }
    linkClickIntercepted(element, url, event) {
        const frame = this.findFrameElement(element);
        if (frame) {
            frame.delegate.linkClickIntercepted(element, url, event);
        }
    }
    willSubmitForm(element, submitter) {
        return (element.closest("turbo-frame") == null &&
            this.shouldSubmit(element, submitter) &&
            this.shouldRedirect(element, submitter));
    }
    formSubmitted(element, submitter) {
        const frame = this.findFrameElement(element, submitter);
        if (frame) {
            frame.delegate.formSubmitted(element, submitter);
        }
    }
    shouldSubmit(form, submitter) {
        var _a;
        const action = getAction(form, submitter);
        const meta = this.element.ownerDocument.querySelector(`meta[name="turbo-root"]`);
        const rootLocation = expandURL((_a = meta === null || meta === void 0 ? void 0 : meta.content) !== null && _a !== void 0 ? _a : "/");
        return this.shouldRedirect(form, submitter) && locationIsVisitable(action, rootLocation);
    }
    shouldRedirect(element, submitter) {
        const isNavigatable = element instanceof HTMLFormElement
            ? this.session.submissionIsNavigatable(element, submitter)
            : this.session.elementIsNavigatable(element);
        if (isNavigatable) {
            const frame = this.findFrameElement(element, submitter);
            return frame ? frame != element.closest("turbo-frame") : false;
        }
        else {
            return false;
        }
    }
    findFrameElement(element, submitter) {
        const id = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("data-turbo-frame")) || element.getAttribute("data-turbo-frame");
        if (id && id != "_top") {
            const frame = this.element.querySelector(`#${id}:not([disabled])`);
            if (frame instanceof FrameElement) {
                return frame;
            }
        }
    }
}

class History {
    constructor(delegate) {
        this.restorationIdentifier = uuid();
        this.restorationData = {};
        this.started = false;
        this.pageLoaded = false;
        this.onPopState = (event) => {
            if (this.shouldHandlePopState()) {
                const { turbo } = event.state || {};
                if (turbo) {
                    this.location = new URL(window.location.href);
                    const { restorationIdentifier } = turbo;
                    this.restorationIdentifier = restorationIdentifier;
                    this.delegate.historyPoppedToLocationWithRestorationIdentifier(this.location, restorationIdentifier);
                }
            }
        };
        this.onPageLoad = async (_event) => {
            await nextMicrotask();
            this.pageLoaded = true;
        };
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            addEventListener("popstate", this.onPopState, false);
            addEventListener("load", this.onPageLoad, false);
            this.started = true;
            this.replace(new URL(window.location.href));
        }
    }
    stop() {
        if (this.started) {
            removeEventListener("popstate", this.onPopState, false);
            removeEventListener("load", this.onPageLoad, false);
            this.started = false;
        }
    }
    push(location, restorationIdentifier) {
        this.update(history.pushState, location, restorationIdentifier);
    }
    replace(location, restorationIdentifier) {
        this.update(history.replaceState, location, restorationIdentifier);
    }
    update(method, location, restorationIdentifier = uuid()) {
        const state = { turbo: { restorationIdentifier } };
        method.call(history, state, "", location.href);
        this.location = location;
        this.restorationIdentifier = restorationIdentifier;
    }
    getRestorationDataForIdentifier(restorationIdentifier) {
        return this.restorationData[restorationIdentifier] || {};
    }
    updateRestorationData(additionalData) {
        const { restorationIdentifier } = this;
        const restorationData = this.restorationData[restorationIdentifier];
        this.restorationData[restorationIdentifier] = Object.assign(Object.assign({}, restorationData), additionalData);
    }
    assumeControlOfScrollRestoration() {
        var _a;
        if (!this.previousScrollRestoration) {
            this.previousScrollRestoration = (_a = history.scrollRestoration) !== null && _a !== void 0 ? _a : "auto";
            history.scrollRestoration = "manual";
        }
    }
    relinquishControlOfScrollRestoration() {
        if (this.previousScrollRestoration) {
            history.scrollRestoration = this.previousScrollRestoration;
            delete this.previousScrollRestoration;
        }
    }
    shouldHandlePopState() {
        return this.pageIsLoaded();
    }
    pageIsLoaded() {
        return this.pageLoaded || document.readyState == "complete";
    }
}

class Navigator {
    constructor(delegate) {
        this.delegate = delegate;
    }
    proposeVisit(location, options = {}) {
        if (this.delegate.allowsVisitingLocationWithAction(location, options.action)) {
            if (locationIsVisitable(location, this.view.snapshot.rootLocation)) {
                this.delegate.visitProposedToLocation(location, options);
            }
            else {
                window.location.href = location.toString();
            }
        }
    }
    startVisit(locatable, restorationIdentifier, options = {}) {
        this.stop();
        this.currentVisit = new Visit(this, expandURL(locatable), restorationIdentifier, Object.assign({ referrer: this.location }, options));
        this.currentVisit.start();
    }
    submitForm(form, submitter) {
        this.stop();
        this.formSubmission = new FormSubmission(this, form, submitter, true);
        this.formSubmission.start();
    }
    stop() {
        if (this.formSubmission) {
            this.formSubmission.stop();
            delete this.formSubmission;
        }
        if (this.currentVisit) {
            this.currentVisit.cancel();
            delete this.currentVisit;
        }
    }
    get adapter() {
        return this.delegate.adapter;
    }
    get view() {
        return this.delegate.view;
    }
    get history() {
        return this.delegate.history;
    }
    formSubmissionStarted(formSubmission) {
        if (typeof this.adapter.formSubmissionStarted === "function") {
            this.adapter.formSubmissionStarted(formSubmission);
        }
    }
    async formSubmissionSucceededWithResponse(formSubmission, fetchResponse) {
        if (formSubmission == this.formSubmission) {
            const responseHTML = await fetchResponse.responseHTML;
            if (responseHTML) {
                const shouldCacheSnapshot = formSubmission.isSafe;
                if (!shouldCacheSnapshot) {
                    this.view.clearSnapshotCache();
                }
                const { statusCode, redirected } = fetchResponse;
                const action = this.getActionForFormSubmission(formSubmission);
                const visitOptions = {
                    action,
                    shouldCacheSnapshot,
                    response: { statusCode, responseHTML, redirected },
                };
                this.proposeVisit(fetchResponse.location, visitOptions);
            }
        }
    }
    async formSubmissionFailedWithResponse(formSubmission, fetchResponse) {
        const responseHTML = await fetchResponse.responseHTML;
        if (responseHTML) {
            const snapshot = PageSnapshot.fromHTMLString(responseHTML);
            if (fetchResponse.serverError) {
                await this.view.renderError(snapshot, this.currentVisit);
            }
            else {
                await this.view.renderPage(snapshot, false, true, this.currentVisit);
            }
            this.view.scrollToTop();
            this.view.clearSnapshotCache();
        }
    }
    formSubmissionErrored(formSubmission, error) {
        console.error(error);
    }
    formSubmissionFinished(formSubmission) {
        if (typeof this.adapter.formSubmissionFinished === "function") {
            this.adapter.formSubmissionFinished(formSubmission);
        }
    }
    visitStarted(visit) {
        this.delegate.visitStarted(visit);
    }
    visitCompleted(visit) {
        this.delegate.visitCompleted(visit);
    }
    locationWithActionIsSamePage(location, action) {
        const anchor = getAnchor(location);
        const currentAnchor = getAnchor(this.view.lastRenderedLocation);
        const isRestorationToTop = action === "restore" && typeof anchor === "undefined";
        return (action !== "replace" &&
            getRequestURL(location) === getRequestURL(this.view.lastRenderedLocation) &&
            (isRestorationToTop || (anchor != null && anchor !== currentAnchor)));
    }
    visitScrolledToSamePageLocation(oldURL, newURL) {
        this.delegate.visitScrolledToSamePageLocation(oldURL, newURL);
    }
    get location() {
        return this.history.location;
    }
    get restorationIdentifier() {
        return this.history.restorationIdentifier;
    }
    getActionForFormSubmission({ submitter, formElement }) {
        return getVisitAction(submitter, formElement) || "advance";
    }
}

var PageStage;
(function (PageStage) {
    PageStage[PageStage["initial"] = 0] = "initial";
    PageStage[PageStage["loading"] = 1] = "loading";
    PageStage[PageStage["interactive"] = 2] = "interactive";
    PageStage[PageStage["complete"] = 3] = "complete";
})(PageStage || (PageStage = {}));
class PageObserver {
    constructor(delegate) {
        this.stage = PageStage.initial;
        this.started = false;
        this.interpretReadyState = () => {
            const { readyState } = this;
            if (readyState == "interactive") {
                this.pageIsInteractive();
            }
            else if (readyState == "complete") {
                this.pageIsComplete();
            }
        };
        this.pageWillUnload = () => {
            this.delegate.pageWillUnload();
        };
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            if (this.stage == PageStage.initial) {
                this.stage = PageStage.loading;
            }
            document.addEventListener("readystatechange", this.interpretReadyState, false);
            addEventListener("pagehide", this.pageWillUnload, false);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            document.removeEventListener("readystatechange", this.interpretReadyState, false);
            removeEventListener("pagehide", this.pageWillUnload, false);
            this.started = false;
        }
    }
    pageIsInteractive() {
        if (this.stage == PageStage.loading) {
            this.stage = PageStage.interactive;
            this.delegate.pageBecameInteractive();
        }
    }
    pageIsComplete() {
        this.pageIsInteractive();
        if (this.stage == PageStage.interactive) {
            this.stage = PageStage.complete;
            this.delegate.pageLoaded();
        }
    }
    get readyState() {
        return document.readyState;
    }
}

class ScrollObserver {
    constructor(delegate) {
        this.started = false;
        this.onScroll = () => {
            this.updatePosition({ x: window.pageXOffset, y: window.pageYOffset });
        };
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            addEventListener("scroll", this.onScroll, false);
            this.onScroll();
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            removeEventListener("scroll", this.onScroll, false);
            this.started = false;
        }
    }
    updatePosition(position) {
        this.delegate.scrollPositionChanged(position);
    }
}

class StreamMessageRenderer {
    render({ fragment }) {
        Bardo.preservingPermanentElements(this, getPermanentElementMapForFragment(fragment), () => document.documentElement.appendChild(fragment));
    }
    enteringBardo(currentPermanentElement, newPermanentElement) {
        newPermanentElement.replaceWith(currentPermanentElement.cloneNode(true));
    }
    leavingBardo() { }
}
function getPermanentElementMapForFragment(fragment) {
    const permanentElementsInDocument = queryPermanentElementsAll(document.documentElement);
    const permanentElementMap = {};
    for (const permanentElementInDocument of permanentElementsInDocument) {
        const { id } = permanentElementInDocument;
        for (const streamElement of fragment.querySelectorAll("turbo-stream")) {
            const elementInStream = getPermanentElementById(streamElement.templateElement.content, id);
            if (elementInStream) {
                permanentElementMap[id] = [permanentElementInDocument, elementInStream];
            }
        }
    }
    return permanentElementMap;
}

class StreamObserver {
    constructor(delegate) {
        this.sources = new Set();
        this.started = false;
        this.inspectFetchResponse = ((event) => {
            const response = fetchResponseFromEvent(event);
            if (response && fetchResponseIsStream(response)) {
                event.preventDefault();
                this.receiveMessageResponse(response);
            }
        });
        this.receiveMessageEvent = (event) => {
            if (this.started && typeof event.data == "string") {
                this.receiveMessageHTML(event.data);
            }
        };
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            this.started = true;
            addEventListener("turbo:before-fetch-response", this.inspectFetchResponse, false);
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            removeEventListener("turbo:before-fetch-response", this.inspectFetchResponse, false);
        }
    }
    connectStreamSource(source) {
        if (!this.streamSourceIsConnected(source)) {
            this.sources.add(source);
            source.addEventListener("message", this.receiveMessageEvent, false);
        }
    }
    disconnectStreamSource(source) {
        if (this.streamSourceIsConnected(source)) {
            this.sources.delete(source);
            source.removeEventListener("message", this.receiveMessageEvent, false);
        }
    }
    streamSourceIsConnected(source) {
        return this.sources.has(source);
    }
    async receiveMessageResponse(response) {
        const html = await response.responseHTML;
        if (html) {
            this.receiveMessageHTML(html);
        }
    }
    receiveMessageHTML(html) {
        this.delegate.receivedMessageFromStream(StreamMessage.wrap(html));
    }
}
function fetchResponseFromEvent(event) {
    var _a;
    const fetchResponse = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.fetchResponse;
    if (fetchResponse instanceof FetchResponse) {
        return fetchResponse;
    }
}
function fetchResponseIsStream(response) {
    var _a;
    const contentType = (_a = response.contentType) !== null && _a !== void 0 ? _a : "";
    return contentType.startsWith(StreamMessage.contentType);
}

class ErrorRenderer extends Renderer {
    static renderElement(currentElement, newElement) {
        const { documentElement, body } = document;
        documentElement.replaceChild(newElement, body);
    }
    async render() {
        this.replaceHeadAndBody();
        this.activateScriptElements();
    }
    replaceHeadAndBody() {
        const { documentElement, head } = document;
        documentElement.replaceChild(this.newHead, head);
        this.renderElement(this.currentElement, this.newElement);
    }
    activateScriptElements() {
        for (const replaceableElement of this.scriptElements) {
            const parentNode = replaceableElement.parentNode;
            if (parentNode) {
                const element = activateScriptElement(replaceableElement);
                parentNode.replaceChild(element, replaceableElement);
            }
        }
    }
    get newHead() {
        return this.newSnapshot.headSnapshot.element;
    }
    get scriptElements() {
        return document.documentElement.querySelectorAll("script");
    }
}

class PageRenderer extends Renderer {
    static renderElement(currentElement, newElement) {
        if (document.body && newElement instanceof HTMLBodyElement) {
            document.body.replaceWith(newElement);
        }
        else {
            document.documentElement.appendChild(newElement);
        }
    }
    get shouldRender() {
        return this.newSnapshot.isVisitable && this.trackedElementsAreIdentical;
    }
    get reloadReason() {
        if (!this.newSnapshot.isVisitable) {
            return {
                reason: "turbo_visit_control_is_reload",
            };
        }
        if (!this.trackedElementsAreIdentical) {
            return {
                reason: "tracked_element_mismatch",
            };
        }
    }
    async prepareToRender() {
        await this.mergeHead();
    }
    async render() {
        if (this.willRender) {
            await this.replaceBody();
        }
    }
    finishRendering() {
        super.finishRendering();
        if (!this.isPreview) {
            this.focusFirstAutofocusableElement();
        }
    }
    get currentHeadSnapshot() {
        return this.currentSnapshot.headSnapshot;
    }
    get newHeadSnapshot() {
        return this.newSnapshot.headSnapshot;
    }
    get newElement() {
        return this.newSnapshot.element;
    }
    async mergeHead() {
        const mergedHeadElements = this.mergeProvisionalElements();
        const newStylesheetElements = this.copyNewHeadStylesheetElements();
        this.copyNewHeadScriptElements();
        await mergedHeadElements;
        await newStylesheetElements;
    }
    async replaceBody() {
        await this.preservingPermanentElements(async () => {
            this.activateNewBody();
            await this.assignNewBody();
        });
    }
    get trackedElementsAreIdentical() {
        return this.currentHeadSnapshot.trackedElementSignature == this.newHeadSnapshot.trackedElementSignature;
    }
    async copyNewHeadStylesheetElements() {
        const loadingElements = [];
        for (const element of this.newHeadStylesheetElements) {
            loadingElements.push(waitForLoad(element));
            document.head.appendChild(element);
        }
        await Promise.all(loadingElements);
    }
    copyNewHeadScriptElements() {
        for (const element of this.newHeadScriptElements) {
            document.head.appendChild(activateScriptElement(element));
        }
    }
    async mergeProvisionalElements() {
        const newHeadElements = [...this.newHeadProvisionalElements];
        for (const element of this.currentHeadProvisionalElements) {
            if (!this.isCurrentElementInElementList(element, newHeadElements)) {
                document.head.removeChild(element);
            }
        }
        for (const element of newHeadElements) {
            document.head.appendChild(element);
        }
    }
    isCurrentElementInElementList(element, elementList) {
        for (const [index, newElement] of elementList.entries()) {
            if (element.tagName == "TITLE") {
                if (newElement.tagName != "TITLE") {
                    continue;
                }
                if (element.innerHTML == newElement.innerHTML) {
                    elementList.splice(index, 1);
                    return true;
                }
            }
            if (newElement.isEqualNode(element)) {
                elementList.splice(index, 1);
                return true;
            }
        }
        return false;
    }
    removeCurrentHeadProvisionalElements() {
        for (const element of this.currentHeadProvisionalElements) {
            document.head.removeChild(element);
        }
    }
    copyNewHeadProvisionalElements() {
        for (const element of this.newHeadProvisionalElements) {
            document.head.appendChild(element);
        }
    }
    activateNewBody() {
        document.adoptNode(this.newElement);
        this.activateNewBodyScriptElements();
    }
    activateNewBodyScriptElements() {
        for (const inertScriptElement of this.newBodyScriptElements) {
            const activatedScriptElement = activateScriptElement(inertScriptElement);
            inertScriptElement.replaceWith(activatedScriptElement);
        }
    }
    async assignNewBody() {
        await this.renderElement(this.currentElement, this.newElement);
    }
    get newHeadStylesheetElements() {
        return this.newHeadSnapshot.getStylesheetElementsNotInSnapshot(this.currentHeadSnapshot);
    }
    get newHeadScriptElements() {
        return this.newHeadSnapshot.getScriptElementsNotInSnapshot(this.currentHeadSnapshot);
    }
    get currentHeadProvisionalElements() {
        return this.currentHeadSnapshot.provisionalElements;
    }
    get newHeadProvisionalElements() {
        return this.newHeadSnapshot.provisionalElements;
    }
    get newBodyScriptElements() {
        return this.newElement.querySelectorAll("script");
    }
}

class SnapshotCache {
    constructor(size) {
        this.keys = [];
        this.snapshots = {};
        this.size = size;
    }
    has(location) {
        return toCacheKey(location) in this.snapshots;
    }
    get(location) {
        if (this.has(location)) {
            const snapshot = this.read(location);
            this.touch(location);
            return snapshot;
        }
    }
    put(location, snapshot) {
        this.write(location, snapshot);
        this.touch(location);
        return snapshot;
    }
    clear() {
        this.snapshots = {};
    }
    read(location) {
        return this.snapshots[toCacheKey(location)];
    }
    write(location, snapshot) {
        this.snapshots[toCacheKey(location)] = snapshot;
    }
    touch(location) {
        const key = toCacheKey(location);
        const index = this.keys.indexOf(key);
        if (index > -1)
            this.keys.splice(index, 1);
        this.keys.unshift(key);
        this.trim();
    }
    trim() {
        for (const key of this.keys.splice(this.size)) {
            delete this.snapshots[key];
        }
    }
}

class PageView extends View {
    constructor() {
        super(...arguments);
        this.snapshotCache = new SnapshotCache(10);
        this.lastRenderedLocation = new URL(location.href);
        this.forceReloaded = false;
    }
    renderPage(snapshot, isPreview = false, willRender = true, visit) {
        const renderer = new PageRenderer(this.snapshot, snapshot, PageRenderer.renderElement, isPreview, willRender);
        if (!renderer.shouldRender) {
            this.forceReloaded = true;
        }
        else {
            visit === null || visit === void 0 ? void 0 : visit.changeHistory();
        }
        return this.render(renderer);
    }
    renderError(snapshot, visit) {
        visit === null || visit === void 0 ? void 0 : visit.changeHistory();
        const renderer = new ErrorRenderer(this.snapshot, snapshot, ErrorRenderer.renderElement, false);
        return this.render(renderer);
    }
    clearSnapshotCache() {
        this.snapshotCache.clear();
    }
    async cacheSnapshot(snapshot = this.snapshot) {
        if (snapshot.isCacheable) {
            this.delegate.viewWillCacheSnapshot();
            const { lastRenderedLocation: location } = this;
            await nextEventLoopTick();
            const cachedSnapshot = snapshot.clone();
            this.snapshotCache.put(location, cachedSnapshot);
            return cachedSnapshot;
        }
    }
    getCachedSnapshotForLocation(location) {
        return this.snapshotCache.get(location);
    }
    get snapshot() {
        return PageSnapshot.fromElement(this.element);
    }
}

class Preloader {
    constructor(delegate) {
        this.selector = "a[data-turbo-preload]";
        this.delegate = delegate;
    }
    get snapshotCache() {
        return this.delegate.navigator.view.snapshotCache;
    }
    start() {
        if (document.readyState === "loading") {
            return document.addEventListener("DOMContentLoaded", () => {
                this.preloadOnLoadLinksForView(document.body);
            });
        }
        else {
            this.preloadOnLoadLinksForView(document.body);
        }
    }
    preloadOnLoadLinksForView(element) {
        for (const link of element.querySelectorAll(this.selector)) {
            this.preloadURL(link);
        }
    }
    async preloadURL(link) {
        const location = new URL(link.href);
        if (this.snapshotCache.has(location)) {
            return;
        }
        try {
            const response = await fetch(location.toString(), { headers: { "VND.PREFETCH": "true", Accept: "text/html" } });
            const responseText = await response.text();
            const snapshot = PageSnapshot.fromHTMLString(responseText);
            this.snapshotCache.put(location, snapshot);
        }
        catch (_) {
        }
    }
}

class Session {
    constructor() {
        this.navigator = new Navigator(this);
        this.history = new History(this);
        this.preloader = new Preloader(this);
        this.view = new PageView(this, document.documentElement);
        this.adapter = new BrowserAdapter(this);
        this.pageObserver = new PageObserver(this);
        this.cacheObserver = new CacheObserver();
        this.linkClickObserver = new LinkClickObserver(this, window);
        this.formSubmitObserver = new FormSubmitObserver(this, document);
        this.scrollObserver = new ScrollObserver(this);
        this.streamObserver = new StreamObserver(this);
        this.formLinkClickObserver = new FormLinkClickObserver(this, document.documentElement);
        this.frameRedirector = new FrameRedirector(this, document.documentElement);
        this.streamMessageRenderer = new StreamMessageRenderer();
        this.drive = true;
        this.enabled = true;
        this.progressBarDelay = 500;
        this.started = false;
        this.formMode = "on";
    }
    start() {
        if (!this.started) {
            this.pageObserver.start();
            this.cacheObserver.start();
            this.formLinkClickObserver.start();
            this.linkClickObserver.start();
            this.formSubmitObserver.start();
            this.scrollObserver.start();
            this.streamObserver.start();
            this.frameRedirector.start();
            this.history.start();
            this.preloader.start();
            this.started = true;
            this.enabled = true;
        }
    }
    disable() {
        this.enabled = false;
    }
    stop() {
        if (this.started) {
            this.pageObserver.stop();
            this.cacheObserver.stop();
            this.formLinkClickObserver.stop();
            this.linkClickObserver.stop();
            this.formSubmitObserver.stop();
            this.scrollObserver.stop();
            this.streamObserver.stop();
            this.frameRedirector.stop();
            this.history.stop();
            this.started = false;
        }
    }
    registerAdapter(adapter) {
        this.adapter = adapter;
    }
    visit(location, options = {}) {
        const frameElement = options.frame ? document.getElementById(options.frame) : null;
        if (frameElement instanceof FrameElement) {
            frameElement.src = location.toString();
            frameElement.loaded;
        }
        else {
            this.navigator.proposeVisit(expandURL(location), options);
        }
    }
    connectStreamSource(source) {
        this.streamObserver.connectStreamSource(source);
    }
    disconnectStreamSource(source) {
        this.streamObserver.disconnectStreamSource(source);
    }
    renderStreamMessage(message) {
        this.streamMessageRenderer.render(StreamMessage.wrap(message));
    }
    clearCache() {
        this.view.clearSnapshotCache();
    }
    setProgressBarDelay(delay) {
        this.progressBarDelay = delay;
    }
    setFormMode(mode) {
        this.formMode = mode;
    }
    get location() {
        return this.history.location;
    }
    get restorationIdentifier() {
        return this.history.restorationIdentifier;
    }
    historyPoppedToLocationWithRestorationIdentifier(location, restorationIdentifier) {
        if (this.enabled) {
            this.navigator.startVisit(location, restorationIdentifier, {
                action: "restore",
                historyChanged: true,
            });
        }
        else {
            this.adapter.pageInvalidated({
                reason: "turbo_disabled",
            });
        }
    }
    scrollPositionChanged(position) {
        this.history.updateRestorationData({ scrollPosition: position });
    }
    willSubmitFormLinkToLocation(link, location) {
        return this.elementIsNavigatable(link) && locationIsVisitable(location, this.snapshot.rootLocation);
    }
    submittedFormLinkToLocation() { }
    willFollowLinkToLocation(link, location, event) {
        return (this.elementIsNavigatable(link) &&
            locationIsVisitable(location, this.snapshot.rootLocation) &&
            this.applicationAllowsFollowingLinkToLocation(link, location, event));
    }
    followedLinkToLocation(link, location) {
        const action = this.getActionForLink(link);
        const acceptsStreamResponse = link.hasAttribute("data-turbo-stream");
        this.visit(location.href, { action, acceptsStreamResponse });
    }
    allowsVisitingLocationWithAction(location, action) {
        return this.locationWithActionIsSamePage(location, action) || this.applicationAllowsVisitingLocation(location);
    }
    visitProposedToLocation(location, options) {
        extendURLWithDeprecatedProperties(location);
        this.adapter.visitProposedToLocation(location, options);
    }
    visitStarted(visit) {
        if (!visit.acceptsStreamResponse) {
            markAsBusy(document.documentElement);
        }
        extendURLWithDeprecatedProperties(visit.location);
        if (!visit.silent) {
            this.notifyApplicationAfterVisitingLocation(visit.location, visit.action);
        }
    }
    visitCompleted(visit) {
        clearBusyState(document.documentElement);
        this.notifyApplicationAfterPageLoad(visit.getTimingMetrics());
    }
    locationWithActionIsSamePage(location, action) {
        return this.navigator.locationWithActionIsSamePage(location, action);
    }
    visitScrolledToSamePageLocation(oldURL, newURL) {
        this.notifyApplicationAfterVisitingSamePageLocation(oldURL, newURL);
    }
    willSubmitForm(form, submitter) {
        const action = getAction(form, submitter);
        return (this.submissionIsNavigatable(form, submitter) &&
            locationIsVisitable(expandURL(action), this.snapshot.rootLocation));
    }
    formSubmitted(form, submitter) {
        this.navigator.submitForm(form, submitter);
    }
    pageBecameInteractive() {
        this.view.lastRenderedLocation = this.location;
        this.notifyApplicationAfterPageLoad();
    }
    pageLoaded() {
        this.history.assumeControlOfScrollRestoration();
    }
    pageWillUnload() {
        this.history.relinquishControlOfScrollRestoration();
    }
    receivedMessageFromStream(message) {
        this.renderStreamMessage(message);
    }
    viewWillCacheSnapshot() {
        var _a;
        if (!((_a = this.navigator.currentVisit) === null || _a === void 0 ? void 0 : _a.silent)) {
            this.notifyApplicationBeforeCachingSnapshot();
        }
    }
    allowsImmediateRender({ element }, options) {
        const event = this.notifyApplicationBeforeRender(element, options);
        const { defaultPrevented, detail: { render }, } = event;
        if (this.view.renderer && render) {
            this.view.renderer.renderElement = render;
        }
        return !defaultPrevented;
    }
    viewRenderedSnapshot(_snapshot, _isPreview) {
        this.view.lastRenderedLocation = this.history.location;
        this.notifyApplicationAfterRender();
    }
    preloadOnLoadLinksForView(element) {
        this.preloader.preloadOnLoadLinksForView(element);
    }
    viewInvalidated(reason) {
        this.adapter.pageInvalidated(reason);
    }
    frameLoaded(frame) {
        this.notifyApplicationAfterFrameLoad(frame);
    }
    frameRendered(fetchResponse, frame) {
        this.notifyApplicationAfterFrameRender(fetchResponse, frame);
    }
    applicationAllowsFollowingLinkToLocation(link, location, ev) {
        const event = this.notifyApplicationAfterClickingLinkToLocation(link, location, ev);
        return !event.defaultPrevented;
    }
    applicationAllowsVisitingLocation(location) {
        const event = this.notifyApplicationBeforeVisitingLocation(location);
        return !event.defaultPrevented;
    }
    notifyApplicationAfterClickingLinkToLocation(link, location, event) {
        return dispatch("turbo:click", {
            target: link,
            detail: { url: location.href, originalEvent: event },
            cancelable: true,
        });
    }
    notifyApplicationBeforeVisitingLocation(location) {
        return dispatch("turbo:before-visit", {
            detail: { url: location.href },
            cancelable: true,
        });
    }
    notifyApplicationAfterVisitingLocation(location, action) {
        return dispatch("turbo:visit", { detail: { url: location.href, action } });
    }
    notifyApplicationBeforeCachingSnapshot() {
        return dispatch("turbo:before-cache");
    }
    notifyApplicationBeforeRender(newBody, options) {
        return dispatch("turbo:before-render", {
            detail: Object.assign({ newBody }, options),
            cancelable: true,
        });
    }
    notifyApplicationAfterRender() {
        return dispatch("turbo:render");
    }
    notifyApplicationAfterPageLoad(timing = {}) {
        return dispatch("turbo:load", {
            detail: { url: this.location.href, timing },
        });
    }
    notifyApplicationAfterVisitingSamePageLocation(oldURL, newURL) {
        dispatchEvent(new HashChangeEvent("hashchange", {
            oldURL: oldURL.toString(),
            newURL: newURL.toString(),
        }));
    }
    notifyApplicationAfterFrameLoad(frame) {
        return dispatch("turbo:frame-load", { target: frame });
    }
    notifyApplicationAfterFrameRender(fetchResponse, frame) {
        return dispatch("turbo:frame-render", {
            detail: { fetchResponse },
            target: frame,
            cancelable: true,
        });
    }
    submissionIsNavigatable(form, submitter) {
        if (this.formMode == "off") {
            return false;
        }
        else {
            const submitterIsNavigatable = submitter ? this.elementIsNavigatable(submitter) : true;
            if (this.formMode == "optin") {
                return submitterIsNavigatable && form.closest('[data-turbo="true"]') != null;
            }
            else {
                return submitterIsNavigatable && this.elementIsNavigatable(form);
            }
        }
    }
    elementIsNavigatable(element) {
        const container = findClosestRecursively(element, "[data-turbo]");
        const withinFrame = findClosestRecursively(element, "turbo-frame");
        if (this.drive || withinFrame) {
            if (container) {
                return container.getAttribute("data-turbo") != "false";
            }
            else {
                return true;
            }
        }
        else {
            if (container) {
                return container.getAttribute("data-turbo") == "true";
            }
            else {
                return false;
            }
        }
    }
    getActionForLink(link) {
        return getVisitAction(link) || "advance";
    }
    get snapshot() {
        return this.view.snapshot;
    }
}
function extendURLWithDeprecatedProperties(url) {
    Object.defineProperties(url, deprecatedLocationPropertyDescriptors);
}
const deprecatedLocationPropertyDescriptors = {
    absoluteURL: {
        get() {
            return this.toString();
        },
    },
};

class Cache {
    constructor(session) {
        this.session = session;
    }
    clear() {
        this.session.clearCache();
    }
    resetCacheControl() {
        this.setCacheControl("");
    }
    exemptPageFromCache() {
        this.setCacheControl("no-cache");
    }
    exemptPageFromPreview() {
        this.setCacheControl("no-preview");
    }
    setCacheControl(value) {
        setMetaContent("turbo-cache-control", value);
    }
}

const StreamActions = {
    after() {
        this.targetElements.forEach((e) => { var _a; return (_a = e.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(this.templateContent, e.nextSibling); });
    },
    append() {
        this.removeDuplicateTargetChildren();
        this.targetElements.forEach((e) => e.append(this.templateContent));
    },
    before() {
        this.targetElements.forEach((e) => { var _a; return (_a = e.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(this.templateContent, e); });
    },
    prepend() {
        this.removeDuplicateTargetChildren();
        this.targetElements.forEach((e) => e.prepend(this.templateContent));
    },
    remove() {
        this.targetElements.forEach((e) => e.remove());
    },
    replace() {
        this.targetElements.forEach((e) => e.replaceWith(this.templateContent));
    },
    update() {
        this.targetElements.forEach((targetElement) => {
            targetElement.innerHTML = "";
            targetElement.append(this.templateContent);
        });
    },
};

const session = new Session();
const cache = new Cache(session);
const { navigator: navigator$1 } = session;
function start() {
    session.start();
}
function registerAdapter(adapter) {
    session.registerAdapter(adapter);
}
function visit(location, options) {
    session.visit(location, options);
}
function connectStreamSource(source) {
    session.connectStreamSource(source);
}
function disconnectStreamSource(source) {
    session.disconnectStreamSource(source);
}
function renderStreamMessage(message) {
    session.renderStreamMessage(message);
}
function clearCache() {
    console.warn("Please replace `Turbo.clearCache()` with `Turbo.cache.clear()`. The top-level function is deprecated and will be removed in a future version of Turbo.`");
    session.clearCache();
}
function setProgressBarDelay(delay) {
    session.setProgressBarDelay(delay);
}
function setConfirmMethod(confirmMethod) {
    FormSubmission.confirmMethod = confirmMethod;
}
function setFormMode(mode) {
    session.setFormMode(mode);
}

var Turbo = /*#__PURE__*/Object.freeze({
    __proto__: null,
    navigator: navigator$1,
    session: session,
    cache: cache,
    PageRenderer: PageRenderer,
    PageSnapshot: PageSnapshot,
    FrameRenderer: FrameRenderer,
    start: start,
    registerAdapter: registerAdapter,
    visit: visit,
    connectStreamSource: connectStreamSource,
    disconnectStreamSource: disconnectStreamSource,
    renderStreamMessage: renderStreamMessage,
    clearCache: clearCache,
    setProgressBarDelay: setProgressBarDelay,
    setConfirmMethod: setConfirmMethod,
    setFormMode: setFormMode,
    StreamActions: StreamActions
});

class TurboFrameMissingError extends Error {
}

class FrameController {
    constructor(element) {
        this.fetchResponseLoaded = (_fetchResponse) => { };
        this.currentFetchRequest = null;
        this.resolveVisitPromise = () => { };
        this.connected = false;
        this.hasBeenLoaded = false;
        this.ignoredAttributes = new Set();
        this.action = null;
        this.visitCachedSnapshot = ({ element }) => {
            const frame = element.querySelector("#" + this.element.id);
            if (frame && this.previousFrameElement) {
                frame.replaceChildren(...this.previousFrameElement.children);
            }
            delete this.previousFrameElement;
        };
        this.element = element;
        this.view = new FrameView(this, this.element);
        this.appearanceObserver = new AppearanceObserver(this, this.element);
        this.formLinkClickObserver = new FormLinkClickObserver(this, this.element);
        this.linkInterceptor = new LinkInterceptor(this, this.element);
        this.restorationIdentifier = uuid();
        this.formSubmitObserver = new FormSubmitObserver(this, this.element);
    }
    connect() {
        if (!this.connected) {
            this.connected = true;
            if (this.loadingStyle == FrameLoadingStyle.lazy) {
                this.appearanceObserver.start();
            }
            else {
                this.loadSourceURL();
            }
            this.formLinkClickObserver.start();
            this.linkInterceptor.start();
            this.formSubmitObserver.start();
        }
    }
    disconnect() {
        if (this.connected) {
            this.connected = false;
            this.appearanceObserver.stop();
            this.formLinkClickObserver.stop();
            this.linkInterceptor.stop();
            this.formSubmitObserver.stop();
        }
    }
    disabledChanged() {
        if (this.loadingStyle == FrameLoadingStyle.eager) {
            this.loadSourceURL();
        }
    }
    sourceURLChanged() {
        if (this.isIgnoringChangesTo("src"))
            return;
        if (this.element.isConnected) {
            this.complete = false;
        }
        if (this.loadingStyle == FrameLoadingStyle.eager || this.hasBeenLoaded) {
            this.loadSourceURL();
        }
    }
    sourceURLReloaded() {
        const { src } = this.element;
        this.ignoringChangesToAttribute("complete", () => {
            this.element.removeAttribute("complete");
        });
        this.element.src = null;
        this.element.src = src;
        return this.element.loaded;
    }
    completeChanged() {
        if (this.isIgnoringChangesTo("complete"))
            return;
        this.loadSourceURL();
    }
    loadingStyleChanged() {
        if (this.loadingStyle == FrameLoadingStyle.lazy) {
            this.appearanceObserver.start();
        }
        else {
            this.appearanceObserver.stop();
            this.loadSourceURL();
        }
    }
    async loadSourceURL() {
        if (this.enabled && this.isActive && !this.complete && this.sourceURL) {
            this.element.loaded = this.visit(expandURL(this.sourceURL));
            this.appearanceObserver.stop();
            await this.element.loaded;
            this.hasBeenLoaded = true;
        }
    }
    async loadResponse(fetchResponse) {
        if (fetchResponse.redirected || (fetchResponse.succeeded && fetchResponse.isHTML)) {
            this.sourceURL = fetchResponse.response.url;
        }
        try {
            const html = await fetchResponse.responseHTML;
            if (html) {
                const document = parseHTMLDocument(html);
                const pageSnapshot = PageSnapshot.fromDocument(document);
                if (pageSnapshot.isVisitable) {
                    await this.loadFrameResponse(fetchResponse, document);
                }
                else {
                    await this.handleUnvisitableFrameResponse(fetchResponse);
                }
            }
        }
        finally {
            this.fetchResponseLoaded = () => { };
        }
    }
    elementAppearedInViewport(element) {
        this.proposeVisitIfNavigatedWithAction(element, element);
        this.loadSourceURL();
    }
    willSubmitFormLinkToLocation(link) {
        return this.shouldInterceptNavigation(link);
    }
    submittedFormLinkToLocation(link, _location, form) {
        const frame = this.findFrameElement(link);
        if (frame)
            form.setAttribute("data-turbo-frame", frame.id);
    }
    shouldInterceptLinkClick(element, _location, _event) {
        return this.shouldInterceptNavigation(element);
    }
    linkClickIntercepted(element, location) {
        this.navigateFrame(element, location);
    }
    willSubmitForm(element, submitter) {
        return element.closest("turbo-frame") == this.element && this.shouldInterceptNavigation(element, submitter);
    }
    formSubmitted(element, submitter) {
        if (this.formSubmission) {
            this.formSubmission.stop();
        }
        this.formSubmission = new FormSubmission(this, element, submitter);
        const { fetchRequest } = this.formSubmission;
        this.prepareRequest(fetchRequest);
        this.formSubmission.start();
    }
    prepareRequest(request) {
        var _a;
        request.headers["Turbo-Frame"] = this.id;
        if ((_a = this.currentNavigationElement) === null || _a === void 0 ? void 0 : _a.hasAttribute("data-turbo-stream")) {
            request.acceptResponseType(StreamMessage.contentType);
        }
    }
    requestStarted(_request) {
        markAsBusy(this.element);
    }
    requestPreventedHandlingResponse(_request, _response) {
        this.resolveVisitPromise();
    }
    async requestSucceededWithResponse(request, response) {
        await this.loadResponse(response);
        this.resolveVisitPromise();
    }
    async requestFailedWithResponse(request, response) {
        await this.loadResponse(response);
        this.resolveVisitPromise();
    }
    requestErrored(request, error) {
        console.error(error);
        this.resolveVisitPromise();
    }
    requestFinished(_request) {
        clearBusyState(this.element);
    }
    formSubmissionStarted({ formElement }) {
        markAsBusy(formElement, this.findFrameElement(formElement));
    }
    formSubmissionSucceededWithResponse(formSubmission, response) {
        const frame = this.findFrameElement(formSubmission.formElement, formSubmission.submitter);
        frame.delegate.proposeVisitIfNavigatedWithAction(frame, formSubmission.formElement, formSubmission.submitter);
        frame.delegate.loadResponse(response);
        if (!formSubmission.isSafe) {
            session.clearCache();
        }
    }
    formSubmissionFailedWithResponse(formSubmission, fetchResponse) {
        this.element.delegate.loadResponse(fetchResponse);
        session.clearCache();
    }
    formSubmissionErrored(formSubmission, error) {
        console.error(error);
    }
    formSubmissionFinished({ formElement }) {
        clearBusyState(formElement, this.findFrameElement(formElement));
    }
    allowsImmediateRender({ element: newFrame }, options) {
        const event = dispatch("turbo:before-frame-render", {
            target: this.element,
            detail: Object.assign({ newFrame }, options),
            cancelable: true,
        });
        const { defaultPrevented, detail: { render }, } = event;
        if (this.view.renderer && render) {
            this.view.renderer.renderElement = render;
        }
        return !defaultPrevented;
    }
    viewRenderedSnapshot(_snapshot, _isPreview) { }
    preloadOnLoadLinksForView(element) {
        session.preloadOnLoadLinksForView(element);
    }
    viewInvalidated() { }
    willRenderFrame(currentElement, _newElement) {
        this.previousFrameElement = currentElement.cloneNode(true);
    }
    async loadFrameResponse(fetchResponse, document) {
        const newFrameElement = await this.extractForeignFrameElement(document.body);
        if (newFrameElement) {
            const snapshot = new Snapshot(newFrameElement);
            const renderer = new FrameRenderer(this, this.view.snapshot, snapshot, FrameRenderer.renderElement, false, false);
            if (this.view.renderPromise)
                await this.view.renderPromise;
            this.changeHistory();
            await this.view.render(renderer);
            this.complete = true;
            session.frameRendered(fetchResponse, this.element);
            session.frameLoaded(this.element);
            this.fetchResponseLoaded(fetchResponse);
        }
        else if (this.willHandleFrameMissingFromResponse(fetchResponse)) {
            this.handleFrameMissingFromResponse(fetchResponse);
        }
    }
    async visit(url) {
        var _a;
        const request = new FetchRequest(this, FetchMethod.get, url, new URLSearchParams(), this.element);
        (_a = this.currentFetchRequest) === null || _a === void 0 ? void 0 : _a.cancel();
        this.currentFetchRequest = request;
        return new Promise((resolve) => {
            this.resolveVisitPromise = () => {
                this.resolveVisitPromise = () => { };
                this.currentFetchRequest = null;
                resolve();
            };
            request.perform();
        });
    }
    navigateFrame(element, url, submitter) {
        const frame = this.findFrameElement(element, submitter);
        frame.delegate.proposeVisitIfNavigatedWithAction(frame, element, submitter);
        this.withCurrentNavigationElement(element, () => {
            frame.src = url;
        });
    }
    proposeVisitIfNavigatedWithAction(frame, element, submitter) {
        this.action = getVisitAction(submitter, element, frame);
        if (this.action) {
            const pageSnapshot = PageSnapshot.fromElement(frame).clone();
            const { visitCachedSnapshot } = frame.delegate;
            frame.delegate.fetchResponseLoaded = (fetchResponse) => {
                if (frame.src) {
                    const { statusCode, redirected } = fetchResponse;
                    const responseHTML = frame.ownerDocument.documentElement.outerHTML;
                    const response = { statusCode, redirected, responseHTML };
                    const options = {
                        response,
                        visitCachedSnapshot,
                        willRender: false,
                        updateHistory: false,
                        restorationIdentifier: this.restorationIdentifier,
                        snapshot: pageSnapshot,
                    };
                    if (this.action)
                        options.action = this.action;
                    session.visit(frame.src, options);
                }
            };
        }
    }
    changeHistory() {
        if (this.action) {
            const method = getHistoryMethodForAction(this.action);
            session.history.update(method, expandURL(this.element.src || ""), this.restorationIdentifier);
        }
    }
    async handleUnvisitableFrameResponse(fetchResponse) {
        console.warn(`The response (${fetchResponse.statusCode}) from <turbo-frame id="${this.element.id}"> is performing a full page visit due to turbo-visit-control.`);
        await this.visitResponse(fetchResponse.response);
    }
    willHandleFrameMissingFromResponse(fetchResponse) {
        this.element.setAttribute("complete", "");
        const response = fetchResponse.response;
        const visit = async (url, options = {}) => {
            if (url instanceof Response) {
                this.visitResponse(url);
            }
            else {
                session.visit(url, options);
            }
        };
        const event = dispatch("turbo:frame-missing", {
            target: this.element,
            detail: { response, visit },
            cancelable: true,
        });
        return !event.defaultPrevented;
    }
    handleFrameMissingFromResponse(fetchResponse) {
        this.view.missing();
        this.throwFrameMissingError(fetchResponse);
    }
    throwFrameMissingError(fetchResponse) {
        const message = `The response (${fetchResponse.statusCode}) did not contain the expected <turbo-frame id="${this.element.id}"> and will be ignored. To perform a full page visit instead, set turbo-visit-control to reload.`;
        throw new TurboFrameMissingError(message);
    }
    async visitResponse(response) {
        const wrapped = new FetchResponse(response);
        const responseHTML = await wrapped.responseHTML;
        const { location, redirected, statusCode } = wrapped;
        return session.visit(location, { response: { redirected, statusCode, responseHTML } });
    }
    findFrameElement(element, submitter) {
        var _a;
        const id = getAttribute("data-turbo-frame", submitter, element) || this.element.getAttribute("target");
        return (_a = getFrameElementById(id)) !== null && _a !== void 0 ? _a : this.element;
    }
    async extractForeignFrameElement(container) {
        let element;
        const id = CSS.escape(this.id);
        try {
            element = activateElement(container.querySelector(`turbo-frame#${id}`), this.sourceURL);
            if (element) {
                return element;
            }
            element = activateElement(container.querySelector(`turbo-frame[src][recurse~=${id}]`), this.sourceURL);
            if (element) {
                await element.loaded;
                return await this.extractForeignFrameElement(element);
            }
        }
        catch (error) {
            console.error(error);
            return new FrameElement();
        }
        return null;
    }
    formActionIsVisitable(form, submitter) {
        const action = getAction(form, submitter);
        return locationIsVisitable(expandURL(action), this.rootLocation);
    }
    shouldInterceptNavigation(element, submitter) {
        const id = getAttribute("data-turbo-frame", submitter, element) || this.element.getAttribute("target");
        if (element instanceof HTMLFormElement && !this.formActionIsVisitable(element, submitter)) {
            return false;
        }
        if (!this.enabled || id == "_top") {
            return false;
        }
        if (id) {
            const frameElement = getFrameElementById(id);
            if (frameElement) {
                return !frameElement.disabled;
            }
        }
        if (!session.elementIsNavigatable(element)) {
            return false;
        }
        if (submitter && !session.elementIsNavigatable(submitter)) {
            return false;
        }
        return true;
    }
    get id() {
        return this.element.id;
    }
    get enabled() {
        return !this.element.disabled;
    }
    get sourceURL() {
        if (this.element.src) {
            return this.element.src;
        }
    }
    set sourceURL(sourceURL) {
        this.ignoringChangesToAttribute("src", () => {
            this.element.src = sourceURL !== null && sourceURL !== void 0 ? sourceURL : null;
        });
    }
    get loadingStyle() {
        return this.element.loading;
    }
    get isLoading() {
        return this.formSubmission !== undefined || this.resolveVisitPromise() !== undefined;
    }
    get complete() {
        return this.element.hasAttribute("complete");
    }
    set complete(value) {
        this.ignoringChangesToAttribute("complete", () => {
            if (value) {
                this.element.setAttribute("complete", "");
            }
            else {
                this.element.removeAttribute("complete");
            }
        });
    }
    get isActive() {
        return this.element.isActive && this.connected;
    }
    get rootLocation() {
        var _a;
        const meta = this.element.ownerDocument.querySelector(`meta[name="turbo-root"]`);
        const root = (_a = meta === null || meta === void 0 ? void 0 : meta.content) !== null && _a !== void 0 ? _a : "/";
        return expandURL(root);
    }
    isIgnoringChangesTo(attributeName) {
        return this.ignoredAttributes.has(attributeName);
    }
    ignoringChangesToAttribute(attributeName, callback) {
        this.ignoredAttributes.add(attributeName);
        callback();
        this.ignoredAttributes.delete(attributeName);
    }
    withCurrentNavigationElement(element, callback) {
        this.currentNavigationElement = element;
        callback();
        delete this.currentNavigationElement;
    }
}
function getFrameElementById(id) {
    if (id != null) {
        const element = document.getElementById(id);
        if (element instanceof FrameElement) {
            return element;
        }
    }
}
function activateElement(element, currentURL) {
    if (element) {
        const src = element.getAttribute("src");
        if (src != null && currentURL != null && urlsAreEqual(src, currentURL)) {
            throw new Error(`Matching <turbo-frame id="${element.id}"> element has a source URL which references itself`);
        }
        if (element.ownerDocument !== document) {
            element = document.importNode(element, true);
        }
        if (element instanceof FrameElement) {
            element.connectedCallback();
            element.disconnectedCallback();
            return element;
        }
    }
}

class StreamElement extends HTMLElement {
    static async renderElement(newElement) {
        await newElement.performAction();
    }
    async connectedCallback() {
        try {
            await this.render();
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.disconnect();
        }
    }
    async render() {
        var _a;
        return ((_a = this.renderPromise) !== null && _a !== void 0 ? _a : (this.renderPromise = (async () => {
            const event = this.beforeRenderEvent;
            if (this.dispatchEvent(event)) {
                await nextAnimationFrame();
                await event.detail.render(this);
            }
        })()));
    }
    disconnect() {
        try {
            this.remove();
        }
        catch (_a) { }
    }
    removeDuplicateTargetChildren() {
        this.duplicateChildren.forEach((c) => c.remove());
    }
    get duplicateChildren() {
        var _a;
        const existingChildren = this.targetElements.flatMap((e) => [...e.children]).filter((c) => !!c.id);
        const newChildrenIds = [...(((_a = this.templateContent) === null || _a === void 0 ? void 0 : _a.children) || [])].filter((c) => !!c.id).map((c) => c.id);
        return existingChildren.filter((c) => newChildrenIds.includes(c.id));
    }
    get performAction() {
        if (this.action) {
            const actionFunction = StreamActions[this.action];
            if (actionFunction) {
                return actionFunction;
            }
            this.raise("unknown action");
        }
        this.raise("action attribute is missing");
    }
    get targetElements() {
        if (this.target) {
            return this.targetElementsById;
        }
        else if (this.targets) {
            return this.targetElementsByQuery;
        }
        else {
            this.raise("target or targets attribute is missing");
        }
    }
    get templateContent() {
        return this.templateElement.content.cloneNode(true);
    }
    get templateElement() {
        if (this.firstElementChild === null) {
            const template = this.ownerDocument.createElement("template");
            this.appendChild(template);
            return template;
        }
        else if (this.firstElementChild instanceof HTMLTemplateElement) {
            return this.firstElementChild;
        }
        this.raise("first child element must be a <template> element");
    }
    get action() {
        return this.getAttribute("action");
    }
    get target() {
        return this.getAttribute("target");
    }
    get targets() {
        return this.getAttribute("targets");
    }
    raise(message) {
        throw new Error(`${this.description}: ${message}`);
    }
    get description() {
        var _a, _b;
        return (_b = ((_a = this.outerHTML.match(/<[^>]+>/)) !== null && _a !== void 0 ? _a : [])[0]) !== null && _b !== void 0 ? _b : "<turbo-stream>";
    }
    get beforeRenderEvent() {
        return new CustomEvent("turbo:before-stream-render", {
            bubbles: true,
            cancelable: true,
            detail: { newStream: this, render: StreamElement.renderElement },
        });
    }
    get targetElementsById() {
        var _a;
        const element = (_a = this.ownerDocument) === null || _a === void 0 ? void 0 : _a.getElementById(this.target);
        if (element !== null) {
            return [element];
        }
        else {
            return [];
        }
    }
    get targetElementsByQuery() {
        var _a;
        const elements = (_a = this.ownerDocument) === null || _a === void 0 ? void 0 : _a.querySelectorAll(this.targets);
        if (elements.length !== 0) {
            return Array.prototype.slice.call(elements);
        }
        else {
            return [];
        }
    }
}

class StreamSourceElement extends HTMLElement {
    constructor() {
        super(...arguments);
        this.streamSource = null;
    }
    connectedCallback() {
        this.streamSource = this.src.match(/^ws{1,2}:/) ? new WebSocket(this.src) : new EventSource(this.src);
        connectStreamSource(this.streamSource);
    }
    disconnectedCallback() {
        if (this.streamSource) {
            disconnectStreamSource(this.streamSource);
        }
    }
    get src() {
        return this.getAttribute("src") || "";
    }
}

FrameElement.delegateConstructor = FrameController;
if (customElements.get("turbo-frame") === undefined) {
    customElements.define("turbo-frame", FrameElement);
}
if (customElements.get("turbo-stream") === undefined) {
    customElements.define("turbo-stream", StreamElement);
}
if (customElements.get("turbo-stream-source") === undefined) {
    customElements.define("turbo-stream-source", StreamSourceElement);
}

(() => {
    let element = document.currentScript;
    if (!element)
        return;
    if (element.hasAttribute("data-turbo-suppress-warning"))
        return;
    element = element.parentElement;
    while (element) {
        if (element == document.body) {
            return console.warn(unindent `
        You are loading Turbo from a <script> element inside the <body> element. This is probably not what you meant to do!

        Load your application’s JavaScript bundle inside the <head> element instead. <script> elements in <body> are evaluated with each page change.

        For more information, see: https://turbo.hotwired.dev/handbook/building#working-with-script-elements

        ——
        Suppress this warning by adding a "data-turbo-suppress-warning" attribute to: %s
      `, element.outerHTML);
        }
        element = element.parentElement;
    }
})();

window.Turbo = Turbo;
start();



// EXTERNAL MODULE: ./node_modules/shopify-api-js/lib/ShopifyFrontendHelper.js
var ShopifyFrontendHelper = __webpack_require__(9116);
;// CONCATENATED MODULE: ./js/libs.js


window.shopifyFrontendHelper = new ShopifyFrontendHelper/* default */.c();
;// CONCATENATED MODULE: ./js/utils/mega-menu.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MegaMenu = function () {
  function MegaMenu() {
    _classCallCheck(this, MegaMenu);
    this.selectors = {
      wrapper: "#mana-mega-menu-container",
      content: ".mana-mega-menu-content",
      linksWrapper: ".site-nav, .site-nav__icons",
      link: ".mega-menu-anchor",
      body: ".mana-mega-menu-body",
      drawer: "#NavDrawer",
      drawerCloseButton: ".js-drawer-close",
      drawerOpenButton: ".site-nav__link--burger",
      drawerClasses: ['js-drawer-open', 'drawer--right', 'drawer--has-fixed-footer'],
      drawerClassesForBody: ['js-drawer-open', 'js-drawer-open-right']
    };
    this._open = false;
    this.timer;
    this.links;
    this.events = [];
  }
  _createClass(MegaMenu, [{
    key: "init",
    value: function init() {
      var self = this;
      var closeMenuButton = document.querySelector(this.selectors.drawer + ' ' + this.selectors.drawerCloseButton);
      if (closeMenuButton && !closeMenuButton.hasAttribute('data-event-listener-set')) {
        closeMenuButton.addEventListener("click", function () {
          self.toggleMenu(false);
        });
        closeMenuButton.setAttribute('data-event-listener-set', 'true');
      }
      var openMenuButton = document.querySelector(this.selectors.drawerOpenButton);
      if (openMenuButton && !openMenuButton.hasAttribute('data-event-listener-set')) {
        openMenuButton.addEventListener("click", function () {
          self.toggleMenu();
        });
        openMenuButton.setAttribute('data-event-listener-set', 'true');
      }
      var toggleBtns = document.querySelectorAll(".mobile-nav__toggle-btn");
      toggleBtns.forEach(function (button) {
        button.setAttribute("aria-expanded", "false");
        button.setAttribute("aria-controls", button.getAttribute("data-aria-controls"));
      });
      toggleBtns.forEach(function (button) {
        if (!button.hasAttribute('data-event-listener-set')) {
          button.addEventListener("click", function () {
            var currentlyExpanded = button.getAttribute("aria-expanded");
            var toggleState = false;
            if (currentlyExpanded === "true") {
              button.setAttribute("aria-expanded", "false");
            } else {
              button.setAttribute("aria-expanded", "true");
              toggleState = true;
            }
            var parent = button.closest(".mobile-nav__has-sublist");
            parent.classList.toggle("mobile-nav--expanded", toggleState);
            $(parent.nextElementSibling).slideToggle();
          });
          button.setAttribute('data-event-listener-set', 'true');
        }
      });
      var content = $(this.selectors.wrapper).find(this.selectors.content);
      this.links = $(this.selectors.link);
      content.each(function () {
        var element = $(this);
        var handle = element.data("megaContentFor");
        $(handle).removeClass("mega-menu-anchor");
        if (handle != '#mega-menu-ShippingCountriesModal') {
          $(handle).bind("mouseenter", function () {
            self.clean();
            content.removeClass("mega-show");
            element.addClass("mega-show");
            $(this).addClass("active");
            self.open();
          });
        } else {
          document.querySelector(handle).addEventListener("click", function () {
            if ($(this).hasClass("active")) {
              self.close();
            } else {
              self.clean();
              content.removeClass("mega-show");
              element.addClass("mega-show");
              $(this).addClass("active");
              self.open();
            }
          });
          document.addEventListener('click', function (event) {
            if (self._open) {
              if (document.querySelector('[data-mega-content-for="#mega-menu-ShippingCountriesModal"]').classList.contains("mega-show")) {
                var shippingCountriesModal = document.querySelector('[data-mega-content-for="#mega-menu-ShippingCountriesModal"] .mana-mega-menu-body');
                var flagSelector = document.querySelector('.site-nav__item.site-nav__item--flag .flag-selector--toggle-modal');
                var clickedElement = event.target;
                if (!(shippingCountriesModal.contains(clickedElement) || flagSelector.contains(clickedElement))) {
                  self.close();
                }
              }
            }
          });
        }
        self.events.push($(handle));
      });
      $(this.selectors.link).each(function () {
        $(this).bind("mouseenter", function () {
          self.close();
        });
        self.events.push($(this));
      });
      var outSelectors = [this.selectors.body, this.selectors.linksWrapper].join(",");
      $(outSelectors).bind("mouseleave", function () {
        if (!$('#mega-menu-ShippingCountriesModal').hasClass('active')) {
          self.timer = setTimeout(self.close.bind(self), 10);
        }
      }).bind("mouseenter", function () {
        clearTimeout(self.timer);
      });
      self.events.push($(outSelectors));
    }
  }, {
    key: "clean",
    value: function clean() {
      this.links.removeClass("active");
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.events.forEach(function (event) {
        event.unbind();
      });
      this.events = [];
    }
  }, {
    key: "open",
    value: function open() {
      if (this._open) {
        return;
      }
      $(this.selectors.wrapper).addClass("mega-show");
      if (document.getElementById('blog-header') != null) {
        document.getElementById('blog-header').style.display = "none";
      }
      this._open = true;
    }
  }, {
    key: "close",
    value: function close() {
      if (!this._open) {
        return;
      }
      this.clean();
      $(this.selectors.wrapper).removeClass("mega-show");
      if (document.getElementById('blog-header') != null) {
        document.getElementById('blog-header').style.display = "block";
      }
      this._open = false;
    }
  }, {
    key: "toggleMenu",
    value: function toggleMenu() {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var navElement = document.querySelector(this.selectors.drawer);
      var bodyElement = document.querySelector('body');
      if (navElement) {
        if (show) {
          var _navElement$classList, _bodyElement$classLis;
          (_navElement$classList = navElement.classList).add.apply(_navElement$classList, _toConsumableArray(this.selectors.drawerClasses));
          (_bodyElement$classLis = bodyElement.classList).add.apply(_bodyElement$classLis, _toConsumableArray(this.selectors.drawerClassesForBody));
        } else {
          var _navElement$classList2, _bodyElement$classLis2;
          (_navElement$classList2 = navElement.classList).remove.apply(_navElement$classList2, _toConsumableArray(this.selectors.drawerClasses));
          (_bodyElement$classLis2 = bodyElement.classList).remove.apply(_bodyElement$classLis2, _toConsumableArray(this.selectors.drawerClassesForBody));
        }
      }
      return false;
    }
  }]);
  return MegaMenu;
}();
;// CONCATENATED MODULE: ./js/utils/flag-selector.js
function flag_selector_typeof(o) { "@babel/helpers - typeof"; return flag_selector_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, flag_selector_typeof(o); }
function flag_selector_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function flag_selector_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, flag_selector_toPropertyKey(descriptor.key), descriptor); } }
function flag_selector_createClass(Constructor, protoProps, staticProps) { if (protoProps) flag_selector_defineProperties(Constructor.prototype, protoProps); if (staticProps) flag_selector_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function flag_selector_toPropertyKey(t) { var i = flag_selector_toPrimitive(t, "string"); return "symbol" == flag_selector_typeof(i) ? i : String(i); }
function flag_selector_toPrimitive(t, r) { if ("object" != flag_selector_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != flag_selector_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FlagSelector = function () {
  function FlagSelector() {
    flag_selector_classCallCheck(this, FlagSelector);
    this.selectors = {
      toggleTextButton: '.flag-selector--toggle-text-modal',
      footerTextButton: '.footerFlag-selector--toggle-modal',
      toggleButton: '.flag-selector--toggle-modal',
      flagButton: '.flag-selector--btn'
    };
  }
  flag_selector_createClass(FlagSelector, [{
    key: "init",
    value: function init() {
      var queryStringForFlag = window.location.search;
      var urlParamsForFlag = new URLSearchParams(queryStringForFlag);
      var lang = urlParamsForFlag.get('lang');
      var self = this;
      if (lang !== null) {
        lang = lang.toUpperCase();
        window.sga.manaSetCookie("manaLang", lang, 7);
        sessionStorage.setItem('myShippingCountry', lang);
        window.history.replaceState(null, null, window.location.pathname);
      }
      $("".concat(self.selectors.toggleTextButton, ", ").concat(self.selectors.footerTextButton)).magnificPopup({
        type: 'inline',
        mainClass: 'mfp-fade',
        closeOnBgClick: true,
        closeBtnInside: false,
        closeOnContentClick: false,
        closeMarkup: '<button title="%title%" type="button" class="icon icon-fallback-text drawer__close js-drawer-close mfp-close"><svg xmlns="http://www.w3.org/2000/svg" style="enable-background:new 0 0 24 24" xml:space="preserve" width="24" height="24"><path d="M0 0h24v24H0V0z" style="fill:none"></path><path d="m4102.4 3320.9-6.9-6.9c-.2-.2-.7-.2-.9 0-.2.2-.2.7 0 .9l6.9 6.9-6.9 6.9c-.2.2-.2.7 0 .9.2.2.7.2.9 0l6.9-6.9 6.9 6.9c.2.2.6.2.9 0 .2-.2.2-.7 0-.9l-6.9-6.9 6.9-6.9c.2-.2.2-.7 0-.9-.3-.2-.7-.2-.9 0l-6.9 6.9z" style="fill-rule:evenodd;clip-rule:evenodd" transform="matrix(1 0 0 1 -4090.423 -3309.776)"></path></svg></button>',
        alignTop: true,
        removalDelay: 500,
        focus: '.flag-selector--btn'
      });
      var modal = $.magnificPopup.instance;
      function isEuropeanStoreHost() {
        var hostname = window.location.hostname.replace(/^www\./, '');
        return hostname === 'drink-mana.com' || hostname === 'drinkmana.eu' || hostname === 'drink-mana.eu';
      }
      function getHostCountryCode() {
        var hostname = window.location.hostname.replace(/^www\./, '');
        var hostCountryMap = {
          'drink-mana.at': 'AT',
          'mojemana.cz': 'CZ',
          'drink-mana.de': 'DE',
          'drink-mana.ch': 'CH',
          'mojamana.sk': 'SK',
          'drinkmana.co.uk': 'GB',
          'drink-mana.co.uk': 'GB',
          'drinkmana.com': 'US'
        };
        return hostCountryMap[hostname] || '';
      }
      function getLanguageCountryCode() {
        var languageCountryMap = {
          en: 'EU',
          es: 'ES',
          fr: 'FR',
          it: 'IT',
          nl: 'NL',
          pl: 'PL'
        };
        var pathLanguage = (window.location.pathname.split('/').filter(Boolean)[0] || '').split('-')[0].toLowerCase();
        var htmlLanguage = (document.documentElement.lang || '').split('-')[0].toLowerCase();
        var weglotLanguage = '';
        if (window.Weglot && typeof window.Weglot.getCurrentLang === 'function') {
          weglotLanguage = (window.Weglot.getCurrentLang() || '').split('-')[0].toLowerCase();
        }
        return languageCountryMap[pathLanguage] || languageCountryMap[htmlLanguage] || languageCountryMap[weglotLanguage] || '';
      }
      function setToggleButtonFlag(countryCode) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cookieLang = window.sga.manaGetCookie("manaLang");
        if (cookieLang !== null && options.ignoreCookie !== true) countryCode = cookieLang;
        $(self.selectors.flagButton).removeClass('flag-selector--btn--active');
        document.querySelectorAll(self.selectors.toggleTextButton).forEach(function (element) {
          if (countryCode in window.flagSelector.assets) {
            if (element.getElementsByTagName('img').length > 0) {
              element.removeChild(element.childNodes[0]);
            }
            var elem = document.createElement("img");
            elem.src = window.flagSelector.assets[countryCode];
            element.appendChild(elem);
            $(self.selectors.flagButton + '[data-lang="' + countryCode + '"]').addClass('flag-selector--btn--active');
            return;
          }
          console.error('flag-selector: Invalid countryCode:', countryCode);
        });
        document.querySelectorAll(self.selectors.toggleButton).forEach(function (element) {
          var imageElements = element.getElementsByTagName('img');
          if (countryCode in window.flagSelector.assets) {
            imageElements[0].setAttribute('src', window.flagSelector.assets[countryCode]);
            return;
          }
          console.error('flag-selector: Invalid countryCode:', countryCode);
        });
        document.querySelectorAll(self.selectors.footerTextButton).forEach(function (element) {
          if (countryCode in window.flagSelector.translations) {
            element.innerHTML = window.flagSelector.translations[countryCode];
            return;
          }
          console.error('flag-selector: Invalid countryCode:', countryCode);
        });
      }
      function registerEventListeners() {
        document.querySelectorAll(self.selectors.flagButton).forEach(function (element) {
          element.addEventListener("click", function (evt) {
            var countryCode = this.getAttribute("country-code");
            var languageCode = this.getAttribute("data-language-code");
            var dataLang = this.getAttribute("data-lang");
            var href = this.getAttribute("href");
            if (this.classList.contains('flag-selector--btn--active')) {
              evt.preventDefault();
              modal.close();
              return;
            }
            if (languageCode && isExternalLink(href) === false) {
              lang = dataLang;
              window.sga.manaSetCookie("manaLang", lang, 7);
              sessionStorage.setItem('myShippingCountry', lang);
              setToggleButtonFlag(lang);
              modal.close();
              evt.preventDefault();
              try {
                window.localStorage.setItem('manaLanguagePromptClosed', 'true');
              } catch (error) {}
              if (window.manaLanguagePickerUpdateUrl) {
                window.manaLanguagePickerUpdateUrl(languageCode);
              }
            } else if (isExternalLink(href) === false) {
              lang = dataLang;
              window.sga.manaSetCookie("manaLang", lang, 7);
              sessionStorage.setItem('myShippingCountry', lang);
              setToggleButtonFlag(lang);
              modal.close();
              console.log(modal);
              evt.preventDefault();
            } else if (countryCode || dataLang) {
              setToggleButtonFlag(countryCode || dataLang);
              modal.close();
              sessionStorage.setItem('myShippingCountry', countryCode || dataLang);
              if (languageCode) {
                try {
                  window.localStorage.setItem('manaLanguagePromptClosed', 'true');
                } catch (error) {}
              }
            }
          });
        });
      }
      function detectCountryCode() {
        var languageCountryCode = isEuropeanStoreHost() ? getLanguageCountryCode() : '';
        if (languageCountryCode && languageCountryCode in window.flagSelector.assets) {
          setToggleButtonFlag(languageCountryCode, {
            ignoreCookie: true
          });
          return;
        }
        var hostCountryCode = getHostCountryCode();
        if (hostCountryCode && hostCountryCode in window.flagSelector.assets) {
          setToggleButtonFlag(hostCountryCode, {
            ignoreCookie: true
          });
          return;
        }
        var countryCode = sessionStorage.getItem('myShippingCountry');
        if (countryCode && countryCode in window.flagSelector.assets) {
          setToggleButtonFlag(countryCode);
          return;
        }
        setToggleButtonFlag(window.flagSelector.defaultCountryCode);
      }
      function setupToggleModalButtons() {
        document.querySelectorAll(self.selectors.toggleButton).forEach(function (element) {
          element.appendChild(document.createElement('img'));
        });
      }
      function isExternalLink(url) {
        var tmp = document.createElement('a');
        tmp.href = url;
        return tmp.host !== window.location.host;
      }
      ;
      setupToggleModalButtons();
      detectCountryCode();
      registerEventListeners();
    }
  }]);
  return FlagSelector;
}();
;// CONCATENATED MODULE: ./js/utils/index.js
function utils_typeof(o) { "@babel/helpers - typeof"; return utils_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, utils_typeof(o); }
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == utils_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(utils_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = utils_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function utils_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return utils_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return utils_arrayLikeToArray(o, minLen); }
function utils_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }


window.loginForms = function () {
  var $recoverPasswordLink = $("#RecoverPassword");
  var $hideRecoverPasswordLink = $("#HideRecoverPasswordLink");
  var $recoverPasswordForm = $("#RecoverPasswordForm");
  var $customerLoginForm = $("#CustomerLoginForm");
  function showRecoverPasswordForm() {
    $recoverPasswordForm.show();
    $customerLoginForm.hide();
  }
  function hideRecoverPasswordForm() {
    $recoverPasswordForm.hide();
    $customerLoginForm.show();
  }
  $recoverPasswordLink.on("click", function (evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });
  $hideRecoverPasswordLink.on("click", function (evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });
  if (window.location.hash === "#recover") {
    showRecoverPasswordForm();
  }
};
window.resetPasswordSuccess = function () {
  $("#ResetSuccess").show();
};
window.registerMaySubscribeTabs = function () {
  var tabs = document.querySelectorAll('.tab-subscription-onetime, .tab-subscription-autodeliver');
  var _iterator = _createForOfIteratorHelper(tabs),
    _step;
  try {
    var _loop = function _loop() {
      var tab = _step.value;
      tab.addEventListener('click', function () {
        var form = tab.closest('form');
        if (form) {
          form.classList.remove('setForm');
          var inputs = form.querySelectorAll('input[name="selling_plan"], input[name^="properties"]');
          inputs.forEach(function (input) {
            input.remove();
          });
          var autodelivery = false;
          if (tab.classList.contains('tab-subscription-autodeliver')) {
            autodelivery = true;
          }
          window.setProductProperties([form], autodelivery);
        }
      });
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
window.setProductProperties = function () {
  var forms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var autodelivery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!forms) {
    forms = document.querySelectorAll('form[action="/cart/add"]');
  }
  var _iterator2 = _createForOfIteratorHelper(forms),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var form = _step2.value;
      if (!form.classList.contains('setForm')) {
        var productId = form.getAttribute('data-productid');
        if (productId) {
          if (manaProductsProperties[productId] !== undefined) {
            var withSellingPlan = form.querySelector('.tab-subscription-autodeliver[data-pf-tab-active="true"]');
            if (autodelivery || withSellingPlan && autodelivery == null) {
              if (manaProductsProperties[productId].sellingPlans.length) {
                form.insertAdjacentHTML('beforeend', '<input name="selling_plan" type="hidden" value="' + manaProductsProperties[productId].sellingPlans[0] + '" />');
                form.insertAdjacentHTML('beforeend', '<input name="properties[_subscription]" type="hidden" value="true" />');
              }
            }
            if (manaProductsProperties[productId].discount) {
              form.insertAdjacentHTML('beforeend', '<input name="properties[_discount_per_one]" type="hidden" value="' + manaProductsProperties[productId].discount + '" />');
              form.insertAdjacentHTML('beforeend', '<input name="properties[_hmac]" type="hidden" value="' + manaProductsProperties[productId].hmac + '" />');
              form.insertAdjacentHTML('beforeend', '<input name="properties[_timestamp]" type="hidden" value="' + manaProductsProperties[productId].timestamp + '" />');
            }
          }
        }
        form.classList.add('setForm');
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var pfATCs = $("#__pf").find('[data-pf-type="ProductATC"]');
  pfATCs.click(function (e) {
    var checkoutAction = e.currentTarget.getAttribute("data-checkout");
    if (checkoutAction === "same" && window.__pagefly_helper_store__) {
      window.__pagefly_helper_store__.subscribe(function () {
        setTimeout(function () {
          window.cartDrawerElement.toggleCart();
        }, 1000);
      });
    }
  });
};
$().ready(function () {
  var menu = new MegaMenu();
  menu.init();
  window.loginForms();
  window.setProductProperties();
  window.registerMaySubscribeTabs();
  var flagSelector = new FlagSelector();
  flagSelector.init();
  $(document).on("shopify:section:select", function (e) {
    if (e.detail.sectionId === "header") {
      return;
    }
    var $parentSection = $("#shopify-section-" + e.detail.sectionId);
    var $megaMenuContent = $parentSection.find(".mega-menu-content");
    if ($megaMenuContent.size() > 0) {
      $("html, body").delay(200).animate({
        scrollTop: 80
      }, "slow");
      var selector = $megaMenuContent.data("mega-content-for");
      $(selector).mouseover();
    }
  }).on("shopify:section:load", function (e) {
    var $parentSection = $("#shopify-section-" + e.detail.sectionId);
    if ($parentSection.find(".mega-menu-content").size() > 0) {
      menu.destroy();
      menu.init();
    }
  }).on("shopify:section:deselect", function (e) {
    if (e.detail.sectionId === "header") {
      return;
    }
    var $parentSection = $("#shopify-section-" + e.detail.sectionId);
    var $megaMenuContent = $parentSection.find(".mega-menu-content");
    if ($megaMenuContent.size() > 0) {
      var selector = $megaMenuContent.data("mega-content-for");
      $(selector).mouseout();
    }
  });
});
function updateManaCartCount() {
  return _updateManaCartCount.apply(this, arguments);
}
function _updateManaCartCount() {
  _updateManaCartCount = _asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
    var response, cart, cartBubble;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch('/cart.js');
        case 3:
          response = _context.sent;
          _context.next = 6;
          return response.json();
        case 6:
          cart = _context.sent;
          cartBubble = document.querySelectorAll('.cart-link__bubble');
          if (cart.item_count) {
            _context.next = 11;
            break;
          }
          cartBubble.forEach(function (el) {
            el.classList.remove('cart-link__bubble--visible');
          });
          return _context.abrupt("return");
        case 11:
          cartBubble.forEach(function (el) {
            el.classList.add('cart-link__bubble--visible');
          });
          _context.next = 17;
          break;
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](0);
          console.log(_context.t0);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 14]]);
  }));
  return _updateManaCartCount.apply(this, arguments);
}
window.fetch = new Proxy(window.fetch, {
  apply: function apply(fetch, that, args) {
    var url = args[0];
    var cartUrls = ["/cart/add.js", "/cart/update.js", "/cart/change.js", "/cart/clear.js"];
    if (cartUrls.includes(url)) {
      var result = fetch.apply(that, args);
      result.then(function (response) {
        updateManaCartCount();
        window.saveCustomerCart();
      });
      return result;
    } else {
      return fetch.apply(that, args);
    }
  }
});
window.onChatClick = function () {
  try {
    var _window;
    (_window = window) === null || _window === void 0 || (_window = _window.GorgiasChat) === null || _window === void 0 || _window.open();
    window.cartDrawerElement.toggleCart(false);
  } catch (e) {
    console.warn("manaCart: ".concat(e === null || e === void 0 ? void 0 : e.message));
  }
};
document.addEventListener("turbo:load", function () {
  var menu = new MegaMenu();
  menu.init();
  var flagSelector = new FlagSelector();
  flagSelector.init();
  window.loginForms();
  window.setProductProperties();
  window.registerMaySubscribeTabs();
});
document.addEventListener("turbo:click", function (e) {
  if (e.detail.url.includes("/products/") || e.detail.url.includes("/collections/") || e.detail.url.includes("/pages/picknmix") || e.detail.url.includes("/pages/mana-recipes") || e.detail.url.includes("/pages/why-mana") || e.detail.url.includes("/pages/faq") || e.detail.url.includes("/pages/reviews")) {
    e.preventDefault();
    return false;
  }
});
// EXTERNAL MODULE: ./js/utils/product-purchase.js
var product_purchase = __webpack_require__(2012);
// EXTERNAL MODULE: ./js/utils/cookies.js
var cookies = __webpack_require__(4020);
// EXTERNAL MODULE: ./js/utils/initTiles.js
var initTiles = __webpack_require__(7996);
// EXTERNAL MODULE: ./js/utils/payment-methods.js
var payment_methods = __webpack_require__(5132);
// EXTERNAL MODULE: ./js/utils/restore-cart.js
var restore_cart = __webpack_require__(7496);
// EXTERNAL MODULE: ./js/globals.js
var globals = __webpack_require__(5160);
;// CONCATENATED MODULE: ./js/theme.js









window.theme = window.theme || {};
window.slate = window.slate || {};
}();
/******/ })()
;